(function () {

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire761b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire761b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gnS5A", function(module, exports) {

$parcel$export(module.exports, "rotation", function () { return ye; });

var $6qd2L = parcelRequire("6qd2L");

var $3aNd6 = parcelRequire("3aNd6");
var $49decdd7c8e65498$require$Buffer = $3aNd6.Buffer;
function e(e, t, s) {
    return t in e ? Object.defineProperty(e, t, {
        value: s,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = s, e;
}
var t = "undefined" != typeof self ? self : $parcel$global;
const s = "undefined" != typeof navigator, i = s && "undefined" == typeof HTMLImageElement, n = !("undefined" == typeof $parcel$global || "undefined" == typeof $6qd2L || !$6qd2L.versions || !$6qd2L.versions.node), r = t.Buffer, a = !!r, h = (e)=>void 0 !== e;
function f(e) {
    return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(h).length);
}
function l(e) {
    let t = new Error(e);
    throw delete t.stack, t;
}
function o(e) {
    let t = function(e) {
        let t = 0;
        return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
    }(e);
    return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
}
const u = (e)=>String.fromCharCode.apply(null, e), d = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
class c {
    static from(e, t) {
        return e instanceof this && e.le === t ? e : new c(e, void 0, void 0, t);
    }
    constructor(e, t = 0, s, i){
        if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
        else if (e instanceof ArrayBuffer) {
            void 0 === s && (s = e.byteLength - t);
            let i = new DataView(e, t, s);
            this._swapDataView(i);
        } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof c) {
            void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && l("Creating view outside of available memory in ArrayBuffer");
            let i = new DataView(e.buffer, t, s);
            this._swapDataView(i);
        } else if ("number" == typeof e) {
            let t = new DataView(new ArrayBuffer(e));
            this._swapDataView(t);
        } else l("Invalid input argument for BufferView: " + e);
    }
    _swapArrayBuffer(e) {
        this._swapDataView(new DataView(e));
    }
    _swapBuffer(e) {
        this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
    }
    _swapDataView(e) {
        this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
    }
    _lengthToEnd(e) {
        return this.byteLength - e;
    }
    set(e, t, s = c) {
        return e instanceof DataView || e instanceof c ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || l("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
    }
    subarray(e, t) {
        return t = t || this._lengthToEnd(e), new c(this, e, t);
    }
    toUint8() {
        return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
    }
    getUint8Array(e, t) {
        return new Uint8Array(this.buffer, this.byteOffset + e, t);
    }
    getString(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        var i;
        return i = s, d ? d.decode(i) : a ? $49decdd7c8e65498$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(u(i)));
    }
    getLatin1String(e = 0, t = this.byteLength) {
        let s = this.getUint8Array(e, t);
        return u(s);
    }
    getUnicodeString(e = 0, t = this.byteLength) {
        const s = [];
        for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
        return u(s);
    }
    getInt8(e) {
        return this.dataView.getInt8(e);
    }
    getUint8(e) {
        return this.dataView.getUint8(e);
    }
    getInt16(e, t = this.le) {
        return this.dataView.getInt16(e, t);
    }
    getInt32(e, t = this.le) {
        return this.dataView.getInt32(e, t);
    }
    getUint16(e, t = this.le) {
        return this.dataView.getUint16(e, t);
    }
    getUint32(e, t = this.le) {
        return this.dataView.getUint32(e, t);
    }
    getFloat32(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getFloat64(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getFloat(e, t = this.le) {
        return this.dataView.getFloat32(e, t);
    }
    getDouble(e, t = this.le) {
        return this.dataView.getFloat64(e, t);
    }
    getUintBytes(e, t, s) {
        switch(t){
            case 1:
                return this.getUint8(e, s);
            case 2:
                return this.getUint16(e, s);
            case 4:
                return this.getUint32(e, s);
            case 8:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    getUint(e, t, s) {
        switch(t){
            case 8:
                return this.getUint8(e, s);
            case 16:
                return this.getUint16(e, s);
            case 32:
                return this.getUint32(e, s);
            case 64:
                return this.getUint64 && this.getUint64(e, s);
        }
    }
    toString(e) {
        return this.dataView.toString(e, this.constructor.name);
    }
    ensureChunk() {}
}
function p(e, t) {
    l(`${e} '${t}' was not loaded, try using full build of exifr.`);
}
class g extends Map {
    constructor(e){
        super(), this.kind = e;
    }
    get(e, t) {
        return this.has(e) || p(this.kind, e), t && (e in t || function(e, t) {
            l(`Unknown ${e} '${t}'.`);
        }(this.kind, e), t[e].enabled || p(this.kind, e)), super.get(e);
    }
    keyList() {
        return Array.from(this.keys());
    }
}
var m = new g("file parser"), y = new g("segment parser"), b = new g("file reader");
let w = t.fetch;
function k(e, t) {
    var i;
    return (i = e).startsWith("data:") || i.length > 1e4 ? v(e, t, "base64") : n && e.includes("://") ? O(e, t, "url", S) : n ? v(e, t, "fs") : s ? O(e, t, "url", S) : void l("Invalid input argument");
}
async function O(e, t, s, i) {
    return b.has(s) ? v(e, t, s) : i ? async function(e, t) {
        let s = await t(e);
        return new c(s);
    }(e, i) : void l(`Parser ${s} is not loaded`);
}
async function v(e, t, s) {
    let i = new (b.get(s))(e, t);
    return await i.read(), i;
}
const S = (e)=>w(e).then((e)=>e.arrayBuffer()), A = (e)=>new Promise((t, s)=>{
        let i = new FileReader;
        i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
    });
class U extends Map {
    get tagKeys() {
        return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
    }
    get tagValues() {
        return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
    }
}
function x(e, t, s) {
    let i = new U;
    for (let [e, t] of s)i.set(e, t);
    if (Array.isArray(t)) for (let s of t)e.set(s, i);
    else e.set(t, i);
    return i;
}
function C(e, t, s) {
    let i, n = e.get(t);
    for (i of s)n.set(i[0], i[1]);
}
const B = new Map, V = new Map, I = new Map, L = [
    "chunked",
    "firstChunkSize",
    "firstChunkSizeNode",
    "firstChunkSizeBrowser",
    "chunkSize",
    "chunkLimit"
], T = [
    "jfif",
    "xmp",
    "icc",
    "iptc",
    "ihdr"
], z = [
    "tiff",
    ...T
], P = [
    "ifd0",
    "ifd1",
    "exif",
    "gps",
    "interop"
], F = [
    ...z,
    ...P
], j = [
    "makerNote",
    "userComment"
], E = [
    "translateKeys",
    "translateValues",
    "reviveValues",
    "multiSegment"
], M = [
    ...E,
    "sanitize",
    "mergeOutput",
    "silentErrors"
];
class _ {
    get translate() {
        return this.translateKeys || this.translateValues || this.reviveValues;
    }
}
class D extends _ {
    get needed() {
        return this.enabled || this.deps.size > 0;
    }
    constructor(t, s, i, n){
        if (super(), e(this, "enabled", !1), e(this, "skip", new Set), e(this, "pick", new Set), e(this, "deps", new Set), e(this, "translateKeys", !1), e(this, "translateValues", !1), e(this, "reviveValues", !1), this.key = t, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = P.includes(t), this.canBeFiltered && (this.dict = B.get(t)), void 0 !== i) {
            if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
            else if ("object" == typeof i) {
                if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                    let { pick: e, skip: t } = i;
                    e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                }
                this.applyInheritables(i);
            } else !0 === i || !1 === i ? this.parse = this.enabled = i : l(`Invalid options argument: ${i}`);
        }
    }
    applyInheritables(e) {
        let t, s;
        for (t of E)s = e[t], void 0 !== s && (this[t] = s);
    }
    translateTagSet(e, t) {
        if (this.dict) {
            let s, i, { tagKeys: n, tagValues: r } = this.dict;
            for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
        } else for (let s of e)t.add(s);
    }
    finalizeFilters() {
        !this.enabled && this.deps.size > 0 ? (this.enabled = !0, X(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && X(this.pick, this.deps);
    }
}
var N = {
    jfif: !1,
    tiff: !0,
    xmp: !1,
    icc: !1,
    iptc: !1,
    ifd0: !0,
    ifd1: !1,
    exif: !0,
    gps: !0,
    interop: !1,
    ihdr: void 0,
    makerNote: !1,
    userComment: !1,
    multiSegment: !1,
    skip: [],
    pick: [],
    translateKeys: !0,
    translateValues: !0,
    reviveValues: !0,
    sanitize: !0,
    mergeOutput: !0,
    silentErrors: !0,
    chunked: !0,
    firstChunkSize: void 0,
    firstChunkSizeNode: 512,
    firstChunkSizeBrowser: 65536,
    chunkSize: 65536,
    chunkLimit: 5
}, $ = new Map;
class R extends _ {
    static useCached(e) {
        let t = $.get(e);
        return void 0 !== t || (t = new this(e), $.set(e, t)), t;
    }
    constructor(e){
        super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : l(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = s ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
    }
    setupFromUndefined() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = N[e];
        for (e of F)this[e] = new D(e, N[e], void 0, this);
    }
    setupFromTrue() {
        let e;
        for (e of L)this[e] = N[e];
        for (e of M)this[e] = N[e];
        for (e of j)this[e] = !0;
        for (e of F)this[e] = new D(e, !0, void 0, this);
    }
    setupFromArray(e) {
        let t;
        for (t of L)this[t] = N[t];
        for (t of M)this[t] = N[t];
        for (t of j)this[t] = N[t];
        for (t of F)this[t] = new D(t, !1, void 0, this);
        this.setupGlobalFilters(e, void 0, P);
    }
    setupFromObject(e) {
        let t;
        for (t of (P.ifd0 = P.ifd0 || P.image, P.ifd1 = P.ifd1 || P.thumbnail, Object.assign(this, e), L))this[t] = W(e[t], N[t]);
        for (t of M)this[t] = W(e[t], N[t]);
        for (t of j)this[t] = W(e[t], N[t]);
        for (t of z)this[t] = new D(t, N[t], e[t], this);
        for (t of P)this[t] = new D(t, N[t], e[t], this.tiff);
        this.setupGlobalFilters(e.pick, e.skip, P, F), !0 === e.tiff ? this.batchEnableWithBool(P, !0) : !1 === e.tiff ? this.batchEnableWithUserValue(P, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, P) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, P);
    }
    batchEnableWithBool(e, t) {
        for (let s of e)this[s].enabled = t;
    }
    batchEnableWithUserValue(e, t) {
        for (let s of e){
            let e = t[s];
            this[s].enabled = !1 !== e && void 0 !== e;
        }
    }
    setupGlobalFilters(e, t, s, i = s) {
        if (e && e.length) {
            for (let e of i)this[e].enabled = !1;
            let t = K(e, s);
            for (let [e, s] of t)X(this[e].pick, s), this[e].enabled = !0;
        } else if (t && t.length) {
            let e = K(t, s);
            for (let [t, s] of e)X(this[t].skip, s);
        }
    }
    filterNestedSegmentTags() {
        let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
        this.makerNote ? t.deps.add(37500) : t.skip.add(37500), this.userComment ? t.deps.add(37510) : t.skip.add(37510), s.enabled || e.skip.add(700), i.enabled || e.skip.add(33723), n.enabled || e.skip.add(34675);
    }
    traverseTiffDependencyTree() {
        let { ifd0: e, exif: t, gps: s, interop: i } = this;
        i.needed && (t.deps.add(40965), e.deps.add(40965)), t.needed && e.deps.add(34665), s.needed && e.deps.add(34853), this.tiff.enabled = P.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
        for (let e of P)this[e].finalizeFilters();
    }
    get onlyTiff() {
        return !T.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
    }
    checkLoadedPlugins() {
        for (let e of z)this[e].enabled && !y.has(e) && p("segment parser", e);
    }
}
function K(e, t) {
    let s, i, n, r, a = [];
    for (n of t){
        for (r of (s = B.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
        i.length && a.push([
            n,
            i
        ]);
    }
    return a;
}
function W(e, t) {
    return void 0 !== e ? e : void 0 !== t ? t : void 0;
}
function X(e, t) {
    for (let s of t)e.add(s);
}
e(R, "default", N);
class H {
    constructor(t){
        e(this, "parsers", {}), e(this, "output", {}), e(this, "errors", []), e(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = R.useCached(t);
    }
    async read(e) {
        this.file = await function(e, t) {
            return "string" == typeof e ? k(e, t) : s && !i && e instanceof HTMLImageElement ? k(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new c(e) : s && e instanceof Blob ? O(e, t, "blob", A) : void l("Invalid input argument");
        }(e, this.options);
    }
    setup() {
        if (this.fileParser) return;
        let { file: e } = this, t = e.getUint16(0);
        for (let [s, i] of m)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
        this.file.close && this.file.close(), l("Unknown file format");
    }
    async parse() {
        let { output: e, errors: t } = this;
        var s;
        return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), f(s = e) ? void 0 : s;
    }
    async executeParsers() {
        let { output: e } = this;
        await this.fileParser.parse();
        let t = Object.values(this.parsers).map(async (t)=>{
            let s = await t.parse();
            t.assignToOutput(e, s);
        });
        this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
    }
    async extractThumbnail() {
        this.setup();
        let { options: e, file: t } = this, s = y.get("tiff", e);
        var i;
        if (t.tiff ? i = {
            start: 0,
            type: "tiff"
        } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
        let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
        return t.close && t.close(), a;
    }
}
async function Y(e, t) {
    let s = new H(t);
    return await s.read(e), s.parse();
}
var G = Object.freeze({
    __proto__: null,
    parse: Y,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R
});
class J {
    static findPosition(e, t) {
        let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
        return {
            offset: t,
            length: s,
            headerLength: i,
            start: n,
            size: r,
            end: n + r
        };
    }
    static parse(e, t = {}) {
        return new this(e, new R({
            [this.type]: t
        }), e).parse();
    }
    normalizeInput(e) {
        return e instanceof c ? e : new c(e);
    }
    constructor(t, s = {}, i){
        e(this, "errors", []), e(this, "raw", new Map), e(this, "handleError", (e)=>{
            if (!this.options.silentErrors) throw e;
            this.errors.push(e.message);
        }), this.chunk = this.normalizeInput(t), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
    }
    translate() {
        this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
    }
    get output() {
        return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
    }
    translateBlock(e, t) {
        let s = I.get(t), i = V.get(t), n = B.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
        for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
        return l;
    }
    translateValue(e, t) {
        return t[e] || t.DEFAULT || e;
    }
    assignToOutput(e, t) {
        this.assignObjectToOutput(e, this.constructor.type, t);
    }
    assignObjectToOutput(e, t, s) {
        if (this.globalOptions.mergeOutput) return Object.assign(e, s);
        e[t] ? Object.assign(e[t], s) : e[t] = s;
    }
}
e(J, "headerLength", 4), e(J, "type", void 0), e(J, "multiSegment", !1), e(J, "canHandle", ()=>!1);
function q(e) {
    return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
}
function Q(e) {
    return e >= 224 && e <= 239;
}
function Z(e, t, s) {
    for (let [i, n] of y)if (n.canHandle(e, t, s)) return i;
}
class ee extends class {
    constructor(t, s, i){
        e(this, "errors", []), e(this, "ensureSegmentChunk", async (e)=>{
            let t = e.start, s = e.size || 65536;
            if (this.file.chunked) {
                if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                else try {
                    e.chunk = await this.file.readChunk(t, s);
                } catch (t) {
                    l(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                }
            } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : l("Segment unreachable: " + JSON.stringify(e));
            return e.chunk;
        }), this.extendOptions && this.extendOptions(t), this.options = t, this.file = s, this.parsers = i;
    }
    injectSegment(e, t) {
        this.options[e].enabled && this.createParser(e, t);
    }
    createParser(e, t) {
        let s = new (y.get(e))(t, this.options, this.file);
        return this.parsers[e] = s;
    }
    createParsers(e) {
        for (let t of e){
            let { type: e, chunk: s } = t, i = this.options[e];
            if (i && i.enabled) {
                let t = this.parsers[e];
                t && t.append || t || this.createParser(e, s);
            }
        }
    }
    async readSegments(e) {
        let t = e.map(this.ensureSegmentChunk);
        await Promise.all(t);
    }
} {
    constructor(...t){
        super(...t), e(this, "appSegments", []), e(this, "jpegSegments", []), e(this, "unknownSegments", []);
    }
    static canHandle(e, t) {
        return 65496 === t;
    }
    async parse() {
        await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
    }
    setupSegmentFinderArgs(e) {
        !0 === e ? (this.findAll = !0, this.wanted = new Set(y.keyList())) : (e = void 0 === e ? y.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && y.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
    }
    async findAppSegments(e = 0, t) {
        this.setupSegmentFinderArgs(t);
        let { file: s, findAll: i, wanted: n, remaining: r } = this;
        if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
            let t = y.get(e), s = this.options[e];
            return t.multiSegment && s.multiSegment;
        }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
            let t = !1;
            for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
            }
        }
    }
    findAppSegmentsInRange(e, t) {
        t -= 2;
        let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
        for(; e < t; e++)if (255 === f.getUint8(e)) {
            if (s = f.getUint8(e + 1), Q(s)) {
                if (i = f.getUint16(e + 2), n = Z(f, e, i), n && o.has(n) && (r = y.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                d.recordUnknownSegments && (a = J.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
            } else if (q(s)) {
                if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                d.recordJpegSegments && this.jpegSegments.push({
                    offset: e,
                    length: i,
                    marker: s
                }), e += i + 1;
            }
        }
        return e;
    }
    mergeMultiSegments() {
        if (!this.appSegments.some((e)=>e.multiSegment)) return;
        let e = function(e, t) {
            let s, i, n, r = new Map;
            for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
            return Array.from(r);
        }(this.appSegments, "type");
        this.mergedAppSegments = e.map(([e, t])=>{
            let s = y.get(e, this.options);
            if (s.handleMultiSegments) return {
                type: e,
                chunk: s.handleMultiSegments(t)
            };
            return t[0];
        });
    }
    getSegment(e) {
        return this.appSegments.find((t)=>t.type === e);
    }
    async getOrFindSegment(e) {
        let t = this.getSegment(e);
        return void 0 === t && (await this.findAppSegments(0, [
            e
        ]), t = this.getSegment(e)), t;
    }
}
e(ee, "type", "jpeg"), m.set("jpeg", ee);
const te = [
    void 0,
    1,
    1,
    2,
    4,
    8,
    1,
    1,
    2,
    4,
    8,
    4,
    8,
    4
];
class se extends J {
    parseHeader() {
        var e = this.chunk.getUint16();
        18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
    }
    parseTags(e, t, s = new Map) {
        let { pick: i, skip: n } = this.options[t];
        i = new Set(i);
        let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
        e += 2;
        for(let f = 0; f < h; f++){
            let h = this.chunk.getUint16(e);
            if (r) {
                if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
            } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
            e += 12;
        }
        return s;
    }
    parseTag(e, t, s) {
        let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = te[n];
        if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && l(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && l(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
        if (2 === n) return "" === (h = (function(e) {
            for(; e.endsWith("\0");)e = e.slice(0, -1);
            return e;
        })(h = i.getString(e, r)).trim()) ? void 0 : h;
        var h;
        if (7 === n) return i.getUint8Array(e, r);
        if (1 === r) return this.parseTagValue(n, e);
        {
            let t = new (function(e) {
                switch(e){
                    case 1:
                        return Uint8Array;
                    case 3:
                        return Uint16Array;
                    case 4:
                        return Uint32Array;
                    case 5:
                        return Array;
                    case 6:
                        return Int8Array;
                    case 8:
                        return Int16Array;
                    case 9:
                        return Int32Array;
                    case 10:
                        return Array;
                    case 11:
                        return Float32Array;
                    case 12:
                        return Float64Array;
                    default:
                        return Array;
                }
            }(n))(r), s = a;
            for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
            return t;
        }
    }
    parseTagValue(e, t) {
        let { chunk: s } = this;
        switch(e){
            case 1:
                return s.getUint8(t);
            case 3:
                return s.getUint16(t);
            case 4:
                return s.getUint32(t);
            case 5:
                return s.getUint32(t) / s.getUint32(t + 4);
            case 6:
                return s.getInt8(t);
            case 8:
                return s.getInt16(t);
            case 9:
                return s.getInt32(t);
            case 10:
                return s.getInt32(t) / s.getInt32(t + 4);
            case 11:
                return s.getFloat(t);
            case 12:
                return s.getDouble(t);
            case 13:
                return s.getUint32(t);
            default:
                l(`Invalid tiff type ${e}`);
        }
    }
}
class ie extends se {
    static canHandle(e, t) {
        return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
    }
    async parse() {
        this.parseHeader();
        let { options: e } = this;
        return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
    }
    safeParse(e) {
        let t = this[e]();
        return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
    }
    findIfd0Offset() {
        void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
    }
    findIfd1Offset() {
        if (void 0 === this.ifd1Offset) {
            this.findIfd0Offset();
            let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
            this.ifd1Offset = this.chunk.getUint32(t);
        }
    }
    parseBlock(e, t) {
        let s = new Map;
        return this[t] = s, this.parseTags(e, t, s), s;
    }
    async parseIfd0Block() {
        if (this.ifd0) return;
        let { file: e } = this;
        this.findIfd0Offset(), this.ifd0Offset < 8 && l("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && l(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, o(this.options));
        let t = this.parseBlock(this.ifd0Offset, "ifd0");
        return 0 !== t.size ? (this.exifOffset = t.get(34665), this.interopOffset = t.get(40965), this.gpsOffset = t.get(34853), this.xmp = t.get(700), this.iptc = t.get(33723), this.icc = t.get(34675), this.options.sanitize && (t.delete(34665), t.delete(40965), t.delete(34853), t.delete(700), t.delete(33723), t.delete(34675)), t) : void 0;
    }
    async parseExifBlock() {
        if (this.exif) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
        this.file.tiff && await this.file.ensureChunk(this.exifOffset, o(this.options));
        let e = this.parseBlock(this.exifOffset, "exif");
        return this.interopOffset || (this.interopOffset = e.get(40965)), this.makerNote = e.get(37500), this.userComment = e.get(37510), this.options.sanitize && (e.delete(40965), e.delete(37500), e.delete(37510)), this.unpack(e, 41728), this.unpack(e, 41729), e;
    }
    unpack(e, t) {
        let s = e.get(t);
        s && 1 === s.length && e.set(t, s[0]);
    }
    async parseGpsBlock() {
        if (this.gps) return;
        if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
        let e = this.parseBlock(this.gpsOffset, "gps");
        return e && e.has(2) && e.has(4) && (e.set("latitude", ne(...e.get(2), e.get(1))), e.set("longitude", ne(...e.get(4), e.get(3)))), e;
    }
    async parseInteropBlock() {
        if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
    }
    async parseThumbnailBlock(e = !1) {
        if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
    }
    async extractThumbnail() {
        if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
        let e = this.ifd1.get(513), t = this.ifd1.get(514);
        return this.chunk.getUint8Array(e, t);
    }
    get image() {
        return this.ifd0;
    }
    get thumbnail() {
        return this.ifd1;
    }
    createOutput() {
        let e, t, s, i = {};
        for (t of P)if (e = this[t], !f(e)) {
            if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                if ("ifd1" === t) continue;
                Object.assign(i, s);
            } else i[t] = s;
        }
        return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
    }
    assignToOutput(e, t) {
        if (this.globalOptions.mergeOutput) Object.assign(e, t);
        else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
    }
}
function ne(e, t, s, i) {
    var n = e + t / 60 + s / 3600;
    return "S" !== i && "W" !== i || (n *= -1), n;
}
e(ie, "type", "tiff"), e(ie, "headerLength", 10), y.set("tiff", ie);
var re = Object.freeze({
    __proto__: null,
    default: G,
    Exifr: H,
    fileParsers: m,
    segmentParsers: y,
    fileReaders: b,
    tagKeys: B,
    tagValues: V,
    tagRevivers: I,
    createDictionary: x,
    extendDictionary: C,
    fetchUrlAsArrayBuffer: S,
    readBlobAsArrayBuffer: A,
    chunkedProps: L,
    otherSegments: T,
    segments: z,
    tiffBlocks: P,
    segmentsAndBlocks: F,
    tiffExtractables: j,
    inheritables: E,
    allFormatters: M,
    Options: R,
    parse: Y
});
const ae = {
    ifd0: !1,
    ifd1: !1,
    exif: !1,
    gps: !1,
    interop: !1,
    sanitize: !1,
    reviveValues: !0,
    translateKeys: !1,
    translateValues: !1,
    mergeOutput: !1
}, he = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    gps: [
        1,
        2,
        3,
        4
    ]
});
async function fe(e) {
    let t = new H(he);
    await t.read(e);
    let s = await t.parse();
    if (s && s.gps) {
        let { latitude: e, longitude: t } = s.gps;
        return {
            latitude: e,
            longitude: t
        };
    }
}
const le = Object.assign({}, ae, {
    tiff: !1,
    ifd1: !0,
    mergeOutput: !1
});
async function oe(e) {
    let t = new H(le);
    await t.read(e);
    let s = await t.extractThumbnail();
    return s && a ? r.from(s) : s;
}
async function ue(e) {
    let t = await this.thumbnail(e);
    if (void 0 !== t) {
        let e = new Blob([
            t
        ]);
        return URL.createObjectURL(e);
    }
}
const de = Object.assign({}, ae, {
    firstChunkSize: 4e4,
    ifd0: [
        274
    ]
});
async function ce(e) {
    let t = new H(de);
    await t.read(e);
    let s = await t.parse();
    if (s && s.ifd0) return s.ifd0[274];
}
const pe = Object.freeze({
    1: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    2: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 0,
        rad: 0
    },
    3: {
        dimensionSwapped: !1,
        scaleX: 1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    4: {
        dimensionSwapped: !1,
        scaleX: -1,
        scaleY: 1,
        deg: 180,
        rad: 180 * Math.PI / 180
    },
    5: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    6: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 90,
        rad: 90 * Math.PI / 180
    },
    7: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: -1,
        deg: 270,
        rad: 270 * Math.PI / 180
    },
    8: {
        dimensionSwapped: !0,
        scaleX: 1,
        scaleY: 1,
        deg: 270,
        rad: 270 * Math.PI / 180
    }
});
let ge = !0, me = !0;
if ("object" == typeof navigator) {
    let e = navigator.userAgent;
    if (e.includes("iPad") || e.includes("iPhone")) {
        let t = e.match(/OS (\d+)_(\d+)/);
        if (t) {
            let [, e, s] = t, i = Number(e) + .1 * Number(s);
            ge = i < 13.4, me = !1;
        }
    } else if (e.includes("OS X 10")) {
        let [, t] = e.match(/OS X 10[_.](\d+)/);
        ge = me = Number(t) < 15;
    }
    if (e.includes("Chrome/")) {
        let [, t] = e.match(/Chrome\/(\d+)/);
        ge = me = Number(t) < 81;
    } else if (e.includes("Firefox/")) {
        let [, t] = e.match(/Firefox\/(\d+)/);
        ge = me = Number(t) < 77;
    }
}
async function ye(e) {
    let t = await ce(e);
    return Object.assign({
        canvas: ge,
        css: me
    }, pe[t]);
}
class be extends c {
    constructor(...t){
        super(...t), e(this, "ranges", new we), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
    }
    _tryExtend(e, t, s) {
        if (0 === e && 0 === this.byteLength && s) {
            let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
            this._swapDataView(e);
        } else {
            let s = e + t;
            if (s > this.byteLength) {
                let { dataView: e } = this._extend(s);
                this._swapDataView(e);
            }
        }
    }
    _extend(e) {
        let t;
        t = a ? r.allocUnsafe(e) : new Uint8Array(e);
        let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
        return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
            uintView: t,
            dataView: s
        };
    }
    subarray(e, t, s = !1) {
        return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
    }
    set(e, t, s = !1) {
        s && this._tryExtend(t, e.byteLength, e);
        let i = super.set(e, t);
        return this.ranges.add(t, i.byteLength), i;
    }
    async ensureChunk(e, t) {
        this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
    }
    available(e, t) {
        return this.ranges.available(e, t);
    }
}
class we {
    constructor(){
        e(this, "list", []);
    }
    get length() {
        return this.list.length;
    }
    add(e, t, s = 0) {
        let i = e + t, n = this.list.filter((t)=>ke(e, t.offset, i) || ke(e, t.end, i));
        if (n.length > 0) {
            e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
            let s = n.shift();
            s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
        } else this.list.push({
            offset: e,
            length: t,
            end: i
        });
    }
    available(e, t) {
        let s = e + t;
        return this.list.some((t)=>t.offset <= e && s <= t.end);
    }
}
function ke(e, t, s) {
    return e <= t && t <= s;
}
class Oe extends be {
    constructor(t, s){
        super(0), e(this, "chunksRead", 0), this.input = t, this.options = s;
    }
    async readWhole() {
        this.chunked = !1, await this.readChunk(this.nextChunkOffset);
    }
    async readChunked() {
        this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
    }
    async readNextChunk(e = this.nextChunkOffset) {
        if (this.fullyRead) return this.chunksRead++, !1;
        let t = this.options.chunkSize, s = await this.readChunk(e, t);
        return !!s && s.byteLength === t;
    }
    async readChunk(e, t) {
        if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
    }
    safeWrapAddress(e, t) {
        return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
    }
    get nextChunkOffset() {
        if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
    }
    get canReadNextChunk() {
        return this.chunksRead < this.options.chunkLimit;
    }
    get fullyRead() {
        return void 0 !== this.size && this.nextChunkOffset === this.size;
    }
    read() {
        return this.options.chunked ? this.readChunked() : this.readWhole();
    }
    close() {}
}
b.set("blob", class extends Oe {
    async readWhole() {
        this.chunked = !1;
        let e = await A(this.input);
        this._swapArrayBuffer(e);
    }
    readChunked() {
        return this.chunked = !0, this.size = this.input.size, super.readChunked();
    }
    async _readChunk(e, t) {
        let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await A(i);
        return this.set(n, e, !0);
    }
});
var $49decdd7c8e65498$export$2e2bcd8739ae039 = re;

});
parcelRegister("6qd2L", function(module, exports) {
// shim for using process in browser
var $4acf49f6c3e67aec$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $4acf49f6c3e67aec$var$cachedSetTimeout;
var $4acf49f6c3e67aec$var$cachedClearTimeout;
function $4acf49f6c3e67aec$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $4acf49f6c3e67aec$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        else $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = $4acf49f6c3e67aec$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        else $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    } catch (e) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = $4acf49f6c3e67aec$var$defaultClearTimeout;
    }
})();
function $4acf49f6c3e67aec$var$runTimeout(fun) {
    if ($4acf49f6c3e67aec$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedSetTimeout === $4acf49f6c3e67aec$var$defaultSetTimout || !$4acf49f6c3e67aec$var$cachedSetTimeout) && setTimeout) {
        $4acf49f6c3e67aec$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $4acf49f6c3e67aec$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $4acf49f6c3e67aec$var$runClearTimeout(marker) {
    if ($4acf49f6c3e67aec$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($4acf49f6c3e67aec$var$cachedClearTimeout === $4acf49f6c3e67aec$var$defaultClearTimeout || !$4acf49f6c3e67aec$var$cachedClearTimeout) && clearTimeout) {
        $4acf49f6c3e67aec$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $4acf49f6c3e67aec$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $4acf49f6c3e67aec$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $4acf49f6c3e67aec$var$queue = [];
var $4acf49f6c3e67aec$var$draining = false;
var $4acf49f6c3e67aec$var$currentQueue;
var $4acf49f6c3e67aec$var$queueIndex = -1;
function $4acf49f6c3e67aec$var$cleanUpNextTick() {
    if (!$4acf49f6c3e67aec$var$draining || !$4acf49f6c3e67aec$var$currentQueue) return;
    $4acf49f6c3e67aec$var$draining = false;
    if ($4acf49f6c3e67aec$var$currentQueue.length) $4acf49f6c3e67aec$var$queue = $4acf49f6c3e67aec$var$currentQueue.concat($4acf49f6c3e67aec$var$queue);
    else $4acf49f6c3e67aec$var$queueIndex = -1;
    if ($4acf49f6c3e67aec$var$queue.length) $4acf49f6c3e67aec$var$drainQueue();
}
function $4acf49f6c3e67aec$var$drainQueue() {
    if ($4acf49f6c3e67aec$var$draining) return;
    var timeout = $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$cleanUpNextTick);
    $4acf49f6c3e67aec$var$draining = true;
    var len = $4acf49f6c3e67aec$var$queue.length;
    while(len){
        $4acf49f6c3e67aec$var$currentQueue = $4acf49f6c3e67aec$var$queue;
        $4acf49f6c3e67aec$var$queue = [];
        while(++$4acf49f6c3e67aec$var$queueIndex < len)if ($4acf49f6c3e67aec$var$currentQueue) $4acf49f6c3e67aec$var$currentQueue[$4acf49f6c3e67aec$var$queueIndex].run();
        $4acf49f6c3e67aec$var$queueIndex = -1;
        len = $4acf49f6c3e67aec$var$queue.length;
    }
    $4acf49f6c3e67aec$var$currentQueue = null;
    $4acf49f6c3e67aec$var$draining = false;
    $4acf49f6c3e67aec$var$runClearTimeout(timeout);
}
$4acf49f6c3e67aec$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $4acf49f6c3e67aec$var$queue.push(new $4acf49f6c3e67aec$var$Item(fun, args));
    if ($4acf49f6c3e67aec$var$queue.length === 1 && !$4acf49f6c3e67aec$var$draining) $4acf49f6c3e67aec$var$runTimeout($4acf49f6c3e67aec$var$drainQueue);
};
// v8 likes predictible objects
function $4acf49f6c3e67aec$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$4acf49f6c3e67aec$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$4acf49f6c3e67aec$var$process.title = "browser";
$4acf49f6c3e67aec$var$process.browser = true;
$4acf49f6c3e67aec$var$process.env = {};
$4acf49f6c3e67aec$var$process.argv = [];
$4acf49f6c3e67aec$var$process.version = ""; // empty string to avoid regexp issues
$4acf49f6c3e67aec$var$process.versions = {};
function $4acf49f6c3e67aec$var$noop() {}
$4acf49f6c3e67aec$var$process.on = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.addListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.once = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.off = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.removeAllListeners = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.emit = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.prependOnceListener = $4acf49f6c3e67aec$var$noop;
$4acf49f6c3e67aec$var$process.listeners = function(name) {
    return [];
};
$4acf49f6c3e67aec$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$4acf49f6c3e67aec$var$process.cwd = function() {
    return "/";
};
$4acf49f6c3e67aec$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$4acf49f6c3e67aec$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3aNd6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $24f87a6f86a8996f$export$a143d493d941bafc; }, function (v) { return $24f87a6f86a8996f$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $24f87a6f86a8996f$export$f99ded8fe4b79145; }, function (v) { return $24f87a6f86a8996f$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $24f87a6f86a8996f$export$a143d493d941bafc;
var $24f87a6f86a8996f$export$e4cf37d7f6fb9e0a;
var $24f87a6f86a8996f$export$f99ded8fe4b79145;
var $24f87a6f86a8996f$export$599f31c3813fae4d;
"use strict";

var $5d11t = parcelRequire("5d11t");

var $7rddL = parcelRequire("7rddL");
const $24f87a6f86a8996f$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$24f87a6f86a8996f$export$a143d493d941bafc = $24f87a6f86a8996f$var$Buffer;
$24f87a6f86a8996f$export$e4cf37d7f6fb9e0a = $24f87a6f86a8996f$var$SlowBuffer;
$24f87a6f86a8996f$export$f99ded8fe4b79145 = 50;
const $24f87a6f86a8996f$var$K_MAX_LENGTH = 0x7fffffff;
$24f87a6f86a8996f$export$599f31c3813fae4d = $24f87a6f86a8996f$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT = $24f87a6f86a8996f$var$typedArraySupport();
if (!$24f87a6f86a8996f$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $24f87a6f86a8996f$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($24f87a6f86a8996f$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$24f87a6f86a8996f$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $24f87a6f86a8996f$var$createBuffer(length) {
    if (length > $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $24f87a6f86a8996f$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $24f87a6f86a8996f$var$allocUnsafe(arg);
    }
    return $24f87a6f86a8996f$var$from(arg, encodingOrOffset, length);
}
$24f87a6f86a8996f$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $24f87a6f86a8996f$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $24f87a6f86a8996f$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $24f87a6f86a8996f$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($24f87a6f86a8996f$var$isInstance(value, ArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, ArrayBuffer)) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($24f87a6f86a8996f$var$isInstance(value, SharedArrayBuffer) || value && $24f87a6f86a8996f$var$isInstance(value.buffer, SharedArrayBuffer))) return $24f87a6f86a8996f$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $24f87a6f86a8996f$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $24f87a6f86a8996f$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $24f87a6f86a8996f$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $24f87a6f86a8996f$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $24f87a6f86a8996f$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($24f87a6f86a8996f$var$Buffer, Uint8Array);
function $24f87a6f86a8996f$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $24f87a6f86a8996f$var$alloc(size, fill, encoding) {
    $24f87a6f86a8996f$var$assertSize(size);
    if (size <= 0) return $24f87a6f86a8996f$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $24f87a6f86a8996f$var$createBuffer(size).fill(fill, encoding) : $24f87a6f86a8996f$var$createBuffer(size).fill(fill);
    return $24f87a6f86a8996f$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $24f87a6f86a8996f$var$Buffer.alloc = function(size, fill, encoding) {
    return $24f87a6f86a8996f$var$alloc(size, fill, encoding);
};
function $24f87a6f86a8996f$var$allocUnsafe(size) {
    $24f87a6f86a8996f$var$assertSize(size);
    return $24f87a6f86a8996f$var$createBuffer(size < 0 ? 0 : $24f87a6f86a8996f$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $24f87a6f86a8996f$var$Buffer.allocUnsafe = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $24f87a6f86a8996f$var$Buffer.allocUnsafeSlow = function(size) {
    return $24f87a6f86a8996f$var$allocUnsafe(size);
};
function $24f87a6f86a8996f$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $24f87a6f86a8996f$var$byteLength(string, encoding) | 0;
    let buf = $24f87a6f86a8996f$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $24f87a6f86a8996f$var$checked(array.length) | 0;
    const buf = $24f87a6f86a8996f$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $24f87a6f86a8996f$var$fromArrayView(arrayView) {
    if ($24f87a6f86a8996f$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $24f87a6f86a8996f$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $24f87a6f86a8996f$var$fromArrayLike(arrayView);
}
function $24f87a6f86a8996f$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $24f87a6f86a8996f$var$Buffer.prototype);
    return buf;
}
function $24f87a6f86a8996f$var$fromObject(obj) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(obj)) {
        const len = $24f87a6f86a8996f$var$checked(obj.length) | 0;
        const buf = $24f87a6f86a8996f$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $24f87a6f86a8996f$var$numberIsNaN(obj.length)) return $24f87a6f86a8996f$var$createBuffer(0);
        return $24f87a6f86a8996f$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $24f87a6f86a8996f$var$fromArrayLike(obj.data);
}
function $24f87a6f86a8996f$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $24f87a6f86a8996f$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $24f87a6f86a8996f$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $24f87a6f86a8996f$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $24f87a6f86a8996f$var$Buffer.alloc(+length);
}
$24f87a6f86a8996f$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $24f87a6f86a8996f$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$24f87a6f86a8996f$var$Buffer.compare = function compare(a, b) {
    if ($24f87a6f86a8996f$var$isInstance(a, Uint8Array)) a = $24f87a6f86a8996f$var$Buffer.from(a, a.offset, a.byteLength);
    if ($24f87a6f86a8996f$var$isInstance(b, Uint8Array)) b = $24f87a6f86a8996f$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(a) || !$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$24f87a6f86a8996f$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$24f87a6f86a8996f$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $24f87a6f86a8996f$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $24f87a6f86a8996f$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($24f87a6f86a8996f$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) buf = $24f87a6f86a8996f$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $24f87a6f86a8996f$var$byteLength(string, encoding) {
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $24f87a6f86a8996f$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $24f87a6f86a8996f$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $24f87a6f86a8996f$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$24f87a6f86a8996f$var$Buffer.byteLength = $24f87a6f86a8996f$var$byteLength;
function $24f87a6f86a8996f$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Slice(this, start, end);
        case "ascii":
            return $24f87a6f86a8996f$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$latin1Slice(this, start, end);
        case "base64":
            return $24f87a6f86a8996f$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$24f87a6f86a8996f$var$Buffer.prototype._isBuffer = true;
function $24f87a6f86a8996f$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$24f87a6f86a8996f$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$24f87a6f86a8996f$var$swap(this, i, i + 1);
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $24f87a6f86a8996f$var$swap(this, i, i + 3);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $24f87a6f86a8996f$var$swap(this, i, i + 7);
        $24f87a6f86a8996f$var$swap(this, i + 1, i + 6);
        $24f87a6f86a8996f$var$swap(this, i + 2, i + 5);
        $24f87a6f86a8996f$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$24f87a6f86a8996f$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $24f87a6f86a8996f$var$utf8Slice(this, 0, length);
    return $24f87a6f86a8996f$var$slowToString.apply(this, arguments);
};
$24f87a6f86a8996f$var$Buffer.prototype.toLocaleString = $24f87a6f86a8996f$var$Buffer.prototype.toString;
$24f87a6f86a8996f$var$Buffer.prototype.equals = function equals(b) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $24f87a6f86a8996f$var$Buffer.compare(this, b) === 0;
};
$24f87a6f86a8996f$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $24f87a6f86a8996f$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($24f87a6f86a8996f$var$customInspectSymbol) $24f87a6f86a8996f$var$Buffer.prototype[$24f87a6f86a8996f$var$customInspectSymbol] = $24f87a6f86a8996f$var$Buffer.prototype.inspect;
$24f87a6f86a8996f$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($24f87a6f86a8996f$var$isInstance(target, Uint8Array)) target = $24f87a6f86a8996f$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $24f87a6f86a8996f$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($24f87a6f86a8996f$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $24f87a6f86a8996f$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($24f87a6f86a8996f$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $24f87a6f86a8996f$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $24f87a6f86a8996f$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$24f87a6f86a8996f$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$24f87a6f86a8996f$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $24f87a6f86a8996f$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $24f87a6f86a8996f$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($24f87a6f86a8996f$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $24f87a6f86a8996f$var$utf8Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $24f87a6f86a8996f$var$asciiWrite(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$asciiToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$base64Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$base64ToBytes(string), buf, offset, length);
}
function $24f87a6f86a8996f$var$ucs2Write(buf, string, offset, length) {
    return $24f87a6f86a8996f$var$blitBuffer($24f87a6f86a8996f$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$24f87a6f86a8996f$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $24f87a6f86a8996f$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $24f87a6f86a8996f$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $24f87a6f86a8996f$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $24f87a6f86a8996f$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $24f87a6f86a8996f$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$24f87a6f86a8996f$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $24f87a6f86a8996f$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $5d11t.fromByteArray(buf);
    else return $5d11t.fromByteArray(buf.slice(start, end));
}
function $24f87a6f86a8996f$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $24f87a6f86a8996f$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $24f87a6f86a8996f$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $24f87a6f86a8996f$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $24f87a6f86a8996f$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $24f87a6f86a8996f$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $24f87a6f86a8996f$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $24f87a6f86a8996f$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $24f87a6f86a8996f$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$24f87a6f86a8996f$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $24f87a6f86a8996f$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $24f87a6f86a8996f$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$24f87a6f86a8996f$var$Buffer.prototype.readUintLE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUintBE = $24f87a6f86a8996f$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint8 = $24f87a6f86a8996f$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$24f87a6f86a8996f$var$Buffer.prototype.readUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$24f87a6f86a8996f$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$24f87a6f86a8996f$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$24f87a6f86a8996f$var$Buffer.prototype.readBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $24f87a6f86a8996f$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$24f87a6f86a8996f$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, true, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 4, this.length);
    return $7rddL.read(this, offset, false, 23, 4);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, true, 52, 8);
};
$24f87a6f86a8996f$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkOffset(offset, 8, this.length);
    return $7rddL.read(this, offset, false, 52, 8);
};
function $24f87a6f86a8996f$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$24f87a6f86a8996f$var$Buffer.prototype.writeUintLE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUintBE = $24f87a6f86a8996f$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint8 = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint16BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32LE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeUint32BE = $24f87a6f86a8996f$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $24f87a6f86a8996f$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $24f87a6f86a8996f$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigUInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $24f87a6f86a8996f$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64LE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$24f87a6f86a8996f$var$Buffer.prototype.writeBigInt64BE = $24f87a6f86a8996f$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $24f87a6f86a8996f$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $24f87a6f86a8996f$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeFloat(this, value, offset, false, noAssert);
};
function $24f87a6f86a8996f$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $24f87a6f86a8996f$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7rddL.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, true, noAssert);
};
$24f87a6f86a8996f$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $24f87a6f86a8996f$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$24f87a6f86a8996f$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$24f87a6f86a8996f$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$24f87a6f86a8996f$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$24f87a6f86a8996f$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $24f87a6f86a8996f$var$Buffer.isBuffer(val) ? val : $24f87a6f86a8996f$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $24f87a6f86a8996f$var$errors = {};
function $24f87a6f86a8996f$var$E(sym, getMessage, Base) {
    $24f87a6f86a8996f$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$24f87a6f86a8996f$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$24f87a6f86a8996f$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$24f87a6f86a8996f$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $24f87a6f86a8996f$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $24f87a6f86a8996f$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $24f87a6f86a8996f$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength) {
    $24f87a6f86a8996f$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $24f87a6f86a8996f$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $24f87a6f86a8996f$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $24f87a6f86a8996f$var$checkBounds(buf, offset, byteLength);
}
function $24f87a6f86a8996f$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $24f87a6f86a8996f$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $24f87a6f86a8996f$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $24f87a6f86a8996f$var$validateNumber(value, type);
        throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $24f87a6f86a8996f$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $24f87a6f86a8996f$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $24f87a6f86a8996f$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $24f87a6f86a8996f$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($24f87a6f86a8996f$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $24f87a6f86a8996f$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $24f87a6f86a8996f$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $24f87a6f86a8996f$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $24f87a6f86a8996f$var$base64ToBytes(str) {
    return $5d11t.toByteArray($24f87a6f86a8996f$var$base64clean(str));
}
function $24f87a6f86a8996f$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $24f87a6f86a8996f$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $24f87a6f86a8996f$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $24f87a6f86a8996f$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $24f87a6f86a8996f$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $24f87a6f86a8996f$var$BufferBigIntNotDefined : fn;
}
function $24f87a6f86a8996f$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("5d11t", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $3caef5c332c7293f$export$d622b2ad8d90c771; }, function (v) { return $3caef5c332c7293f$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $3caef5c332c7293f$export$6100ba28696e12de; }, function (v) { return $3caef5c332c7293f$export$6100ba28696e12de = v; });
var $3caef5c332c7293f$export$a48f0734ac7c2329;
var $3caef5c332c7293f$export$d622b2ad8d90c771;
var $3caef5c332c7293f$export$6100ba28696e12de;
"use strict";
$3caef5c332c7293f$export$a48f0734ac7c2329 = $3caef5c332c7293f$var$byteLength;
$3caef5c332c7293f$export$d622b2ad8d90c771 = $3caef5c332c7293f$var$toByteArray;
$3caef5c332c7293f$export$6100ba28696e12de = $3caef5c332c7293f$var$fromByteArray;
var $3caef5c332c7293f$var$lookup = [];
var $3caef5c332c7293f$var$revLookup = [];
var $3caef5c332c7293f$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $3caef5c332c7293f$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $3caef5c332c7293f$var$i = 0, $3caef5c332c7293f$var$len = $3caef5c332c7293f$var$code.length; $3caef5c332c7293f$var$i < $3caef5c332c7293f$var$len; ++$3caef5c332c7293f$var$i){
    $3caef5c332c7293f$var$lookup[$3caef5c332c7293f$var$i] = $3caef5c332c7293f$var$code[$3caef5c332c7293f$var$i];
    $3caef5c332c7293f$var$revLookup[$3caef5c332c7293f$var$code.charCodeAt($3caef5c332c7293f$var$i)] = $3caef5c332c7293f$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$3caef5c332c7293f$var$revLookup["-".charCodeAt(0)] = 62;
$3caef5c332c7293f$var$revLookup["_".charCodeAt(0)] = 63;
function $3caef5c332c7293f$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $3caef5c332c7293f$var$byteLength(b64) {
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $3caef5c332c7293f$var$toByteArray(b64) {
    var tmp;
    var lens = $3caef5c332c7293f$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $3caef5c332c7293f$var$Arr($3caef5c332c7293f$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 18 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 2 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i)] << 10 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $3caef5c332c7293f$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $3caef5c332c7293f$var$tripletToBase64(num) {
    return $3caef5c332c7293f$var$lookup[num >> 18 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 12 & 0x3F] + $3caef5c332c7293f$var$lookup[num >> 6 & 0x3F] + $3caef5c332c7293f$var$lookup[num & 0x3F];
}
function $3caef5c332c7293f$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($3caef5c332c7293f$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $3caef5c332c7293f$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($3caef5c332c7293f$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 2] + $3caef5c332c7293f$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($3caef5c332c7293f$var$lookup[tmp >> 10] + $3caef5c332c7293f$var$lookup[tmp >> 4 & 0x3F] + $3caef5c332c7293f$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("7rddL", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $56a54f6ebabce67d$export$aafa59e2e03f2942; }, function (v) { return $56a54f6ebabce67d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $56a54f6ebabce67d$export$68d8715fc104d294; }, function (v) { return $56a54f6ebabce67d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $56a54f6ebabce67d$export$aafa59e2e03f2942;
var $56a54f6ebabce67d$export$68d8715fc104d294;
$56a54f6ebabce67d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$56a54f6ebabce67d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("eKpYu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $abc98293c451d2b0$export$2e2bcd8739ae039; });
class $abc98293c451d2b0$var$NgConfig {
}
$abc98293c451d2b0$var$NgConfig.UPLOAD_URL = "/api/userfiles/";
$abc98293c451d2b0$var$NgConfig.JOB_START_URL = "/api/jobs/start/";
$abc98293c451d2b0$var$NgConfig.JOB_STATUS_URL = "/api/jobs/status/";
$abc98293c451d2b0$var$NgConfig.FILES_URL = "/userfiles";
$abc98293c451d2b0$var$NgConfig.PARAMS_URL = "/tools/params";
$abc98293c451d2b0$var$NgConfig.FILES_API_URL = "/api/userfiles";
$abc98293c451d2b0$var$NgConfig.MAX_UPLOAD_FILE_SIZE = 1073741824;
$abc98293c451d2b0$var$NgConfig.MAX_NUMBER_OF_BATCH_UPLOADS = 10;
var $abc98293c451d2b0$export$2e2bcd8739ae039 = $abc98293c451d2b0$var$NgConfig;

});

function $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $a85fd1efd23057e0$var$id = 0;
function $a85fd1efd23057e0$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $a85fd1efd23057e0$var$id++ + "_" + e;
}
// We're using a generic because languages have different plural rules.
// eslint-disable-next-line no-use-before-define
function $a85fd1efd23057e0$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== "string") return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== "") newParts.push(raw);
            // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param phrase that needs interpolation, with placeholders
 * @param options with values that will be used to replace placeholders
 */ function $a85fd1efd23057e0$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = "$$$$";
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== "_") {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === "string") replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
        // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $a85fd1efd23057e0$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
    return interpolated;
}
const $a85fd1efd23057e0$var$defaultOnMissingKey = (key)=>{
    throw new Error(`missing string: ${key}`);
};
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $a85fd1efd23057e0$var$_onMissingKey = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("onMissingKey");
var $a85fd1efd23057e0$var$_apply = /*#__PURE__*/ $a85fd1efd23057e0$var$_classPrivateFieldLooseKey("apply");
class $a85fd1efd23057e0$export$2e2bcd8739ae039 {
    constructor(locales, _temp){
        let { onMissingKey: onMissingKey = $a85fd1efd23057e0$var$defaultOnMissingKey } = _temp === void 0 ? {} : _temp;
        Object.defineProperty(this, $a85fd1efd23057e0$var$_apply, {
            value: $a85fd1efd23057e0$var$_apply2
        });
        Object.defineProperty(this, $a85fd1efd23057e0$var$_onMissingKey, {
            writable: true,
            value: void 0
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply], this);
        else $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_apply)[$a85fd1efd23057e0$var$_apply](locales);
        $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey] = onMissingKey;
    }
    /**
   * Public translate method
   *
   * @param key
   * @param options with values that will be used later to replace placeholders in string
   * @returns string translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join("");
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @returns The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        let string = this.locale.strings[key];
        if (string == null) {
            $a85fd1efd23057e0$var$_classPrivateFieldLooseBase(this, $a85fd1efd23057e0$var$_onMissingKey)[$a85fd1efd23057e0$var$_onMissingKey](key);
            string = key;
        }
        const hasPluralForms = typeof string === "object";
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== "undefined") {
                const plural = this.locale.pluralize(options.smart_count);
                return $a85fd1efd23057e0$var$interpolate(string[plural], options);
            }
            throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
        }
        if (typeof string !== "string") throw new Error(`string was not a string`);
        return $a85fd1efd23057e0$var$interpolate(string, options);
    }
}
function $a85fd1efd23057e0$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    Object.assign(this.locale, {
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        },
        pluralize: locale.pluralize || prevLocale.pluralize
    });
}


var $1713863f3a962559$exports = {};
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ $1713863f3a962559$exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(":");
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === "*") out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};


/* @ts-self-types="./index.d.ts" */ let $3c82c89e950acc97$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3c82c89e950acc97$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size | 0;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3c82c89e950acc97$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size | 0;
    while(i--)id += $3c82c89e950acc97$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $a50c1ad1c2867517$exports = {};
var $8284bc2b60dc4bc4$exports = {};
var $db5dfd0661742a1a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $db5dfd0661742a1a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$db5dfd0661742a1a$exports = $db5dfd0661742a1a$var$isObject;


var $1c50bd4ee78fb504$exports = {};
var $67910ad3df1b1086$exports = {};
var $fb170ba8a9c2191f$exports = {};
/** Detect free variable `global` from Node.js. */ var $fb170ba8a9c2191f$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$fb170ba8a9c2191f$exports = $fb170ba8a9c2191f$var$freeGlobal;


/** Detect free variable `self`. */ var $67910ad3df1b1086$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $67910ad3df1b1086$var$root = $fb170ba8a9c2191f$exports || $67910ad3df1b1086$var$freeSelf || Function("return this")();
$67910ad3df1b1086$exports = $67910ad3df1b1086$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1c50bd4ee78fb504$var$now = function() {
    return $67910ad3df1b1086$exports.Date.now();
};
$1c50bd4ee78fb504$exports = $1c50bd4ee78fb504$var$now;


var $e588870a06e690e1$exports = {};
var $3b7784db2f170e31$exports = {};
var $85eafef3a7f213a3$exports = {};
/** Used to match a single whitespace character. */ var $85eafef3a7f213a3$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $85eafef3a7f213a3$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $85eafef3a7f213a3$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$85eafef3a7f213a3$exports = $85eafef3a7f213a3$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $3b7784db2f170e31$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $3b7784db2f170e31$var$baseTrim(string) {
    return string ? string.slice(0, $85eafef3a7f213a3$exports(string) + 1).replace($3b7784db2f170e31$var$reTrimStart, "") : string;
}
$3b7784db2f170e31$exports = $3b7784db2f170e31$var$baseTrim;



var $b7350b23d035986b$exports = {};
var $852d1f971b259156$exports = {};
var $a090581360ce8173$exports = {};

/** Built-in value references. */ var $a090581360ce8173$var$Symbol = $67910ad3df1b1086$exports.Symbol;
$a090581360ce8173$exports = $a090581360ce8173$var$Symbol;


var $f2cc4cee927d37c7$exports = {};

/** Used for built-in method references. */ var $f2cc4cee927d37c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f2cc4cee927d37c7$var$hasOwnProperty = $f2cc4cee927d37c7$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f2cc4cee927d37c7$var$nativeObjectToString = $f2cc4cee927d37c7$var$objectProto.toString;
/** Built-in value references. */ var $f2cc4cee927d37c7$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $f2cc4cee927d37c7$var$getRawTag(value) {
    var isOwn = $f2cc4cee927d37c7$var$hasOwnProperty.call(value, $f2cc4cee927d37c7$var$symToStringTag), tag = value[$f2cc4cee927d37c7$var$symToStringTag];
    try {
        value[$f2cc4cee927d37c7$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $f2cc4cee927d37c7$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$f2cc4cee927d37c7$var$symToStringTag] = tag;
        else delete value[$f2cc4cee927d37c7$var$symToStringTag];
    }
    return result;
}
$f2cc4cee927d37c7$exports = $f2cc4cee927d37c7$var$getRawTag;


var $934b51efa189f09c$exports = {};
/** Used for built-in method references. */ var $934b51efa189f09c$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $934b51efa189f09c$var$nativeObjectToString = $934b51efa189f09c$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $934b51efa189f09c$var$objectToString(value) {
    return $934b51efa189f09c$var$nativeObjectToString.call(value);
}
$934b51efa189f09c$exports = $934b51efa189f09c$var$objectToString;


/** `Object#toString` result references. */ var $852d1f971b259156$var$nullTag = "[object Null]", $852d1f971b259156$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $852d1f971b259156$var$symToStringTag = $a090581360ce8173$exports ? $a090581360ce8173$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $852d1f971b259156$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $852d1f971b259156$var$undefinedTag : $852d1f971b259156$var$nullTag;
    return $852d1f971b259156$var$symToStringTag && $852d1f971b259156$var$symToStringTag in Object(value) ? $f2cc4cee927d37c7$exports(value) : $934b51efa189f09c$exports(value);
}
$852d1f971b259156$exports = $852d1f971b259156$var$baseGetTag;


var $5475ba594a8bdf91$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5475ba594a8bdf91$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$5475ba594a8bdf91$exports = $5475ba594a8bdf91$var$isObjectLike;


/** `Object#toString` result references. */ var $b7350b23d035986b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $b7350b23d035986b$var$isSymbol(value) {
    return typeof value == "symbol" || $5475ba594a8bdf91$exports(value) && $852d1f971b259156$exports(value) == $b7350b23d035986b$var$symbolTag;
}
$b7350b23d035986b$exports = $b7350b23d035986b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $e588870a06e690e1$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e588870a06e690e1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e588870a06e690e1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e588870a06e690e1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e588870a06e690e1$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e588870a06e690e1$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($b7350b23d035986b$exports(value)) return $e588870a06e690e1$var$NAN;
    if ($db5dfd0661742a1a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $db5dfd0661742a1a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $3b7784db2f170e31$exports(value);
    var isBinary = $e588870a06e690e1$var$reIsBinary.test(value);
    return isBinary || $e588870a06e690e1$var$reIsOctal.test(value) ? $e588870a06e690e1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e588870a06e690e1$var$reIsBadHex.test(value) ? $e588870a06e690e1$var$NAN : +value;
}
$e588870a06e690e1$exports = $e588870a06e690e1$var$toNumber;


/** Error message constants. */ var $8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8284bc2b60dc4bc4$var$nativeMax = Math.max, $8284bc2b60dc4bc4$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $8284bc2b60dc4bc4$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($8284bc2b60dc4bc4$var$FUNC_ERROR_TEXT);
    wait = $e588870a06e690e1$exports(wait) || 0;
    if ($db5dfd0661742a1a$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $8284bc2b60dc4bc4$var$nativeMax($e588870a06e690e1$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $8284bc2b60dc4bc4$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1c50bd4ee78fb504$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1c50bd4ee78fb504$exports());
    }
    function debounced() {
        var time = $1c50bd4ee78fb504$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$8284bc2b60dc4bc4$exports = $8284bc2b60dc4bc4$var$debounce;



/** Error message constants. */ var $a50c1ad1c2867517$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $a50c1ad1c2867517$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($a50c1ad1c2867517$var$FUNC_ERROR_TEXT);
    if ($db5dfd0661742a1a$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $8284bc2b60dc4bc4$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$a50c1ad1c2867517$exports = $a50c1ad1c2867517$var$throttle;


function $f790bad313c52a0f$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $f790bad313c52a0f$var$id = 0;
function $f790bad313c52a0f$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $f790bad313c52a0f$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f790bad313c52a0f$var$packageJson = {
    "version": "4.2.0"
};
var $f790bad313c52a0f$var$_callbacks = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("callbacks");
var $f790bad313c52a0f$var$_publish = /*#__PURE__*/ $f790bad313c52a0f$var$_classPrivateFieldLooseKey("publish");
/**
 * Default store that keeps state in a simple object.
 */ class $f790bad313c52a0f$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $f790bad313c52a0f$var$_publish, {
            value: $f790bad313c52a0f$var$_publish2
        });
        this.state = {};
        Object.defineProperty(this, $f790bad313c52a0f$var$_callbacks, {
            writable: true,
            value: new Set()
        });
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_publish)[$f790bad313c52a0f$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].add(listener);
        return ()=>{
            $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].delete(listener);
        };
    }
}
function $f790bad313c52a0f$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $f790bad313c52a0f$var$_classPrivateFieldLooseBase(this, $f790bad313c52a0f$var$_callbacks)[$f790bad313c52a0f$var$_callbacks].forEach((listener)=>{
        listener(...args);
    });
}
$f790bad313c52a0f$var$DefaultStore.VERSION = $f790bad313c52a0f$var$packageJson.version;
var $f790bad313c52a0f$export$2e2bcd8739ae039 = $f790bad313c52a0f$var$DefaultStore;


/**
 * Takes a full filename string and returns an object {name, extension}
 */ function $09afbe8d004816d5$export$2e2bcd8739ae039(fullFileName) {
    const lastDot = fullFileName.lastIndexOf(".");
    // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}


// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
var $92507ee89880573c$export$2e2bcd8739ae039 = {
    __proto__: null,
    md: "text/markdown",
    markdown: "text/markdown",
    mp4: "video/mp4",
    mp3: "audio/mp3",
    svg: "image/svg+xml",
    jpg: "image/jpeg",
    png: "image/png",
    webp: "image/webp",
    gif: "image/gif",
    heic: "image/heic",
    heif: "image/heif",
    yaml: "text/yaml",
    yml: "text/yaml",
    csv: "text/csv",
    tsv: "text/tab-separated-values",
    tab: "text/tab-separated-values",
    avi: "video/x-msvideo",
    mks: "video/x-matroska",
    mkv: "video/x-matroska",
    mov: "video/quicktime",
    dicom: "application/dicom",
    doc: "application/msword",
    msg: "application/vnd.ms-outlook",
    docm: "application/vnd.ms-word.document.macroenabled.12",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    dot: "application/msword",
    dotm: "application/vnd.ms-word.template.macroenabled.12",
    dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    xla: "application/vnd.ms-excel",
    xlam: "application/vnd.ms-excel.addin.macroenabled.12",
    xlc: "application/vnd.ms-excel",
    xlf: "application/x-xliff+xml",
    xlm: "application/vnd.ms-excel",
    xls: "application/vnd.ms-excel",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xlt: "application/vnd.ms-excel",
    xltm: "application/vnd.ms-excel.template.macroenabled.12",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    xlw: "application/vnd.ms-excel",
    txt: "text/plain",
    text: "text/plain",
    conf: "text/plain",
    log: "text/plain",
    pdf: "application/pdf",
    zip: "application/zip",
    "7z": "application/x-7z-compressed",
    rar: "application/x-rar-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
    dmg: "application/x-apple-diskimage"
};


function $d70a5ddc0e61f36b$export$2e2bcd8739ae039(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in (0, $92507ee89880573c$export$2e2bcd8739ae039)) // else, see if we can map extension to a mime type
    return (0, $92507ee89880573c$export$2e2bcd8739ae039)[fileExtension];
    // if all fails, fall back to a generic byte stream type
    return "application/octet-stream";
}




function $d67267bb9859462b$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $d67267bb9859462b$var$encodeFilename(name) {
    let suffix = "";
    return name.replace(/[^A-Z0-9]/gi, (character)=>{
        suffix += `-${$d67267bb9859462b$var$encodeCharacter(character)}`;
        return "/";
    }) + suffix;
}
function $d67267bb9859462b$export$2e2bcd8739ae039(file, instanceId) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = instanceId || "uppy";
    if (typeof file.name === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === "string") id += `-${$d67267bb9859462b$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
// If the provider has a stable, unique ID, then we can use that to identify the file.
// Then we don't have to generate our own ID, and we can add the same file many times if needed (different path)
function $d67267bb9859462b$var$hasFileStableId(file) {
    if (!file.isRemote || !file.remote) return false;
    // These are the providers that it seems like have stable IDs for their files. The other's I haven't checked yet.
    const stableIdProviders = new Set([
        "box",
        "dropbox",
        "drive",
        "facebook",
        "unsplash"
    ]);
    return stableIdProviders.has(file.remote.provider);
}
function $d67267bb9859462b$export$2ff5b23440673856(file, instanceId) {
    if ($d67267bb9859462b$var$hasFileStableId(file)) return file.id;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    return $d67267bb9859462b$export$2e2bcd8739ae039({
        ...file,
        type: fileType
    }, instanceId);
}


// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
function $d0281443a9bf1cf1$export$2e2bcd8739ae039(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== "undefined") // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
    // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    const version = edgeVersion.split(".", 2);
    const major = parseInt(version[0], 10);
    const minor = parseInt(version[1], 10);
    // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
    // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
    // other versions don't work.
    return false;
}


function $77bbd1edc6b4e0f3$export$2e2bcd8739ae039(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split("/")[0] === "image") return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
    return "noname";
}


/* eslint-disable no-console */ /**
 * Adds zero to strings shorter than two characters.
 */ function $cd89119ba1e2ad9d$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
function $cd89119ba1e2ad9d$export$2e2bcd8739ae039() {
    const date = new Date();
    const hours = $cd89119ba1e2ad9d$var$pad(date.getHours());
    const minutes = $cd89119ba1e2ad9d$var$pad(date.getMinutes());
    const seconds = $cd89119ba1e2ad9d$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}


// Swallow all logs, except errors.
// default if logger is not set or debug: false
const $b03b26a8a191c595$export$51086a57eba987c9 = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};
// Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
const $b03b26a8a191c595$export$e6a390ea6399b7d8 = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${(0, $cd89119ba1e2ad9d$export$2e2bcd8739ae039)()}]`, ...args);
    }
};


/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable max-classes-per-file, class-methods-use-this */ var $06e80194017bcce5$exports = {};
"use strict";
$06e80194017bcce5$exports = function prettierBytes(num) {
    if (typeof num !== "number" || Number.isNaN(num)) throw new TypeError(`Expected a number, got ${typeof num}`);
    const neg = num < 0;
    const units = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    if (neg) num = -num;
    if (num < 1) return `${(neg ? "-" : "") + num} B`;
    const exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    num = Number(num / 1024 ** exponent);
    const unit = units[exponent];
    if (num >= 10 || num % 1 === 0) return `${(neg ? "-" : "") + num.toFixed(0)} ${unit}`;
    return `${(neg ? "-" : "") + num.toFixed(1)} ${unit}`;
};


var $34b5d77a3aae6147$exports = {};
var $bf27c8b296b096af$exports = {};
/* jshint node: true */ "use strict";
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $bf27c8b296b096af$var$WildcardMatcher(text, separator) {
    this.text = text = text || "";
    this.hasWild = ~text.indexOf("*");
    this.separator = separator;
    this.parts = text.split(separator);
}
$bf27c8b296b096af$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || "").split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === "*") continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == "function") {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == "object") {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
$bf27c8b296b096af$exports = function(text, test, separator) {
    var matcher = new $bf27c8b296b096af$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != "undefined") return matcher.match(test);
    return matcher;
};


var $34b5d77a3aae6147$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ $34b5d77a3aae6147$exports = function(target, pattern) {
    function test(pattern) {
        var result = $bf27c8b296b096af$exports(pattern, target, $34b5d77a3aae6147$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(";")[0]) : test;
};


/**
 * The minimal required properties to be present from UppyFile in order to validate it.
 */ const $3044940369c0f03d$export$ba43bf67f3d48107 = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
class $3044940369c0f03d$export$e4d147272ce048a7 extends Error {
    constructor(message, opts){
        var _opts$isUserFacing;
        super(message);
        this.isRestriction = true;
        this.isUserFacing = (_opts$isUserFacing = opts == null ? void 0 : opts.isUserFacing) != null ? _opts$isUserFacing : true;
        if (opts != null && opts.file) this.file = opts.file; // only some restriction errors are related to a particular file
    }
}
class $3044940369c0f03d$export$c464a380a24dd3b8 {
    constructor(getOpts, getI18n){
        this.getI18n = getI18n;
        this.getOpts = ()=>{
            var _opts$restrictions;
            const opts = getOpts();
            if (((_opts$restrictions = opts.restrictions) == null ? void 0 : _opts$restrictions.allowedFileTypes) != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
            return opts;
        };
    }
    // Because these operations are slow, we cannot run them for every file (if we are adding multiple files)
    validateAggregateRestrictions(existingFiles, addingFiles) {
        const { maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles } = this.getOpts().restrictions;
        if (maxNumberOfFiles) {
            const nonGhostFiles = existingFiles.filter((f)=>!f.isGhost);
            if (nonGhostFiles.length + addingFiles.length > maxNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(`${this.getI18n()("youCanOnlyUploadX", {
                smart_count: maxNumberOfFiles
            })}`);
        }
        if (maxTotalFileSize) {
            const totalFilesSize = [
                ...existingFiles,
                ...addingFiles
            ].reduce((total, f)=>{
                var _f$size;
                return total + ((_f$size = f.size) != null ? _f$size : 0);
            }, 0);
            if (totalFilesSize > maxTotalFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("aggregateExceedsSize", {
                sizeAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxTotalFileSize),
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalFilesSize)
            }));
        }
    }
    validateSingleFile(file) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes("/")) {
                    if (!file.type) return false;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($34b5d77a3aae6147$exports)))(file.type.replace(/;.*?$/, ""), type);
                }
                // otherwise this is likely an extension
                if (type[0] === "." && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(", ");
                throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("youCanOnlyUploadFileTypes", {
                    types: allowedFileTypesString
                }), {
                    file: file
                });
            }
        }
        // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) {
            var _file$name;
            throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("exceedsSize", {
                size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(maxFileSize),
                file: (_file$name = file.name) != null ? _file$name : this.getI18n()("unnamed")
            }), {
                file: file
            });
        }
        // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("inferiorSize", {
            size: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(minFileSize)
        }), {
            file: file
        });
    }
    validate(existingFiles, addingFiles) {
        addingFiles.forEach((addingFile)=>{
            this.validateSingleFile(addingFile);
        });
        this.validateAggregateRestrictions(existingFiles, addingFiles);
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (minNumberOfFiles && Object.keys(files).length < minNumberOfFiles) throw new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("youHaveToAtLeastSelectX", {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        var _file$name2;
        const error = new $3044940369c0f03d$export$e4d147272ce048a7(this.getI18n()("missingRequiredMetaFieldOnFile", {
            fileName: (_file$name2 = file.name) != null ? _file$name2 : this.getI18n()("unnamed")
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!Object.hasOwn(file.meta, field) || file.meta[field] === "") missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}


var $721644b39e57ffe9$export$2e2bcd8739ae039 = {
    strings: {
        addBulkFilesFailed: {
            0: "Failed to add %{smart_count} file due to an internal error",
            1: "Failed to add %{smart_count} files due to internal errors"
        },
        youCanOnlyUploadX: {
            0: "You can only upload %{smart_count} file",
            1: "You can only upload %{smart_count} files"
        },
        youHaveToAtLeastSelectX: {
            0: "You have to select at least %{smart_count} file",
            1: "You have to select at least %{smart_count} files"
        },
        aggregateExceedsSize: "You selected %{size} of files, but maximum allowed size is %{sizeAllowed}",
        exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
        missingRequiredMetaField: "Missing required meta fields",
        missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
        inferiorSize: "This file is smaller than the allowed size of %{size}",
        youCanOnlyUploadFileTypes: "You can only upload: %{types}",
        noMoreFilesAllowed: "Cannot add more files",
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: "Connection with Companion failed",
        authAborted: "Authentication aborted",
        companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
        failedToUpload: "Failed to upload %{file}",
        noInternetConnection: "No Internet connection",
        connectedToInternet: "Connected to the Internet",
        // Strings for remote providers
        noFilesFound: "You have no files or folders here",
        noSearchResults: "Unfortunately, there are no results for this search",
        selectX: {
            0: "Select %{smart_count}",
            1: "Select %{smart_count}"
        },
        allFilesFromFolderNamed: "All files from folder %{name}",
        openFolderNamed: "Open folder %{name}",
        cancel: "Cancel",
        logOut: "Log out",
        logIn: "Log in",
        pickFiles: "Pick files",
        pickPhotos: "Pick photos",
        filter: "Filter",
        resetFilter: "Reset filter",
        loading: "Loading...",
        loadedXFiles: "Loaded %{numFiles} files",
        authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
        authenticateWith: "Connect to %{pluginName}",
        signInWithGoogle: "Sign in with Google",
        searchImages: "Search for images",
        enterTextToSearch: "Enter text to search for images",
        search: "Search",
        resetSearch: "Reset search",
        emptyFolderAdded: "No files were added from empty folder",
        addedNumFiles: "Added %{numFiles} file(s)",
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: "Added %{smart_count} file from %{folder}",
            1: "Added %{smart_count} files from %{folder}"
        },
        additionalRestrictionsFailed: "%{count} additional restrictions were not fulfilled",
        unnamed: "Unnamed",
        pleaseWait: "Please wait"
    }
};


function $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $b16b91c7840d3bff$var$id = 0;
function $b16b91c7840d3bff$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $b16b91c7840d3bff$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b16b91c7840d3bff$var$packageJson = {
    "version": "4.4.7"
};
/**
 * ids are always `string`s, except the root folder's id can be `null`
 */ /**
 * PartialTree has the following structure.
 *
 *           FolderRoot
 *         ┌─────┴─────┐
 *     FolderNode     File
 *   ┌─────┴────┐
 *  File      File
 *
 * Root folder is called `PartialTreeFolderRoot`,
 * all other folders are called `PartialTreeFolderNode`, because they are "internal nodes".
 *
 * It's possible for `PartialTreeFolderNode` to be a leaf node if it doesn't contain any files.
 */ /**
 * This is a base for a provider that does not necessarily use the Companion-assisted OAuth2 flow
 */ /*
 * UnknownProviderPlugin can be any Companion plugin (such as Google Drive)
 * that uses the Companion-assisted OAuth flow.
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `storage`
 * will error in the `Provider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `Provider` class.
 * `Provider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ /*
 * UnknownSearchProviderPlugin can be any search Companion plugin (such as Unsplash).
 * As the plugins are passed around throughout Uppy we need a generic type for this.
 * It may seems like duplication, but this type safe. Changing the type of `title`
 * will error in the `SearchProvider` class of @uppy/companion-client and vice versa.
 *
 * Note that this is the *plugin* class, not a version of the `SearchProvider` class.
 * `SearchProvider` does operate on Companion plugins with `uppy.getPlugin()`.
 */ // TODO: can we use namespaces in other plugins to populate this?
// eslint-disable-next-line @typescript-eslint/no-empty-interface
// The user facing type for UppyOptions used in uppy.setOptions()
/** `OmitFirstArg<typeof someArray>` is the type of the returned value of `someArray.slice(1)`. */ const $b16b91c7840d3bff$var$defaultUploadState = {
    totalProgress: 0,
    allowNewUpload: true,
    error: null,
    recoveredState: null
};
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $b16b91c7840d3bff$var$_plugins = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("plugins");
var $b16b91c7840d3bff$var$_restricter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("restricter");
var $b16b91c7840d3bff$var$_storeUnsubscribe = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $b16b91c7840d3bff$var$_emitter = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("emitter");
var $b16b91c7840d3bff$var$_preProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("preProcessors");
var $b16b91c7840d3bff$var$_uploaders = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("uploaders");
var $b16b91c7840d3bff$var$_postProcessors = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("postProcessors");
var $b16b91c7840d3bff$var$_informAndEmit = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("informAndEmit");
var $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $b16b91c7840d3bff$var$_checkRequiredMetaFields = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $b16b91c7840d3bff$var$_assertNewUploadAllowed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $b16b91c7840d3bff$var$_transformFile = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("transformFile");
var $b16b91c7840d3bff$var$_startIfAutoProceed = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $b16b91c7840d3bff$var$_checkAndUpdateFileState = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("checkAndUpdateFileState");
var $b16b91c7840d3bff$var$_getFilesToRetry = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getFilesToRetry");
var $b16b91c7840d3bff$var$_doRetryAll = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("doRetryAll");
var $b16b91c7840d3bff$var$_handleUploadProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("handleUploadProgress");
var $b16b91c7840d3bff$var$_updateTotalProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateTotalProgress");
var $b16b91c7840d3bff$var$_updateTotalProgressThrottled = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateTotalProgressThrottled");
var $b16b91c7840d3bff$var$_calculateTotalProgress = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("calculateTotalProgress");
var $b16b91c7840d3bff$var$_addListeners = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("addListeners");
var $b16b91c7840d3bff$var$_updateOnlineStatus = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $b16b91c7840d3bff$var$_requestClientById = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("requestClientById");
var $b16b91c7840d3bff$var$_createUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("createUpload");
var $b16b91c7840d3bff$var$_getUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("getUpload");
var $b16b91c7840d3bff$var$_removeUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("removeUpload");
var $b16b91c7840d3bff$var$_runUpload = /*#__PURE__*/ $b16b91c7840d3bff$var$_classPrivateFieldLooseKey("runUpload");
class $b16b91c7840d3bff$export$1c95bea2669f592b {
    /**
   * Instantiate Uppy
   */ constructor(_opts){
        /**
     * Run an upload. This picks up where it left off in case the upload is being restored.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_runUpload, {
            value: $b16b91c7840d3bff$var$_runUpload2
        });
        /**
     * Remove an upload, eg. if it has been canceled or completed.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_removeUpload, {
            value: $b16b91c7840d3bff$var$_removeUpload2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getUpload, {
            value: $b16b91c7840d3bff$var$_getUpload2
        });
        /**
     * Create an upload for a bunch of files.
     *
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_createUpload, {
            value: $b16b91c7840d3bff$var$_createUpload2
        });
        /**
     * Registers listeners for all global actions, like:
     * `error`, `file-removed`, `upload-progress`
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_addListeners, {
            value: $b16b91c7840d3bff$var$_addListeners2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_calculateTotalProgress, {
            value: $b16b91c7840d3bff$var$_calculateTotalProgress2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateTotalProgress, {
            value: $b16b91c7840d3bff$var$_updateTotalProgress2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_doRetryAll, {
            value: $b16b91c7840d3bff$var$_doRetryAll2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_getFilesToRetry, {
            value: $b16b91c7840d3bff$var$_getFilesToRetry2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState, {
            value: $b16b91c7840d3bff$var$_checkAndUpdateFileState2
        });
        // Schedule an upload if `autoProceed` is enabled.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_startIfAutoProceed, {
            value: $b16b91c7840d3bff$var$_startIfAutoProceed2
        });
        /**
     * Create a file state object based on user-provided `addFile()` options.
     */ Object.defineProperty(this, $b16b91c7840d3bff$var$_transformFile, {
            value: $b16b91c7840d3bff$var$_transformFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed, {
            value: $b16b91c7840d3bff$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile, {
            value: $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_informAndEmit, {
            value: $b16b91c7840d3bff$var$_informAndEmit2
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_emitter, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1713863f3a962559$exports)))()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        this.scheduledAutoProceed = null;
        this.wasOffline = false;
        Object.defineProperty(this, $b16b91c7840d3bff$var$_handleUploadProgress, {
            writable: true,
            value: (file, progress)=>{
                const fileInState = file ? this.getFile(file.id) : undefined;
                if (file == null || !fileInState) {
                    this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
                    return;
                }
                if (fileInState.progress.percentage === 100) {
                    this.log(`Not setting progress for a file that has been already uploaded: ${file.id}`);
                    return;
                }
                const newProgress = {
                    bytesTotal: progress.bytesTotal,
                    // bytesTotal may be null or zero; in that case we can't divide by it
                    percentage: progress.bytesTotal != null && Number.isFinite(progress.bytesTotal) && progress.bytesTotal > 0 ? Math.round(progress.bytesUploaded / progress.bytesTotal * 100) : undefined
                };
                if (fileInState.progress.uploadStarted != null) this.setFileState(file.id, {
                    progress: {
                        ...fileInState.progress,
                        ...newProgress,
                        bytesUploaded: progress.bytesUploaded
                    }
                });
                else this.setFileState(file.id, {
                    progress: {
                        ...fileInState.progress,
                        ...newProgress
                    }
                });
                $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
            }
        });
        // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled, {
            writable: true,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($a50c1ad1c2867517$exports)))(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgress)[$b16b91c7840d3bff$var$_updateTotalProgress](), 500, {
                leading: true,
                trailing: true
            })
        });
        Object.defineProperty(this, $b16b91c7840d3bff$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        // We need to store request clients by a unique ID, so we can share RequestClient instances across files
        // this allows us to do rate limiting and synchronous operations like refreshing provider tokens
        // example: refreshing tokens: if each file has their own requestclient,
        // we don't have any way to synchronize all requests in order to
        // - block all requests
        // - refresh the token
        // - unblock all requests and allow them to run with a the new access token
        // back when we had a requestclient per file, once an access token expired,
        // all 6 files would go ahead and refresh the token at the same time
        // (calling /refresh-token up to 6 times), which will probably fail for some providers
        Object.defineProperty(this, $b16b91c7840d3bff$var$_requestClientById, {
            writable: true,
            value: new Map()
        });
        this.defaultLocale = (0, $721644b39e57ffe9$export$2e2bcd8739ae039);
        const defaultOptions = {
            id: "uppy",
            autoProceed: false,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: (0, $3044940369c0f03d$export$ba43bf67f3d48107),
            meta: {},
            onBeforeFileAdded: (file, files)=>!Object.hasOwn(files, file.id),
            onBeforeUpload: (files)=>files,
            store: new (0, $f790bad313c52a0f$export$2e2bcd8739ae039)(),
            logger: (0, $b03b26a8a191c595$export$51086a57eba987c9),
            infoTimeout: 5000
        };
        const merged = {
            ...defaultOptions,
            ..._opts
        };
        // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...merged,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        };
        // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
        else if (_opts && _opts.debug) this.opts.logger = (0, $b03b26a8a191c595$export$e6a390ea6399b7d8);
        this.log(`Using Core v${$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION}`);
        this.i18nInit();
        this.store = this.opts.store;
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            plugins: {},
            files: {},
            currentUploads: {},
            capabilities: {
                uploadProgress: (0, $d0281443a9bf1cf1$export$2e2bcd8739ae039)(),
                individualCancellation: true,
                resumableUploads: false
            },
            meta: {
                ...this.opts.meta
            },
            info: []
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter] = new (0, $3044940369c0f03d$export$c464a380a24dd3b8)(()=>this.opts, ()=>this.i18n);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe] = this.store.subscribe((prevState, nextState, patch)=>{
            this.emit("state-update", prevState, nextState, patch);
            this.updateAll(nextState);
        });
        // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== "undefined") // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore Mutating the global object for debug purposes
        window[this.opts.id] = this;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_addListeners)[$b16b91c7840d3bff$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_emitter)[$b16b91c7840d3bff$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   */ setState(patch) {
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   */ getState() {
        return this.store.getState();
    }
    patchFilesState(filesWithNewState) {
        const existingFilesState = this.getState().files;
        this.setState({
            files: {
                ...existingFilesState,
                ...Object.fromEntries(Object.entries(filesWithNewState).map((_ref)=>{
                    let [fileID, newFileState] = _ref;
                    return [
                        fileID,
                        {
                            ...existingFilesState[fileID],
                            ...newFileState
                        }
                    ];
                }))
            }
        });
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.patchFilesState({
            [fileID]: state
        });
    }
    i18nInit() {
        const onMissingKey = (key)=>this.log(`Missing i18n string: ${key}`, "error");
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.opts.locale
        ], {
            onMissingKey: onMissingKey
        });
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts == null ? void 0 : newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions(newOpts);
        });
        // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(undefined); // so that UI re-renders with new options
    }
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: false,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = Object.create(null);
        Object.keys(files).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...files[fileID],
                progress: {
                    ...files[fileID].progress,
                    ...defaultProgress
                },
                // @ts-expect-error these typed are inserted
                // into the namespace in their respective packages
                // but core isn't ware of those
                tus: undefined,
                transloadit: undefined
            };
        });
        this.setState({
            files: updatedFiles,
            ...$b16b91c7840d3bff$var$defaultUploadState
        });
    }
    clear() {
        const { capabilities: capabilities, currentUploads: currentUploads } = this.getState();
        if (Object.keys(currentUploads).length > 0 && !capabilities.individualCancellation) throw new Error("The installed uploader plugin does not allow removing files during an upload.");
        this.setState({
            ...$b16b91c7840d3bff$var$defaultUploadState,
            files: {}
        });
    }
    addPreProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log("Adding metadata:");
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log(`Was trying to set metadata for a file that has been removed: ${fileID}`);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getFilesByIds(ids) {
        return ids.map((id)=>this.getFile(id));
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = [];
        const newFiles = [];
        const startedFiles = [];
        const uploadStartedFiles = [];
        const pausedFiles = [];
        const completeFiles = [];
        const erroredFiles = [];
        const inProgressNotPausedFiles = [];
        const processingFiles = [];
        for (const file of files){
            const { progress: progress } = file;
            if (!progress.uploadComplete && progress.uploadStarted) {
                inProgressFiles.push(file);
                if (!file.isPaused) inProgressNotPausedFiles.push(file);
            }
            if (!progress.uploadStarted) newFiles.push(file);
            if (progress.uploadStarted || progress.preprocess || progress.postprocess) startedFiles.push(file);
            if (progress.uploadStarted) uploadStartedFiles.push(file);
            if (file.isPaused) pausedFiles.push(file);
            if (progress.uploadComplete) completeFiles.push(file);
            if (file.error) erroredFiles.push(file);
            if (progress.preprocess || progress.postprocess) processingFiles.push(file);
        }
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validate(files, [
                file
            ]);
        } catch (err) {
            return err;
        }
        return null;
    }
    validateSingleFile(file) {
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(file);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    validateAggregateRestrictions(files) {
        const existingFiles = this.getFiles();
        try {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(existingFiles, files);
        } catch (err) {
            return err.message;
        }
        return null;
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   */ addFile(file) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed](file);
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState]([
            file
        ]);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        if (errors.length > 0) throw errors[0];
        this.setState({
            files: nextFilesState
        });
        const [firstValidFileToAdd] = validFilesToAdd;
        this.emit("file-added", firstValidFileToAdd);
        this.emit("files-added", validFilesToAdd);
        this.log(`Added file: ${firstValidFileToAdd.name}, ${firstValidFileToAdd.id}, mime type: ${firstValidFileToAdd.type}`);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
        return firstValidFileToAdd.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_assertNewUploadAllowed)[$b16b91c7840d3bff$var$_assertNewUploadAllowed]();
        const { nextFilesState: nextFilesState, validFilesToAdd: validFilesToAdd, errors: errors } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkAndUpdateFileState)[$b16b91c7840d3bff$var$_checkAndUpdateFileState](fileDescriptors);
        const restrictionErrors = errors.filter((error)=>error.isRestriction);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit](restrictionErrors);
        const nonRestrictionErrors = errors.filter((error)=>!error.isRestriction);
        if (nonRestrictionErrors.length > 0) {
            let message = "Multiple errors occurred while adding files:\n";
            nonRestrictionErrors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n("addBulkFilesFailed", {
                    smart_count: nonRestrictionErrors.length
                }),
                details: message
            }, "error", this.opts.infoTimeout);
            if (typeof AggregateError === "function") throw new AggregateError(nonRestrictionErrors, message);
            else {
                const err = new Error(message);
                // @ts-expect-error fallback when AggregateError is not available
                err.errors = nonRestrictionErrors;
                throw err;
            }
        }
        // OK, we haven't thrown an error, we can start updating state and emitting events now:
        this.setState({
            files: nextFilesState
        });
        validFilesToAdd.forEach((file)=>{
            this.emit("file-added", file);
        });
        this.emit("files-added", validFilesToAdd);
        if (validFilesToAdd.length > 5) this.log(`Added batch of ${validFilesToAdd.length} files`);
        else Object.values(validFilesToAdd).forEach((file)=>{
            this.log(`Added file: ${file.name}\n id: ${file.id}\n type: ${file.type}`);
        });
        if (validFilesToAdd.length > 0) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_startIfAutoProceed)[$b16b91c7840d3bff$var$_startIfAutoProceed]();
    }
    removeFiles(fileIDs) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        });
        // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved);
            // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error("The installed uploader plugin does not allow removing files during an upload.");
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        };
        // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit("file-removed", removedFiles[fileID]);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
    removeFile(fileID) {
        this.removeFiles([
            fileID
        ]);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).progress.uploadComplete) return undefined;
        const file = this.getFile(fileID);
        const wasPaused = file.isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit("upload-pause", file, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("pause-all");
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("resume-all");
    }
    async retryAll() {
        const result = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_doRetryAll)[$b16b91c7840d3bff$var$_doRetryAll]();
        this.emit("complete", result);
        return result;
    }
    cancelAll() {
        this.emit("cancel-all");
        const { files: files } = this.getState();
        const fileIDs = Object.keys(files);
        if (fileIDs.length) this.removeFiles(fileIDs);
        this.setState($b16b91c7840d3bff$var$defaultUploadState);
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit("upload-retry", this.getFile(fileID));
        const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            var _provider;
            (_provider = plugin.provider) == null || _provider.logout == null || _provider.logout();
        });
    }
    // eslint-disable-next-line class-methods-use-this, @typescript-eslint/explicit-module-boundary-types
    [Symbol.for("uppy test: updateTotalProgress")]() {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgress)[$b16b91c7840d3bff$var$_updateTotalProgress]();
    }
    updateOnlineStatus() {
        var _window$navigator$onL;
        const online = (_window$navigator$onL = window.navigator.onLine) != null ? _window$navigator$onL : true;
        if (!online) {
            this.emit("is-offline");
            this.info(this.i18n("noInternetConnection"), "error", 0);
            this.wasOffline = true;
        } else {
            this.emit("is-online");
            if (this.wasOffline) {
                this.emit("back-online");
                this.info(this.i18n("connectedToInternet"), "success", 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   */ use(Plugin) {
        if (typeof Plugin !== "function") {
            const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}.` + " Please verify that the plugin was imported and spelled correctly.";
            throw new TypeError(msg);
        }
        // Instantiate
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        const plugin = new Plugin(this, ...args);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error("Your plugin must have an id");
        if (!plugin.type) throw new Error("Your plugin must have a type");
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + "Uppy plugins must have unique `id` options.";
            throw new Error(msg);
        }
        // @ts-expect-error does exist
        if (Plugin.VERSION) // @ts-expect-error does exist
        this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type].push(plugin);
        else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        this.emit("plugin-added", plugin);
        return this;
    }
    /**
   * Find one Plugin by name.
   */ getPlugin(id) {
        for (const plugins of Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [Symbol.for("uppy test: getPlugins")](type) {
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   */ iteratePlugins(method) {
        Object.values($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit("plugin-remove", instance);
        if (instance.uninstall) instance.uninstall();
        const list = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins][instance.type];
        // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ destroy() {
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll();
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_storeUnsubscribe)[$b16b91c7840d3bff$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
            window.removeEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit("info-hidden");
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   */ info(message, type, duration) {
        if (type === void 0) type = "info";
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === "object";
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit("info-visible");
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case "error":
                logger.error(message);
                break;
            case "warning":
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    registerRequestClient(id, client) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].set(id, client);
    }
    /** @protected */ getRequestClientForFile(file) {
        if (!file.remote) throw new Error(`Tried to get RequestClient for a non-remote file ${file.id}`);
        const requestClient = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_requestClientById)[$b16b91c7840d3bff$var$_requestClientById].get(file.remote.requestClientId);
        if (requestClient == null) throw new Error(`requestClientId "${file.remote.requestClientId}" not registered for file "${file.id}"`);
        return requestClient;
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
            return Promise.reject(new Error("Nonexistent upload"));
        }
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
    }
    [Symbol.for("uppy test: createUpload")]() {
        // @ts-expect-error https://github.com/microsoft/TypeScript/issues/47595
        return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   */ addResultData(uploadID, data) {
        if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getUpload)[$b16b91c7840d3bff$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Start an upload for all the files that are not currently being uploaded.
   */ async upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_plugins)[$b16b91c7840d3bff$var$_plugins]["uploader"]) != null && _classPrivateFieldLoo.length)) this.log("No uploader type plugins are used", "warning");
        let { files: files } = this.getState();
        // retry any failed files from a previous upload() call
        const filesToRetry = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getFilesToRetry)[$b16b91c7840d3bff$var$_getFilesToRetry]();
        if (filesToRetry.length > 0) {
            const retryResult = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_doRetryAll)[$b16b91c7840d3bff$var$_doRetryAll](); // we don't want the complete event to fire
            const hasNewFiles = this.getFiles().filter((file)=>file.progress.uploadStarted == null).length > 0;
            // if no new files, make it idempotent and return
            if (!hasNewFiles) {
                this.emit("complete", retryResult);
                return retryResult;
            }
            ({ files: files } = this.getState());
        }
        // If no files to retry, proceed with original upload() behavior for new files
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
            files = onBeforeUploadResult;
            // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                err
            ]);
            throw err;
        }).then(()=>{
            if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFields)[$b16b91c7840d3bff$var$_checkRequiredMetaFields](files)) throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("missingRequiredMetaField"));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(async ()=>{
            const { currentUploads: currentUploads } = this.getState();
            // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID);
                // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](waitingFileIDs);
            const result = await $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
            this.emit("complete", result);
            return result;
        }).catch((err)=>{
            this.emit("error", err);
            this.log(err, "error");
            throw err;
        });
    }
}
function $b16b91c7840d3bff$var$_informAndEmit2(errors) {
    for (const error of errors){
        if (error.isRestriction) this.emit("restriction-failed", error.file, error);
        else this.emit("error", error, error.file);
        this.log(error, "warning");
    }
    const userFacingErrors = errors.filter((error)=>error.isUserFacing);
    // don't flood the user: only show the first 4 toasts
    const maxNumToShow = 4;
    const firstErrors = userFacingErrors.slice(0, maxNumToShow);
    const additionalErrors = userFacingErrors.slice(maxNumToShow);
    firstErrors.forEach((_ref2)=>{
        let { message: message, details: details = "" } = _ref2;
        this.info({
            message: message,
            details: details
        }, "error", this.opts.infoTimeout);
    });
    if (additionalErrors.length > 0) this.info({
        message: this.i18n("additionalRestrictionsFailed", {
            count: additionalErrors.length
        })
    });
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit("restriction-failed", file, error);
        return false;
    }
    if (missingFields.length === 0 && file.missingRequiredMetaFields) this.setFileState(file.id, {
        missingRequiredMetaFields: []
    });
    return true;
}
function $b16b91c7840d3bff$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $b16b91c7840d3bff$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noMoreFilesAllowed"), {
            file: file
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
        throw error;
    }
}
function $b16b91c7840d3bff$var$_transformFile2(fileDescriptorOrFile) {
    // Uppy expects files in { name, type, size, data } format.
    // If the actual File object is passed from input[type=file] or drag-drop,
    // we normalize it to match Uppy file object
    const file = fileDescriptorOrFile instanceof File ? {
        name: fileDescriptorOrFile.name,
        type: fileDescriptorOrFile.type,
        size: fileDescriptorOrFile.size,
        data: fileDescriptorOrFile
    } : fileDescriptorOrFile;
    const fileType = (0, $d70a5ddc0e61f36b$export$2e2bcd8739ae039)(file);
    const fileName = (0, $77bbd1edc6b4e0f3$export$2e2bcd8739ae039)(fileType, file);
    const fileExtension = (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(fileName).extension;
    const id = (0, $d67267bb9859462b$export$2ff5b23440673856)(file, this.getID());
    const meta = file.meta || {};
    meta.name = fileName;
    meta.type = fileType;
    // `null` means the size is unknown.
    const size = Number.isFinite(file.data.size) ? file.data.size : null;
    return {
        source: file.source || "",
        id: id,
        name: fileName,
        extension: fileExtension || "",
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: file.data,
        progress: {
            percentage: 0,
            bytesUploaded: false,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isGhost: false,
        isRemote: file.isRemote || false,
        remote: file.remote,
        preview: file.preview
    };
}
function $b16b91c7840d3bff$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $b16b91c7840d3bff$var$_checkAndUpdateFileState2(filesToAdd) {
    const { files: existingFiles } = this.getState();
    // create a copy of the files object only once
    const nextFilesState = {
        ...existingFiles
    };
    const validFilesToAdd = [];
    const errors = [];
    for (const fileToAdd of filesToAdd)try {
        var _existingFiles$newFil;
        let newFile = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_transformFile)[$b16b91c7840d3bff$var$_transformFile](fileToAdd);
        // If a file has been recovered (Golden Retriever), but we were unable to recover its data (probably too large),
        // users are asked to re-select these half-recovered files and then this method will be called again.
        // In order to keep the progress, meta and everything else, we keep the existing file,
        // but we replace `data`, and we remove `isGhost`, because the file is no longer a ghost now
        const isGhost = (_existingFiles$newFil = existingFiles[newFile.id]) == null ? void 0 : _existingFiles$newFil.isGhost;
        if (isGhost) {
            const existingFileState = existingFiles[newFile.id];
            newFile = {
                ...existingFileState,
                isGhost: false,
                data: fileToAdd.data
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, nextFilesState);
        if (!onBeforeFileAddedResult && this.checkIfFileAlreadyExists(newFile.id)) {
            var _newFile$name;
            throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)(this.i18n("noDuplicates", {
                fileName: (_newFile$name = newFile.name) != null ? _newFile$name : this.i18n("unnamed")
            }), {
                file: fileToAdd
            });
        }
        // Pass through reselected files from Golden Retriever
        if (onBeforeFileAddedResult === false && !isGhost) // Don’t show UI info for this error, as it should be done by the developer
        throw new (0, $3044940369c0f03d$export$e4d147272ce048a7)("Cannot add the file because onBeforeFileAdded returned false.", {
            isUserFacing: false,
            file: fileToAdd
        });
        else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateSingleFile(newFile);
        // need to add it to the new local state immediately, so we can use the state to validate the next files too
        nextFilesState[newFile.id] = newFile;
        validFilesToAdd.push(newFile);
    } catch (err) {
        errors.push(err);
    }
    try {
        // need to run this separately because it's much more slow, so if we run it inside the for-loop it will be very slow
        // when many files are added
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_restricter)[$b16b91c7840d3bff$var$_restricter].validateAggregateRestrictions(Object.values(existingFiles), validFilesToAdd);
    } catch (err) {
        errors.push(err);
        // If we have any aggregate error, don't allow adding this batch
        return {
            nextFilesState: existingFiles,
            validFilesToAdd: [],
            errors: errors
        };
    }
    return {
        nextFilesState: nextFilesState,
        validFilesToAdd: validFilesToAdd,
        errors: errors
    };
}
function $b16b91c7840d3bff$var$_getFilesToRetry2() {
    const { files: files } = this.getState();
    return Object.keys(files).filter((file)=>{
        return files[file].error;
    });
}
async function $b16b91c7840d3bff$var$_doRetryAll2() {
    const filesToRetry = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_getFilesToRetry)[$b16b91c7840d3bff$var$_getFilesToRetry]();
    const updatedFiles = {
        ...this.getState().files
    };
    filesToRetry.forEach((fileID)=>{
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            isPaused: false,
            error: null
        };
    });
    this.setState({
        files: updatedFiles,
        error: null
    });
    this.emit("retry-all", this.getFilesByIds(filesToRetry));
    if (filesToRetry.length === 0) return {
        successful: [],
        failed: []
    };
    const uploadID = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_createUpload)[$b16b91c7840d3bff$var$_createUpload](filesToRetry, {
        forceAllowNewUpload: true // create new upload even if allowNewUpload: false
    });
    return $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_runUpload)[$b16b91c7840d3bff$var$_runUpload](uploadID);
}
function $b16b91c7840d3bff$var$_updateTotalProgress2() {
    var _totalProgressPercent, _totalProgressPercent2;
    const totalProgress = $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_calculateTotalProgress)[$b16b91c7840d3bff$var$_calculateTotalProgress]();
    let totalProgressPercent = null;
    if (totalProgress != null) {
        totalProgressPercent = Math.round(totalProgress * 100);
        if (totalProgressPercent > 100) totalProgressPercent = 100;
        else if (totalProgressPercent < 0) totalProgressPercent = 0;
    }
    this.emit("progress", (_totalProgressPercent = totalProgressPercent) != null ? _totalProgressPercent : 0);
    this.setState({
        totalProgress: (_totalProgressPercent2 = totalProgressPercent) != null ? _totalProgressPercent2 : 0
    });
}
function $b16b91c7840d3bff$var$_calculateTotalProgress2() {
    // calculate total progress, using the number of files currently uploading,
    // between 0 and 1 and sum of individual progress of each file
    const files = this.getFiles();
    // note: also includes files that have completed uploading:
    const filesInProgress = files.filter((file)=>{
        return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
    });
    if (filesInProgress.length === 0) return 0;
    if (filesInProgress.every((file)=>file.progress.uploadComplete)) // If every uploading file is complete, and we're still getting progress, it probably means
    // there's a bug somewhere in some progress reporting code (maybe not even our code)
    // and we're still getting progress, so let's just assume it means a 100% progress
    return 1;
    const isSizedFile = (file)=>file.progress.bytesTotal != null && file.progress.bytesTotal !== 0;
    const sizedFilesInProgress = filesInProgress.filter(isSizedFile);
    const unsizedFilesInProgress = filesInProgress.filter((file)=>!isSizedFile(file));
    if (sizedFilesInProgress.every((file)=>file.progress.uploadComplete) && unsizedFilesInProgress.length > 0 && !unsizedFilesInProgress.every((file)=>file.progress.uploadComplete)) // we are done with uploading all files of known size, however
    // there is at least one file with unknown size still uploading,
    // and we cannot say anything about their progress
    // In any case, return null because it doesn't make any sense to show a progress
    return null;
    const totalFilesSize = sizedFilesInProgress.reduce((acc, file)=>{
        var _file$progress$bytesT;
        return acc + ((_file$progress$bytesT = file.progress.bytesTotal) != null ? _file$progress$bytesT : 0);
    }, 0);
    const totalUploadedSize = sizedFilesInProgress.reduce((acc, file)=>acc + (file.progress.bytesUploaded || 0), 0);
    return totalFilesSize === 0 ? 0 : totalUploadedSize / totalFilesSize;
}
function $b16b91c7840d3bff$var$_addListeners2() {
    // Type inference only works for inline functions so we have to type it again
    const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || "Unknown error";
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on("error", errorHandler);
    this.on("upload-error", (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === "object" && error.message) {
            var _file$name;
            this.log(error.message, "error");
            const newError = new Error(this.i18n("failedToUpload", {
                file: (_file$name = file == null ? void 0 : file.name) != null ? _file$name : ""
            })); // we may want a new custom error here
            newError.isUserFacing = true; // todo maybe don't do this with all errors?
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
                newError
            ]);
        } else $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_informAndEmit)[$b16b91c7840d3bff$var$_informAndEmit]([
            error
        ]);
    });
    let uploadStalledWarningRecentlyEmitted = null;
    this.on("upload-stalled", (error, files)=>{
        const { message: message } = error;
        const details = files.map((file)=>file.meta.name).join(", ");
        if (!uploadStalledWarningRecentlyEmitted) {
            this.info({
                message: message,
                details: details
            }, "warning", this.opts.infoTimeout);
            uploadStalledWarningRecentlyEmitted = setTimeout(()=>{
                uploadStalledWarningRecentlyEmitted = null;
            }, this.opts.infoTimeout);
        }
        this.log(`${message} ${details}`.trim(), "warning");
    });
    this.on("upload", ()=>{
        this.setState({
            error: null
        });
    });
    const onUploadStarted = (files)=>{
        const filesFiltered = files.filter((file)=>{
            const exists = file != null && this.getFile(file.id);
            if (!exists) this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return exists;
        });
        const filesState = Object.fromEntries(filesFiltered.map((file)=>[
                file.id,
                {
                    progress: {
                        uploadStarted: Date.now(),
                        uploadComplete: false,
                        bytesUploaded: 0,
                        bytesTotal: file.size
                    }
                }
            ]));
        this.patchFilesState(filesState);
    };
    this.on("upload-start", onUploadStarted);
    this.on("upload-progress", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_handleUploadProgress)[$b16b91c7840d3bff$var$_handleUploadProgress]);
    this.on("upload-success", (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors].size > 0 ? {
                    mode: "indeterminate"
                } : undefined,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        });
        // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
    });
    this.on("preprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on("preprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on("postprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on("postprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on("restored", ()=>{
        // Files may have changed--ensure progress is still accurate.
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateTotalProgressThrottled)[$b16b91c7840d3bff$var$_updateTotalProgressThrottled]();
    });
    // @ts-expect-error should fix itself when dashboard it typed (also this doesn't belong here)
    this.on("dashboard:file-edit-complete", (file)=>{
        if (file) $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile)[$b16b91c7840d3bff$var$_checkRequiredMetaFieldsOnFile](file);
    });
    // show informer if offline
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("online", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        window.addEventListener("offline", $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus]);
        setTimeout($b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_updateOnlineStatus)[$b16b91c7840d3bff$var$_updateOnlineStatus], 3000);
    }
}
function $b16b91c7840d3bff$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error("Cannot create a new upload: already uploading.");
    const uploadID = (0, $3c82c89e950acc97$export$ac4959f4f1338dfc)();
    this.emit("upload", uploadID, this.getFilesByIds(fileIDs));
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $b16b91c7840d3bff$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $b16b91c7840d3bff$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $b16b91c7840d3bff$var$_runUpload2(uploadID) {
    const getCurrentUpload = ()=>{
        const { currentUploads: currentUploads } = this.getState();
        return currentUploads[uploadID];
    };
    let currentUpload = getCurrentUpload();
    const steps = [
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_preProcessors)[$b16b91c7840d3bff$var$_preProcessors],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_uploaders)[$b16b91c7840d3bff$var$_uploaders],
        ...$b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_postProcessors)[$b16b91c7840d3bff$var$_postProcessors]
    ];
    try {
        for(let step = currentUpload.step || 0; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            this.setState({
                currentUploads: {
                    ...this.getState().currentUploads,
                    [uploadID]: {
                        ...currentUpload,
                        step: step
                    }
                }
            });
            const { fileIDs: fileIDs } = currentUpload;
            // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(fileIDs, uploadID);
            // Update currentUpload value in case it was modified asynchronously.
            currentUpload = getCurrentUpload();
        }
    } catch (err) {
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
        throw err;
    }
    // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit("postprocess-complete", file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        });
        // Update currentUpload value in case it was modified asynchronously.
        currentUpload = getCurrentUpload();
    }
    // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        $b16b91c7840d3bff$var$_classPrivateFieldLooseBase(this, $b16b91c7840d3bff$var$_removeUpload)[$b16b91c7840d3bff$var$_removeUpload](uploadID);
    }
    if (result == null) {
        this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
        result = {
            successful: [],
            failed: [],
            uploadID: uploadID
        };
    }
    return result;
}
$b16b91c7840d3bff$export$1c95bea2669f592b.VERSION = $b16b91c7840d3bff$var$packageJson.version;
var $b16b91c7840d3bff$export$2e2bcd8739ae039 = $b16b91c7840d3bff$export$1c95bea2669f592b;


var $4d2e93495e50cc85$var$n, $4d2e93495e50cc85$export$41c562ebe57d11e2, $4d2e93495e50cc85$var$u, $4d2e93495e50cc85$export$a8257692ac88316c, $4d2e93495e50cc85$var$i, $4d2e93495e50cc85$var$o, $4d2e93495e50cc85$var$r, $4d2e93495e50cc85$var$f, $4d2e93495e50cc85$var$e, $4d2e93495e50cc85$var$c, $4d2e93495e50cc85$var$s, $4d2e93495e50cc85$var$a, $4d2e93495e50cc85$var$h = {}, $4d2e93495e50cc85$var$v = [], $4d2e93495e50cc85$var$p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $4d2e93495e50cc85$var$y = Array.isArray;
function $4d2e93495e50cc85$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $4d2e93495e50cc85$var$_(n) {
    var l = n.parentNode;
    l && l.removeChild(n);
}
function $4d2e93495e50cc85$export$c8a8987d4410bf2d(l, u, t) {
    var i, o, r, f = {};
    for(r in u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : f[r] = u[r];
    if (arguments.length > 2 && (f.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(r in l.defaultProps)void 0 === f[r] && (f[r] = l.defaultProps[r]);
    return $4d2e93495e50cc85$var$b(l, f, i, o, null);
}
function $4d2e93495e50cc85$var$b(n, t, i, o, r) {
    var f = {
        type: n,
        props: t,
        key: i,
        ref: o,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __d: void 0,
        __c: null,
        constructor: void 0,
        __v: null == r ? ++$4d2e93495e50cc85$var$u : r,
        __i: -1,
        __u: 0
    };
    return null == r && null != $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(f), f;
}
function $4d2e93495e50cc85$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $4d2e93495e50cc85$export$ffb0004e005737fa(n) {
    return n.children;
}
function $4d2e93495e50cc85$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $4d2e93495e50cc85$var$x(n, l) {
    if (null == l) return n.__ ? $4d2e93495e50cc85$var$x(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $4d2e93495e50cc85$var$x(n) : null;
}
function $4d2e93495e50cc85$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $4d2e93495e50cc85$var$C(n);
    }
}
function $4d2e93495e50cc85$var$P(n) {
    (!n.__d && (n.__d = !0) && $4d2e93495e50cc85$var$i.push(n) && !$4d2e93495e50cc85$var$S.__r++ || $4d2e93495e50cc85$var$o !== $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) && (($4d2e93495e50cc85$var$o = $4d2e93495e50cc85$export$41c562ebe57d11e2.debounceRendering) || $4d2e93495e50cc85$var$r)($4d2e93495e50cc85$var$S);
}
function $4d2e93495e50cc85$var$S() {
    var n, u, t, o, r, e, c, s;
    for($4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f); n = $4d2e93495e50cc85$var$i.shift();)n.__d && (u = $4d2e93495e50cc85$var$i.length, o = void 0, e = (r = (t = n).__v).__e, c = [], s = [], t.__P && ((o = $4d2e93495e50cc85$var$d({}, r)).__v = r.__v + 1, $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode && $4d2e93495e50cc85$export$41c562ebe57d11e2.vnode(o), $4d2e93495e50cc85$var$O(t.__P, o, r, t.__n, void 0 !== t.__P.ownerSVGElement, 32 & r.__u ? [
        e
    ] : null, c, null == e ? $4d2e93495e50cc85$var$x(r) : e, !!(32 & r.__u), s), o.__v = r.__v, o.__.__k[o.__i] = o, $4d2e93495e50cc85$var$j(c, o, s), o.__e != e && $4d2e93495e50cc85$var$C(o)), $4d2e93495e50cc85$var$i.length > u && $4d2e93495e50cc85$var$i.sort($4d2e93495e50cc85$var$f));
    $4d2e93495e50cc85$var$S.__r = 0;
}
function $4d2e93495e50cc85$var$$(n, l, u, t, i, o, r, f, e, c, s) {
    var a, p, y, d, _, g = t && t.__k || $4d2e93495e50cc85$var$v, b = l.length;
    for(u.__d = e, $4d2e93495e50cc85$var$I(u, l, g), e = u.__d, a = 0; a < b; a++)null != (y = u.__k[a]) && "boolean" != typeof y && "function" != typeof y && (p = -1 === y.__i ? $4d2e93495e50cc85$var$h : g[y.__i] || $4d2e93495e50cc85$var$h, y.__i = a, $4d2e93495e50cc85$var$O(n, y, p, i, o, r, f, e, c, s), d = y.__e, y.ref && p.ref != y.ref && (p.ref && $4d2e93495e50cc85$var$N(p.ref, null, y), s.push(y.ref, y.__c || d, y)), null == _ && null != d && (_ = d), 65536 & y.__u || p.__k === y.__k ? (e && !e.isConnected && (e = $4d2e93495e50cc85$var$x(p)), e = $4d2e93495e50cc85$var$H(y, e, n)) : "function" == typeof y.type && void 0 !== y.__d ? e = y.__d : d && (e = d.nextSibling), y.__d = void 0, y.__u &= -196609);
    u.__d = e, u.__e = _;
}
function $4d2e93495e50cc85$var$I(n, l, u) {
    var t, i, o, r, f, e = l.length, c = u.length, s = c, a = 0;
    for(n.__k = [], t = 0; t < e; t++)r = t + a, null != (i = n.__k[t] = null == (i = l[t]) || "boolean" == typeof i || "function" == typeof i ? null : "string" == typeof i || "number" == typeof i || "bigint" == typeof i || i.constructor == String ? $4d2e93495e50cc85$var$b(null, i, null, null, null) : $4d2e93495e50cc85$var$y(i) ? $4d2e93495e50cc85$var$b($4d2e93495e50cc85$export$ffb0004e005737fa, {
        children: i
    }, null, null, null) : void 0 === i.constructor && i.__b > 0 ? $4d2e93495e50cc85$var$b(i.type, i.props, i.key, i.ref ? i.ref : null, i.__v) : i) ? (i.__ = n, i.__b = n.__b + 1, f = $4d2e93495e50cc85$var$A(i, u, r, s), i.__i = f, o = null, -1 !== f && (s--, (o = u[f]) && (o.__u |= 131072)), null == o || null === o.__v ? (-1 == f && a--, "function" != typeof i.type && (i.__u |= 65536)) : f !== r && (f === r + 1 ? a++ : f > r ? s > e - r ? a += f - r : a-- : f < r ? f == r - 1 && (a = f - r) : a = 0, f !== t + a && (i.__u |= 65536))) : (o = u[r]) && null == o.key && o.__e && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$x(o)), $4d2e93495e50cc85$var$q(o, o, !1), u[r] = null, s--);
    if (s) for(t = 0; t < c; t++)null != (o = u[t]) && 0 == (131072 & o.__u) && (o.__e == n.__d && (n.__d = $4d2e93495e50cc85$var$x(o)), $4d2e93495e50cc85$var$q(o, o));
}
function $4d2e93495e50cc85$var$H(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $4d2e93495e50cc85$var$H(t[i], l, u));
        return l;
    }
    n.__e != l && (u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 === l.nodeType);
    return l;
}
function $4d2e93495e50cc85$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($4d2e93495e50cc85$var$y(n) ? n.some(function(n) {
        $4d2e93495e50cc85$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $4d2e93495e50cc85$var$A(n, l, u, t) {
    var i = n.key, o = n.type, r = u - 1, f = u + 1, e = l[u];
    if (null === e || e && i == e.key && o === e.type && 0 == (131072 & e.__u)) return u;
    if (t > (null != e && 0 == (131072 & e.__u) ? 1 : 0)) for(; r >= 0 || f < l.length;){
        if (r >= 0) {
            if ((e = l[r]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return r;
            r--;
        }
        if (f < l.length) {
            if ((e = l[f]) && 0 == (131072 & e.__u) && i == e.key && o === e.type) return f;
            f++;
        }
    }
    return -1;
}
function $4d2e93495e50cc85$var$F(n, l, u) {
    "-" === l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $4d2e93495e50cc85$var$p.test(l) ? u : u + "px";
}
function $4d2e93495e50cc85$var$L(n, l, u, t, i) {
    var o;
    n: if ("style" === l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $4d2e93495e50cc85$var$F(n.style, l, "");
            if (u) for(l in u)t && u[l] === t[l] || $4d2e93495e50cc85$var$F(n.style, l, u[l]);
        }
    } else if ("o" === l[0] && "n" === l[1]) o = l !== (l = l.replace(/(PointerCapture)$|Capture$/i, "$1")), l = l.toLowerCase() in n || "onFocusOut" === l || "onFocusIn" === l ? l.toLowerCase().slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + o] = u, u ? t ? u.u = t.u : (u.u = $4d2e93495e50cc85$var$e, n.addEventListener(l, o ? $4d2e93495e50cc85$var$s : $4d2e93495e50cc85$var$c, o)) : n.removeEventListener(l, o ? $4d2e93495e50cc85$var$s : $4d2e93495e50cc85$var$c, o);
    else {
        if (i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" !== l[4] ? n.removeAttribute(l) : n.setAttribute(l, u));
    }
}
function $4d2e93495e50cc85$var$M(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $4d2e93495e50cc85$var$e++;
            else if (u.t < t.u) return;
            return t($4d2e93495e50cc85$export$41c562ebe57d11e2.event ? $4d2e93495e50cc85$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $4d2e93495e50cc85$var$O(n, u, t, i, o, r, f, e, c, s) {
    var a, h, v, p, _, g, b, m, x, C, P, S, I, H, T, A = u.type;
    if (void 0 !== u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), r = [
        e = u.__e = t.__e
    ]), (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof A) try {
        if (m = u.props, x = (a = A.contextType) && i[a.__c], C = a ? x ? x.props.value : a.__ : i, t.__c ? b = (h = u.__c = t.__c).__ = h.__E : ("prototype" in A && A.prototype.render ? u.__c = h = new A(m, C) : (u.__c = h = new $4d2e93495e50cc85$export$16fa2f45be04daa8(m, C), h.constructor = A, h.render = $4d2e93495e50cc85$var$B), x && x.sub(h), h.props = m, h.state || (h.state = {}), h.context = C, h.__n = i, v = h.__d = !0, h.__h = [], h._sb = []), null == h.__s && (h.__s = h.state), null != A.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $4d2e93495e50cc85$var$d({}, h.__s)), $4d2e93495e50cc85$var$d(h.__s, A.getDerivedStateFromProps(m, h.__s))), p = h.props, _ = h.state, h.__v = u, v) null == A.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (null == A.getDerivedStateFromProps && m !== p && null != h.componentWillReceiveProps && h.componentWillReceiveProps(m, C), !h.__e && (null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(m, h.__s, C) || u.__v === t.__v)) {
                for(u.__v !== t.__v && (h.props = m, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.forEach(function(n) {
                    n && (n.__ = u);
                }), P = 0; P < h._sb.length; P++)h.__h.push(h._sb[P]);
                h._sb = [], h.__h.length && f.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(m, h.__s, C), null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(p, _, g);
            });
        }
        if (h.context = C, h.props = m, h.__P = n, h.__e = !1, S = $4d2e93495e50cc85$export$41c562ebe57d11e2.__r, I = 0, "prototype" in A && A.prototype.render) {
            for(h.state = h.__s, h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, S && S(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++I < 25);
        h.state = h.__s, null != h.getChildContext && (i = $4d2e93495e50cc85$var$d($4d2e93495e50cc85$var$d({}, i), h.getChildContext())), v || null == h.getSnapshotBeforeUpdate || (g = h.getSnapshotBeforeUpdate(p, _)), $4d2e93495e50cc85$var$$(n, $4d2e93495e50cc85$var$y(T = null != a && a.type === $4d2e93495e50cc85$export$ffb0004e005737fa && null == a.key ? a.props.children : a) ? T : [
            T
        ], u, t, i, o, r, f, e, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && f.push(h), b && (h.__E = h.__ = null);
    } catch (n) {
        u.__v = null, c || null != r ? (u.__e = e, u.__u |= c ? 160 : 32, r[r.indexOf(e)] = null) : (u.__e = t.__e, u.__k = t.__k), $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == r && u.__v === t.__v ? (u.__k = t.__k, u.__e = t.__e) : u.__e = $4d2e93495e50cc85$var$z(t.__e, u, t, i, o, r, f, c, s);
    (a = $4d2e93495e50cc85$export$41c562ebe57d11e2.diffed) && a(u);
}
function $4d2e93495e50cc85$var$j(n, u, t) {
    u.__d = void 0;
    for(var i = 0; i < t.length; i++)$4d2e93495e50cc85$var$N(t[i], t[++i], t[++i]);
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__c && $4d2e93495e50cc85$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $4d2e93495e50cc85$var$z(l, u, t, i, o, r, f, e, c) {
    var s, a, v, p, d, g, b, m = t.props, w = u.props, k = u.type;
    if ("svg" === k && (o = !0), null != r) {
        for(s = 0; s < r.length; s++)if ((d = r[s]) && "setAttribute" in d == !!k && (k ? d.localName === k : 3 === d.nodeType)) {
            l = d, r[s] = null;
            break;
        }
    }
    if (null == l) {
        if (null === k) return document.createTextNode(w);
        l = o ? document.createElementNS("http://www.w3.org/2000/svg", k) : document.createElement(k, w.is && w), r = null, e = !1;
    }
    if (null === k) m === w || e && l.data === w || (l.data = w);
    else {
        if (r = r && $4d2e93495e50cc85$var$n.call(l.childNodes), m = t.props || $4d2e93495e50cc85$var$h, !e && null != r) for(m = {}, s = 0; s < l.attributes.length; s++)m[(d = l.attributes[s]).name] = d.value;
        for(s in m)d = m[s], "children" == s || ("dangerouslySetInnerHTML" == s ? v = d : "key" === s || s in w || $4d2e93495e50cc85$var$L(l, s, null, d, o));
        for(s in w)d = w[s], "children" == s ? p = d : "dangerouslySetInnerHTML" == s ? a = d : "value" == s ? g = d : "checked" == s ? b = d : "key" === s || e && "function" != typeof d || m[s] === d || $4d2e93495e50cc85$var$L(l, s, d, m[s], o);
        if (a) e || v && (a.__html === v.__html || a.__html === l.innerHTML) || (l.innerHTML = a.__html), u.__k = [];
        else if (v && (l.innerHTML = ""), $4d2e93495e50cc85$var$$(l, $4d2e93495e50cc85$var$y(p) ? p : [
            p
        ], u, t, i, o && "foreignObject" !== k, r, f, r ? r[0] : t.__k && $4d2e93495e50cc85$var$x(t, 0), e, c), null != r) for(s = r.length; s--;)null != r[s] && $4d2e93495e50cc85$var$_(r[s]);
        e || (s = "value", void 0 !== g && (g !== l[s] || "progress" === k && !g || "option" === k && g !== m[s]) && $4d2e93495e50cc85$var$L(l, s, g, m[s], !1), s = "checked", void 0 !== b && b !== l[s] && $4d2e93495e50cc85$var$L(l, s, b, m[s], !1));
    }
    return l;
}
function $4d2e93495e50cc85$var$N(n, u, t) {
    try {
        "function" == typeof n ? n(u) : n.current = u;
    } catch (n) {
        $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $4d2e93495e50cc85$var$q(n, u, t) {
    var i, o;
    if ($4d2e93495e50cc85$export$41c562ebe57d11e2.unmount && $4d2e93495e50cc85$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current !== n.__e || $4d2e93495e50cc85$var$N(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $4d2e93495e50cc85$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(o = 0; o < i.length; o++)i[o] && $4d2e93495e50cc85$var$q(i[o], u, t || "function" != typeof n.type);
    t || null == n.__e || $4d2e93495e50cc85$var$_(n.__e), n.__c = n.__ = n.__e = n.__d = void 0;
}
function $4d2e93495e50cc85$var$B(n, l, u) {
    return this.constructor(n, u);
}
function $4d2e93495e50cc85$export$b3890eb0ae9dca99(u, t, i) {
    var o, r, f, e;
    $4d2e93495e50cc85$export$41c562ebe57d11e2.__ && $4d2e93495e50cc85$export$41c562ebe57d11e2.__(u, t), r = (o = "function" == typeof i) ? null : i && i.__k || t.__k, f = [], e = [], $4d2e93495e50cc85$var$O(t, u = (!o && i || t).__k = $4d2e93495e50cc85$export$c8a8987d4410bf2d($4d2e93495e50cc85$export$ffb0004e005737fa, null, [
        u
    ]), r || $4d2e93495e50cc85$var$h, $4d2e93495e50cc85$var$h, void 0 !== t.ownerSVGElement, !o && i ? [
        i
    ] : r ? null : t.firstChild ? $4d2e93495e50cc85$var$n.call(t.childNodes) : null, f, !o && i ? i : r ? r.__e : t.firstChild, o, e), $4d2e93495e50cc85$var$j(f, u, e);
}
function $4d2e93495e50cc85$export$fa8d919ba61d84db(n, l) {
    $4d2e93495e50cc85$export$b3890eb0ae9dca99(n, l, $4d2e93495e50cc85$export$fa8d919ba61d84db);
}
function $4d2e93495e50cc85$export$e530037191fcd5d7(l, u, t) {
    var i, o, r, f, e = $4d2e93495e50cc85$var$d({}, l.props);
    for(r in l.type && l.type.defaultProps && (f = l.type.defaultProps), u)"key" == r ? i = u[r] : "ref" == r ? o = u[r] : e[r] = void 0 === u[r] && void 0 !== f ? f[r] : u[r];
    return arguments.length > 2 && (e.children = arguments.length > 3 ? $4d2e93495e50cc85$var$n.call(arguments, 2) : t), $4d2e93495e50cc85$var$b(l.type, e, i || l.key, o || l.ref, null);
}
function $4d2e93495e50cc85$export$fd42f52fd3ae1109(n, l) {
    var u = {
        __c: l = "__cC" + $4d2e93495e50cc85$var$a++,
        __: n,
        Consumer: function(n, l) {
            return n.children(l);
        },
        Provider: function(n) {
            var u, t;
            return this.getChildContext || (u = [], (t = {})[l] = this, this.getChildContext = function() {
                return t;
            }, this.shouldComponentUpdate = function(n) {
                this.props.value !== n.value && u.some(function(n) {
                    n.__e = !0, $4d2e93495e50cc85$var$P(n);
                });
            }, this.sub = function(n) {
                u.push(n);
                var l = n.componentWillUnmount;
                n.componentWillUnmount = function() {
                    u.splice(u.indexOf(n), 1), l && l.call(n);
                };
            }), n.children;
        }
    };
    return u.Provider.__ = u.Consumer.contextType = u;
}
$4d2e93495e50cc85$var$n = $4d2e93495e50cc85$var$v.slice, $4d2e93495e50cc85$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, o, r; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((o = i.constructor) && null != o.getDerivedStateFromError && (i.setState(o.getDerivedStateFromError(n)), r = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), r = i.__d), r) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $4d2e93495e50cc85$var$u = 0, $4d2e93495e50cc85$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s !== this.state ? this.__s : this.__s = $4d2e93495e50cc85$var$d({}, this.state), "function" == typeof n && (n = n($4d2e93495e50cc85$var$d({}, u), this.props)), n && $4d2e93495e50cc85$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $4d2e93495e50cc85$var$P(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $4d2e93495e50cc85$var$P(this));
}, $4d2e93495e50cc85$export$16fa2f45be04daa8.prototype.render = $4d2e93495e50cc85$export$ffb0004e005737fa, $4d2e93495e50cc85$var$i = [], $4d2e93495e50cc85$var$r = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $4d2e93495e50cc85$var$f = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $4d2e93495e50cc85$var$S.__r = 0, $4d2e93495e50cc85$var$e = 0, $4d2e93495e50cc85$var$c = $4d2e93495e50cc85$var$M(!1), $4d2e93495e50cc85$var$s = $4d2e93495e50cc85$var$M(!0), $4d2e93495e50cc85$var$a = 0;



var $e28f05d17e052ff9$var$t, $e28f05d17e052ff9$var$r, $e28f05d17e052ff9$var$u, $e28f05d17e052ff9$var$i, $e28f05d17e052ff9$var$o = 0, $e28f05d17e052ff9$var$f = [], $e28f05d17e052ff9$var$c = [], $e28f05d17e052ff9$var$e = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2), $e28f05d17e052ff9$var$a = $e28f05d17e052ff9$var$e.__b, $e28f05d17e052ff9$var$v = $e28f05d17e052ff9$var$e.__r, $e28f05d17e052ff9$var$l = $e28f05d17e052ff9$var$e.diffed, $e28f05d17e052ff9$var$m = $e28f05d17e052ff9$var$e.__c, $e28f05d17e052ff9$var$s = $e28f05d17e052ff9$var$e.unmount, $e28f05d17e052ff9$var$d = $e28f05d17e052ff9$var$e.__;
function $e28f05d17e052ff9$var$h(n, t) {
    $e28f05d17e052ff9$var$e.__h && $e28f05d17e052ff9$var$e.__h($e28f05d17e052ff9$var$r, n, $e28f05d17e052ff9$var$o || t), $e28f05d17e052ff9$var$o = 0;
    var u = $e28f05d17e052ff9$var$r.__H || ($e28f05d17e052ff9$var$r.__H = {
        __: [],
        __h: []
    });
    return n >= u.__.length && u.__.push({
        __V: $e28f05d17e052ff9$var$c
    }), u.__[n];
}
function $e28f05d17e052ff9$export$60241385465d0a34(n) {
    return $e28f05d17e052ff9$var$o = 1, $e28f05d17e052ff9$export$13e3392192263954($e28f05d17e052ff9$var$D, n);
}
function $e28f05d17e052ff9$export$13e3392192263954(n, u, i) {
    var o = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 2);
    if (o.t = n, !o.__c && (o.__ = [
        i ? i(u) : $e28f05d17e052ff9$var$D(void 0, u),
        function(n) {
            var t = o.__N ? o.__N[0] : o.__[0], r = o.t(t, n);
            t !== r && (o.__N = [
                r,
                o.__[1]
            ], o.__c.setState({}));
        }
    ], o.__c = $e28f05d17e052ff9$var$r, !$e28f05d17e052ff9$var$r.u)) {
        var f = function(n, t, r) {
            if (!o.__c.__H) return !0;
            var u = o.__c.__H.__.filter(function(n) {
                return !!n.__c;
            });
            if (u.every(function(n) {
                return !n.__N;
            })) return !c || c.call(this, n, t, r);
            var i = !1;
            return u.forEach(function(n) {
                if (n.__N) {
                    var t = n.__[0];
                    n.__ = n.__N, n.__N = void 0, t !== n.__[0] && (i = !0);
                }
            }), !(!i && o.__c.props === n) && (!c || c.call(this, n, t, r));
        };
        $e28f05d17e052ff9$var$r.u = !0;
        var c = $e28f05d17e052ff9$var$r.shouldComponentUpdate, e = $e28f05d17e052ff9$var$r.componentWillUpdate;
        $e28f05d17e052ff9$var$r.componentWillUpdate = function(n, t, r) {
            if (this.__e) {
                var u = c;
                c = void 0, f(n, t, r), c = u;
            }
            e && e.call(this, n, t, r);
        }, $e28f05d17e052ff9$var$r.shouldComponentUpdate = f;
    }
    return o.__N || o.__;
}
function $e28f05d17e052ff9$export$6d9c69b0de29b591(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 3);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__H.__h.push(i));
}
function $e28f05d17e052ff9$export$e5c5a5f917a5871c(n, u) {
    var i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 4);
    !$e28f05d17e052ff9$var$e.__s && $e28f05d17e052ff9$var$C(i.__H, u) && (i.__ = n, i.i = u, $e28f05d17e052ff9$var$r.__h.push(i));
}
function $e28f05d17e052ff9$export$b8f5890fc79d6aca(n) {
    return $e28f05d17e052ff9$var$o = 5, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return {
            current: n
        };
    }, []);
}
function $e28f05d17e052ff9$export$d5a552a76deda3c2(n, t, r) {
    $e28f05d17e052ff9$var$o = 6, $e28f05d17e052ff9$export$e5c5a5f917a5871c(function() {
        return "function" == typeof n ? (n(t()), function() {
            return n(null);
        }) : n ? (n.current = t(), function() {
            return n.current = null;
        }) : void 0;
    }, null == r ? r : r.concat(n));
}
function $e28f05d17e052ff9$export$1538c33de8887b59(n, r) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 7);
    return $e28f05d17e052ff9$var$C(u.__H, r) ? (u.__V = n(), u.i = r, u.__h = n, u.__V) : u.__;
}
function $e28f05d17e052ff9$export$35808ee640e87ca7(n, t) {
    return $e28f05d17e052ff9$var$o = 8, $e28f05d17e052ff9$export$1538c33de8887b59(function() {
        return n;
    }, t);
}
function $e28f05d17e052ff9$export$fae74005e78b1a27(n) {
    var u = $e28f05d17e052ff9$var$r.context[n.__c], i = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 9);
    return i.c = n, u ? (null == i.__ && (i.__ = !0, u.sub($e28f05d17e052ff9$var$r)), u.props.value) : n.__;
}
function $e28f05d17e052ff9$export$dc8fbce3eb94dc1e(n, t) {
    $e28f05d17e052ff9$var$e.useDebugValue && $e28f05d17e052ff9$var$e.useDebugValue(t ? t(n) : n);
}
function $e28f05d17e052ff9$export$c052f6604b7d51fe(n) {
    var u = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 10), i = $e28f05d17e052ff9$export$60241385465d0a34();
    return u.__ = n, $e28f05d17e052ff9$var$r.componentDidCatch || ($e28f05d17e052ff9$var$r.componentDidCatch = function(n, t) {
        u.__ && u.__(n, t), i[1](n);
    }), [
        i[0],
        function() {
            i[1](void 0);
        }
    ];
}
function $e28f05d17e052ff9$export$f680877a34711e37() {
    var n = $e28f05d17e052ff9$var$h($e28f05d17e052ff9$var$t++, 11);
    if (!n.__) {
        for(var u = $e28f05d17e052ff9$var$r.__v; null !== u && !u.__m && null !== u.__;)u = u.__;
        var i = u.__m || (u.__m = [
            0,
            0
        ]);
        n.__ = "P" + i[0] + "-" + i[1]++;
    }
    return n.__;
}
function $e28f05d17e052ff9$var$j() {
    for(var n; n = $e28f05d17e052ff9$var$f.shift();)if (n.__P && n.__H) try {
        n.__H.__h.forEach($e28f05d17e052ff9$var$z), n.__H.__h.forEach($e28f05d17e052ff9$var$B), n.__H.__h = [];
    } catch (t) {
        n.__H.__h = [], $e28f05d17e052ff9$var$e.__e(t, n.__v);
    }
}
$e28f05d17e052ff9$var$e.__b = function(n) {
    $e28f05d17e052ff9$var$r = null, $e28f05d17e052ff9$var$a && $e28f05d17e052ff9$var$a(n);
}, $e28f05d17e052ff9$var$e.__ = function(n, t) {
    n && t.__k && t.__k.__m && (n.__m = t.__k.__m), $e28f05d17e052ff9$var$d && $e28f05d17e052ff9$var$d(n, t);
}, $e28f05d17e052ff9$var$e.__r = function(n) {
    $e28f05d17e052ff9$var$v && $e28f05d17e052ff9$var$v(n), $e28f05d17e052ff9$var$t = 0;
    var i = ($e28f05d17e052ff9$var$r = n.__c).__H;
    i && ($e28f05d17e052ff9$var$u === $e28f05d17e052ff9$var$r ? (i.__h = [], $e28f05d17e052ff9$var$r.__h = [], i.__.forEach(function(n) {
        n.__N && (n.__ = n.__N), n.__V = $e28f05d17e052ff9$var$c, n.__N = n.i = void 0;
    })) : (i.__h.forEach($e28f05d17e052ff9$var$z), i.__h.forEach($e28f05d17e052ff9$var$B), i.__h = [], $e28f05d17e052ff9$var$t = 0)), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r;
}, $e28f05d17e052ff9$var$e.diffed = function(n) {
    $e28f05d17e052ff9$var$l && $e28f05d17e052ff9$var$l(n);
    var t = n.__c;
    t && t.__H && (t.__H.__h.length && (1 !== $e28f05d17e052ff9$var$f.push(t) && $e28f05d17e052ff9$var$i === $e28f05d17e052ff9$var$e.requestAnimationFrame || (($e28f05d17e052ff9$var$i = $e28f05d17e052ff9$var$e.requestAnimationFrame) || $e28f05d17e052ff9$var$w)($e28f05d17e052ff9$var$j)), t.__H.__.forEach(function(n) {
        n.i && (n.__H = n.i), n.__V !== $e28f05d17e052ff9$var$c && (n.__ = n.__V), n.i = void 0, n.__V = $e28f05d17e052ff9$var$c;
    })), $e28f05d17e052ff9$var$u = $e28f05d17e052ff9$var$r = null;
}, $e28f05d17e052ff9$var$e.__c = function(n, t) {
    t.some(function(n) {
        try {
            n.__h.forEach($e28f05d17e052ff9$var$z), n.__h = n.__h.filter(function(n) {
                return !n.__ || $e28f05d17e052ff9$var$B(n);
            });
        } catch (r) {
            t.some(function(n) {
                n.__h && (n.__h = []);
            }), t = [], $e28f05d17e052ff9$var$e.__e(r, n.__v);
        }
    }), $e28f05d17e052ff9$var$m && $e28f05d17e052ff9$var$m(n, t);
}, $e28f05d17e052ff9$var$e.unmount = function(n) {
    $e28f05d17e052ff9$var$s && $e28f05d17e052ff9$var$s(n);
    var t, r = n.__c;
    r && r.__H && (r.__H.__.forEach(function(n) {
        try {
            $e28f05d17e052ff9$var$z(n);
        } catch (n) {
            t = n;
        }
    }), r.__H = void 0, t && $e28f05d17e052ff9$var$e.__e(t, r.__v));
};
var $e28f05d17e052ff9$var$k = "function" == typeof requestAnimationFrame;
function $e28f05d17e052ff9$var$w(n) {
    var t, r = function() {
        clearTimeout(u), $e28f05d17e052ff9$var$k && cancelAnimationFrame(t), setTimeout(n);
    }, u = setTimeout(r, 100);
    $e28f05d17e052ff9$var$k && (t = requestAnimationFrame(r));
}
function $e28f05d17e052ff9$var$z(n) {
    var t = $e28f05d17e052ff9$var$r, u = n.__c;
    "function" == typeof u && (n.__c = void 0, u()), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$B(n) {
    var t = $e28f05d17e052ff9$var$r;
    n.__c = n.__(), $e28f05d17e052ff9$var$r = t;
}
function $e28f05d17e052ff9$var$C(n, t) {
    return !n || n.length !== t.length || t.some(function(t, r) {
        return t !== n[r];
    });
}
function $e28f05d17e052ff9$var$D(n, t) {
    return "function" == typeof t ? t(n) : t;
}


function $2c57945ee961e217$var$S(n, t) {
    for(var e in t)n[e] = t[e];
    return n;
}
function $2c57945ee961e217$var$C(n, t) {
    for(var e in n)if ("__source" !== e && !(e in t)) return !0;
    for(var r in t)if ("__source" !== r && n[r] !== t[r]) return !0;
    return !1;
}
function $2c57945ee961e217$export$221d75b3f55bb0bd(n, t) {
    this.props = n, this.context = t;
}
function $2c57945ee961e217$export$7c73462e0d25e514(n, e) {
    function r(n) {
        var t = this.props.ref, r = t == n.ref;
        return !r && t && (t.call ? t(null) : t.current = null), e ? !e(this.props, n) || !r : $2c57945ee961e217$var$C(this.props, n);
    }
    function u(e) {
        return this.shouldComponentUpdate = r, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(n, e);
    }
    return u.displayName = "Memo(" + (n.displayName || n.name) + ")", u.prototype.isReactComponent = !0, u.__f = !0, u;
}
($2c57945ee961e217$export$221d75b3f55bb0bd.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).isPureReactComponent = !0, $2c57945ee961e217$export$221d75b3f55bb0bd.prototype.shouldComponentUpdate = function(n, t) {
    return $2c57945ee961e217$var$C(this.props, n) || $2c57945ee961e217$var$C(this.state, t);
};
var $2c57945ee961e217$var$x = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__b;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__b = function(n) {
    n.type && n.type.__f && n.ref && (n.props.ref = n.ref, n.ref = null), $2c57945ee961e217$var$x && $2c57945ee961e217$var$x(n);
};
var $2c57945ee961e217$var$R = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.forward_ref") || 3911;
function $2c57945ee961e217$export$257a8862b851cb5b(n) {
    function t(t) {
        var e = $2c57945ee961e217$var$S({}, t);
        return delete e.ref, n(e, t.ref || null);
    }
    return t.$$typeof = $2c57945ee961e217$var$R, t.render = t, t.prototype.isReactComponent = t.__f = !0, t.displayName = "ForwardRef(" + (n.displayName || n.name) + ")", t;
}
var $2c57945ee961e217$var$k = function(n, t) {
    return null == n ? null : (0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(n).map(t));
}, $2c57945ee961e217$export$dca3b0875bd9a954 = {
    map: $2c57945ee961e217$var$k,
    forEach: $2c57945ee961e217$var$k,
    count: function(n) {
        return n ? (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n).length : 0;
    },
    only: function(n) {
        var t = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n);
        if (1 !== t.length) throw "Children.only";
        return t[0];
    },
    toArray: (0, $4d2e93495e50cc85$export$47e4c5b300681277)
}, $2c57945ee961e217$var$M = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__e;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__e = function(n, t, e, r) {
    if (n.then) {
        for(var u, o = t; o = o.__;)if ((u = o.__c) && u.__c) return null == t.__e && (t.__e = e.__e, t.__k = e.__k), u.__c(n, t);
    }
    $2c57945ee961e217$var$M(n, t, e, r);
};
var $2c57945ee961e217$var$O = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).unmount;
function $2c57945ee961e217$var$T(n, t, e) {
    return n && (n.__c && n.__c.__H && (n.__c.__H.__.forEach(function(n) {
        "function" == typeof n.__c && n.__c();
    }), n.__c.__H = null), null != (n = $2c57945ee961e217$var$S({}, n)).__c && (n.__c.__P === e && (n.__c.__P = t), n.__c = null), n.__k = n.__k && n.__k.map(function(n) {
        return $2c57945ee961e217$var$T(n, t, e);
    })), n;
}
function $2c57945ee961e217$var$F(n, t, e) {
    return n && e && (n.__v = null, n.__k = n.__k && n.__k.map(function(n) {
        return $2c57945ee961e217$var$F(n, t, e);
    }), n.__c && n.__c.__P === t && (n.__e && e.appendChild(n.__e), n.__c.__e = !0, n.__c.__P = e)), n;
}
function $2c57945ee961e217$export$74bf444e3cd11ea5() {
    this.__u = 0, this.t = null, this.__b = null;
}
function $2c57945ee961e217$var$L(n) {
    var t = n.__.__c;
    return t && t.__a && t.__a(n);
}
function $2c57945ee961e217$export$488013bae63b21da(n) {
    var e, r, u;
    function o(o) {
        if (e || (e = n()).then(function(n) {
            r = n.default || n;
        }, function(n) {
            u = n;
        }), u) throw u;
        if (!r) throw e;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(r, o);
    }
    return o.displayName = "Lazy", o.__f = !0, o;
}
function $2c57945ee961e217$export$998bcd577473dd93() {
    this.u = null, this.o = null;
}
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).unmount = function(n) {
    var t = n.__c;
    t && t.__R && t.__R(), t && 32 & n.__u && (n.type = null), $2c57945ee961e217$var$O && $2c57945ee961e217$var$O(n);
}, ($2c57945ee961e217$export$74bf444e3cd11ea5.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).__c = function(n, t) {
    var e = t.__c, r = this;
    null == r.t && (r.t = []), r.t.push(e);
    var u = $2c57945ee961e217$var$L(r.__v), o = !1, i = function() {
        o || (o = !0, e.__R = null, u ? u(l) : l());
    };
    e.__R = i;
    var l = function() {
        if (!--r.__u) {
            if (r.state.__a) {
                var n = r.state.__a;
                r.__v.__k[0] = $2c57945ee961e217$var$F(n, n.__c.__P, n.__c.__O);
            }
            var t;
            for(r.setState({
                __a: r.__b = null
            }); t = r.t.pop();)t.forceUpdate();
        }
    };
    r.__u++ || 32 & t.__u || r.setState({
        __a: r.__b = r.__v.__k[0]
    }), n.then(i, i);
}, $2c57945ee961e217$export$74bf444e3cd11ea5.prototype.componentWillUnmount = function() {
    this.t = [];
}, $2c57945ee961e217$export$74bf444e3cd11ea5.prototype.render = function(n, e) {
    if (this.__b) {
        if (this.__v.__k) {
            var r = document.createElement("div"), o = this.__v.__k[0].__c;
            this.__v.__k[0] = $2c57945ee961e217$var$T(this.__b, r, o.__O = o.__P);
        }
        this.__b = null;
    }
    var i = e.__a && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, n.fallback);
    return i && (i.__u &= -33), [
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, e.__a ? null : n.children),
        i
    ];
};
var $2c57945ee961e217$var$V = function(n, t, e) {
    if (++e[1] === e[0] && n.o.delete(t), n.props.revealOrder && ("t" !== n.props.revealOrder[0] || !n.o.size)) for(e = n.u; e;){
        for(; e.length > 3;)e.pop()();
        if (e[1] < e[0]) break;
        n.u = e = e[2];
    }
};
function $2c57945ee961e217$var$W(n) {
    return this.getChildContext = function() {
        return n.context;
    }, n.children;
}
function $2c57945ee961e217$var$P(n) {
    var e = this, r = n.i;
    e.componentWillUnmount = function() {
        (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(null, e.l), e.l = null, e.i = null;
    }, e.i && e.i !== r && e.componentWillUnmount(), e.l || (e.i = r, e.l = {
        nodeType: 1,
        parentNode: r,
        childNodes: [],
        appendChild: function(n) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        insertBefore: function(n, t) {
            this.childNodes.push(n), e.i.appendChild(n);
        },
        removeChild: function(n) {
            this.childNodes.splice(this.childNodes.indexOf(n) >>> 1, 1), e.i.removeChild(n);
        }
    }), (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)((0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($2c57945ee961e217$var$W, {
        context: e.context
    }, n.__v), e.l);
}
function $2c57945ee961e217$export$d39a5bbd09211389(n, e) {
    var r = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($2c57945ee961e217$var$P, {
        __v: n,
        i: e
    });
    return r.containerInfo = e, r;
}
($2c57945ee961e217$export$998bcd577473dd93.prototype = new (0, $4d2e93495e50cc85$export$16fa2f45be04daa8)).__a = function(n) {
    var t = this, e = $2c57945ee961e217$var$L(t.__v), r = t.o.get(n);
    return r[0]++, function(u) {
        var o = function() {
            t.props.revealOrder ? (r.push(u), $2c57945ee961e217$var$V(t, n, r)) : u();
        };
        e ? e(o) : o();
    };
}, $2c57945ee961e217$export$998bcd577473dd93.prototype.render = function(n) {
    this.u = null, this.o = new Map;
    var t = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(n.children);
    n.revealOrder && "b" === n.revealOrder[0] && t.reverse();
    for(var e = t.length; e--;)this.o.set(t[e], this.u = [
        1,
        0,
        this.u
    ]);
    return n.children;
}, $2c57945ee961e217$export$998bcd577473dd93.prototype.componentDidUpdate = $2c57945ee961e217$export$998bcd577473dd93.prototype.componentDidMount = function() {
    var n = this;
    this.o.forEach(function(t, e) {
        $2c57945ee961e217$var$V(n, e, t);
    });
};
var $2c57945ee961e217$var$z = "undefined" != typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, $2c57945ee961e217$var$B = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|image(!S)|letter|lighting|marker(?!H|W|U)|overline|paint|pointer|shape|stop|strikethrough|stroke|text(?!L)|transform|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, $2c57945ee961e217$var$H = /^on(Ani|Tra|Tou|BeforeInp|Compo)/, $2c57945ee961e217$var$Z = /[A-Z0-9]/g, $2c57945ee961e217$var$Y = "undefined" != typeof document, $2c57945ee961e217$var$$ = function(n) {
    return ("undefined" != typeof Symbol && "symbol" == typeof Symbol() ? /fil|che|rad/ : /fil|che|ra/).test(n);
};
function $2c57945ee961e217$export$b3890eb0ae9dca99(n, t, e) {
    return null == t.__k && (t.textContent = ""), (0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
function $2c57945ee961e217$export$fa8d919ba61d84db(n, t, e) {
    return (0, $4d2e93495e50cc85$export$fa8d919ba61d84db)(n, t), "function" == typeof e && e(), n ? n.__c : null;
}
(0, $4d2e93495e50cc85$export$16fa2f45be04daa8).prototype.isReactComponent = {}, [
    "componentWillMount",
    "componentWillReceiveProps",
    "componentWillUpdate"
].forEach(function(t) {
    Object.defineProperty((0, $4d2e93495e50cc85$export$16fa2f45be04daa8).prototype, t, {
        configurable: !0,
        get: function() {
            return this["UNSAFE_" + t];
        },
        set: function(n) {
            Object.defineProperty(this, t, {
                configurable: !0,
                writable: !0,
                value: n
            });
        }
    });
});
var $2c57945ee961e217$var$J = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).event;
function $2c57945ee961e217$var$K() {}
function $2c57945ee961e217$var$Q() {
    return this.cancelBubble;
}
function $2c57945ee961e217$var$X() {
    return this.defaultPrevented;
}
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).event = function(n) {
    return $2c57945ee961e217$var$J && (n = $2c57945ee961e217$var$J(n)), n.persist = $2c57945ee961e217$var$K, n.isPropagationStopped = $2c57945ee961e217$var$Q, n.isDefaultPrevented = $2c57945ee961e217$var$X, n.nativeEvent = n;
};
var $2c57945ee961e217$var$nn, $2c57945ee961e217$var$tn = {
    enumerable: !1,
    configurable: !0,
    get: function() {
        return this.class;
    }
}, $2c57945ee961e217$var$en = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).vnode = function(n) {
    "string" == typeof n.type && function(n) {
        var t = n.props, e = n.type, u = {};
        for(var o in t){
            var i = t[o];
            if (!("value" === o && "defaultValue" in t && null == i || $2c57945ee961e217$var$Y && "children" === o && "noscript" === e || "class" === o || "className" === o)) {
                var l = o.toLowerCase();
                "defaultValue" === o && "value" in t && null == t.value ? o = "value" : "download" === o && !0 === i ? i = "" : "translate" === l && "no" === i ? i = !1 : "ondoubleclick" === l ? o = "ondblclick" : "onchange" !== l || "input" !== e && "textarea" !== e || $2c57945ee961e217$var$$(t.type) ? "onfocus" === l ? o = "onfocusin" : "onblur" === l ? o = "onfocusout" : $2c57945ee961e217$var$H.test(o) ? o = l : -1 === e.indexOf("-") && $2c57945ee961e217$var$B.test(o) ? o = o.replace($2c57945ee961e217$var$Z, "-$&").toLowerCase() : null === i && (i = void 0) : l = o = "oninput", "oninput" === l && u[o = l] && (o = "oninputCapture"), u[o] = i;
            }
        }
        "select" == e && u.multiple && Array.isArray(u.value) && (u.value = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = -1 != u.value.indexOf(n.props.value);
        })), "select" == e && null != u.defaultValue && (u.value = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(t.children).forEach(function(n) {
            n.props.selected = u.multiple ? -1 != u.defaultValue.indexOf(n.props.value) : u.defaultValue == n.props.value;
        })), t.class && !t.className ? (u.class = t.class, Object.defineProperty(u, "className", $2c57945ee961e217$var$tn)) : (t.className && !t.class || t.class && t.className) && (u.class = u.className = t.className), n.props = u;
    }(n), n.$$typeof = $2c57945ee961e217$var$z, $2c57945ee961e217$var$en && $2c57945ee961e217$var$en(n);
};
var $2c57945ee961e217$var$rn = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__r;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).__r = function(n) {
    $2c57945ee961e217$var$rn && $2c57945ee961e217$var$rn(n), $2c57945ee961e217$var$nn = n.__c;
};
var $2c57945ee961e217$var$un = (0, $4d2e93495e50cc85$export$41c562ebe57d11e2).diffed;
(0, $4d2e93495e50cc85$export$41c562ebe57d11e2).diffed = function(n) {
    $2c57945ee961e217$var$un && $2c57945ee961e217$var$un(n);
    var t = n.props, e = n.__e;
    null != e && "textarea" === n.type && "value" in t && t.value !== e.value && (e.value = null == t.value ? "" : t.value), $2c57945ee961e217$var$nn = null;
};
var $2c57945ee961e217$export$ae55be85d98224ed = {
    ReactCurrentDispatcher: {
        current: {
            readContext: function(n) {
                return $2c57945ee961e217$var$nn.__n[n.__c].props.value;
            }
        }
    }
}, $2c57945ee961e217$export$83d89fbfd8236492 = "17.0.2";
function $2c57945ee961e217$export$d38cd72104c1f0e9(n) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d).bind(null, n);
}
function $2c57945ee961e217$export$a8257692ac88316c(n) {
    return !!n && n.$$typeof === $2c57945ee961e217$var$z;
}
function $2c57945ee961e217$export$9522e17588c12572(n) {
    return $2c57945ee961e217$export$a8257692ac88316c(n) && n.type === (0, $4d2e93495e50cc85$export$ffb0004e005737fa);
}
function $2c57945ee961e217$export$56885ab8b9c456ab(n) {
    return !!n && !!n.displayName && ("string" == typeof n.displayName || n.displayName instanceof String) && n.displayName.startsWith("Memo(");
}
function $2c57945ee961e217$export$e530037191fcd5d7(n) {
    return $2c57945ee961e217$export$a8257692ac88316c(n) ? (0, $4d2e93495e50cc85$export$e530037191fcd5d7).apply(null, arguments) : n;
}
function $2c57945ee961e217$export$502457920280e6be(n) {
    return !!n.__k && ((0, $4d2e93495e50cc85$export$b3890eb0ae9dca99)(null, n), !0);
}
function $2c57945ee961e217$export$466bfc07425424d5(n) {
    return n && (n.base || 1 === n.nodeType && n) || null;
}
var $2c57945ee961e217$export$c78a37762a8d58e1 = function(n, t) {
    return n(t);
}, $2c57945ee961e217$export$cd75ccfd720a3cd4 = function(n, t) {
    return n(t);
}, $2c57945ee961e217$export$5f8d39834fd61797 = (0, $4d2e93495e50cc85$export$ffb0004e005737fa);
function $2c57945ee961e217$export$7568632d0d33d16d(n) {
    n();
}
function $2c57945ee961e217$export$6a7bc4e911dc01cf(n) {
    return n;
}
function $2c57945ee961e217$export$7b286972b8d8ccbf() {
    return [
        !1,
        $2c57945ee961e217$export$7568632d0d33d16d
    ];
}
var $2c57945ee961e217$export$aaabe4eda9ed9969 = (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c), $2c57945ee961e217$export$45a5e7f76e0caa8d = $2c57945ee961e217$export$a8257692ac88316c;
function $2c57945ee961e217$export$306c0aa65ff9ec16(n, t) {
    var e = t(), r = (0, $e28f05d17e052ff9$export$60241385465d0a34)({
        h: {
            __: e,
            v: t
        }
    }), u = r[0].h, o = r[1];
    return (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c)(function() {
        u.__ = e, u.v = t, $2c57945ee961e217$var$wn(u) && o({
            h: u
        });
    }, [
        n,
        e,
        t
    ]), (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(function() {
        return $2c57945ee961e217$var$wn(u) && o({
            h: u
        }), n(function() {
            $2c57945ee961e217$var$wn(u) && o({
                h: u
            });
        });
    }, [
        n
    ]), e;
}
function $2c57945ee961e217$var$wn(n) {
    var t, e, r = n.v, u = n.__;
    try {
        var o = r();
        return !((t = u) === (e = o) && (0 !== t || 1 / t == 1 / e) || t != t && e != e);
    } catch (n) {
        return !0;
    }
}
var $2c57945ee961e217$export$2e2bcd8739ae039 = {
    useState: (0, $e28f05d17e052ff9$export$60241385465d0a34),
    useId: (0, $e28f05d17e052ff9$export$f680877a34711e37),
    useReducer: (0, $e28f05d17e052ff9$export$13e3392192263954),
    useEffect: (0, $e28f05d17e052ff9$export$6d9c69b0de29b591),
    useLayoutEffect: (0, $e28f05d17e052ff9$export$e5c5a5f917a5871c),
    useInsertionEffect: $2c57945ee961e217$export$aaabe4eda9ed9969,
    useTransition: $2c57945ee961e217$export$7b286972b8d8ccbf,
    useDeferredValue: $2c57945ee961e217$export$6a7bc4e911dc01cf,
    useSyncExternalStore: $2c57945ee961e217$export$306c0aa65ff9ec16,
    startTransition: $2c57945ee961e217$export$7568632d0d33d16d,
    useRef: (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca),
    useImperativeHandle: (0, $e28f05d17e052ff9$export$d5a552a76deda3c2),
    useMemo: (0, $e28f05d17e052ff9$export$1538c33de8887b59),
    useCallback: (0, $e28f05d17e052ff9$export$35808ee640e87ca7),
    useContext: (0, $e28f05d17e052ff9$export$fae74005e78b1a27),
    useDebugValue: (0, $e28f05d17e052ff9$export$dc8fbce3eb94dc1e),
    version: "17.0.2",
    Children: $2c57945ee961e217$export$dca3b0875bd9a954,
    render: $2c57945ee961e217$export$b3890eb0ae9dca99,
    hydrate: $2c57945ee961e217$export$fa8d919ba61d84db,
    unmountComponentAtNode: $2c57945ee961e217$export$502457920280e6be,
    createPortal: $2c57945ee961e217$export$d39a5bbd09211389,
    createElement: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d),
    createContext: (0, $4d2e93495e50cc85$export$fd42f52fd3ae1109),
    createFactory: $2c57945ee961e217$export$d38cd72104c1f0e9,
    cloneElement: $2c57945ee961e217$export$e530037191fcd5d7,
    createRef: (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43),
    Fragment: (0, $4d2e93495e50cc85$export$ffb0004e005737fa),
    isValidElement: $2c57945ee961e217$export$a8257692ac88316c,
    isElement: $2c57945ee961e217$export$45a5e7f76e0caa8d,
    isFragment: $2c57945ee961e217$export$9522e17588c12572,
    isMemo: $2c57945ee961e217$export$56885ab8b9c456ab,
    findDOMNode: $2c57945ee961e217$export$466bfc07425424d5,
    Component: (0, $4d2e93495e50cc85$export$16fa2f45be04daa8),
    PureComponent: $2c57945ee961e217$export$221d75b3f55bb0bd,
    memo: $2c57945ee961e217$export$7c73462e0d25e514,
    forwardRef: $2c57945ee961e217$export$257a8862b851cb5b,
    flushSync: $2c57945ee961e217$export$cd75ccfd720a3cd4,
    unstable_batchedUpdates: $2c57945ee961e217$export$c78a37762a8d58e1,
    StrictMode: $2c57945ee961e217$export$5f8d39834fd61797,
    Suspense: $2c57945ee961e217$export$74bf444e3cd11ea5,
    SuspenseList: $2c57945ee961e217$export$998bcd577473dd93,
    lazy: $2c57945ee961e217$export$488013bae63b21da,
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: $2c57945ee961e217$export$ae55be85d98224ed
};


/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 */ function $dcdea5a9bf8353ff$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    if (!("nodeType" in obj)) return false;
    return obj.nodeType === Node.ELEMENT_NODE;
}


function $1866f8238923bb5d$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === "string") return context.querySelector(element);
    if ((0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return element;
    return null;
}
var $1866f8238923bb5d$export$2e2bcd8739ae039 = $1866f8238923bb5d$var$findDOMElement;


/**
 * Get the declared text direction for an element.
 */ function $82cce0c04a5d7a26$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
var $82cce0c04a5d7a26$export$2e2bcd8739ae039 = $82cce0c04a5d7a26$var$getTextDirection;


/* eslint-disable class-methods-use-this */ /**
 * Core plugin logic that all plugins share.
 *
 * BasePlugin does not contain DOM rendering so it can be used for plugins
 * without a user interface.
 *
 * See `Plugin` for the extended version with Preact rendering for interfaces.
 */ 
class $336df15d01030489$export$2e2bcd8739ae039 {
    constructor(uppy, opts){
        this.uppy = uppy;
        this.opts = opts != null ? opts : {};
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return (plugins == null ? void 0 : plugins[this.id]) || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(undefined); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new (0, $a85fd1efd23057e0$export$2e2bcd8739ae039)([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(undefined); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addTarget(plugin) {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(state) {}
    // Called after every state update, after everything's mounted. Debounced.
    afterUpdate() {}
}


function $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $5d08dd66a9cc6899$var$id = 0;
function $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $5d08dd66a9cc6899$var$id++ + "_" + e;
}
/**
 * Defer a frequent call to the microtask queue.
 */ function $5d08dd66a9cc6899$var$debounce(fn) {
    let calling = null;
    let latestArgs;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null;
            // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $5d08dd66a9cc6899$var$_updateUI = /*#__PURE__*/ $5d08dd66a9cc6899$var$_classPrivateFieldLooseKey("updateUI");
class $5d08dd66a9cc6899$var$UIPlugin extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $5d08dd66a9cc6899$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    getTargetPlugin(target // eslint-disable-line no-use-before-define
    ) {
        let targetPlugin;
        if (typeof (target == null ? void 0 : target.addTarget) === "function") {
            // Targeting a plugin *instance*
            targetPlugin = target;
            if (!(targetPlugin instanceof $5d08dd66a9cc6899$var$UIPlugin)) // eslint-disable-next-line no-console
            console.warn(new Error("The provided plugin is not an instance of UIPlugin. This is an indication of a bug with the way Uppy is bundled.", {
                cause: {
                    targetPlugin: targetPlugin,
                    UIPlugin: $5d08dd66a9cc6899$var$UIPlugin
                }
            }));
        } else if (typeof target === "function") {
            // Targeting a plugin type
            const Target = target;
            // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        return targetPlugin;
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, // eslint-disable-line no-use-before-define
    plugin) {
        const callerPluginName = plugin.id;
        const targetElement = (0, $1866f8238923bb5d$export$2e2bcd8739ae039)(target);
        if (targetElement) {
            this.isTargetDOMEl = true;
            // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement("div");
            uppyRootElement.classList.add("uppy-Root");
            // API for plugins that require a synchronous rerender.
            $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI)[$5d08dd66a9cc6899$var$_updateUI] = $5d08dd66a9cc6899$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.destroy
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $2c57945ee961e217$export$b3890eb0ae9dca99)(this.render(state, uppyRootElement), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = "";
            (0, $2c57945ee961e217$export$b3890eb0ae9dca99)(this.render(this.uppy.getState(), uppyRootElement), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement);
            // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(uppyRootElement) || "ltr";
            this.onMount();
            return this.el;
        }
        const targetPlugin = this.getTargetPlugin(target);
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === "function") message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    state, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    container) {
        throw new Error("Extend the render method to add your plugin to a DOM element");
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $5d08dd66a9cc6899$var$_classPrivateFieldLooseBase(this, $5d08dd66a9cc6899$var$_updateUI))[$5d08dd66a9cc6899$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
var $5d08dd66a9cc6899$export$2e2bcd8739ae039 = $5d08dd66a9cc6899$var$UIPlugin;



/**
 * Low-pass filter using Exponential Moving Averages (aka exponential smoothing)
 * Filters a sequence of values by updating the mixing the previous output value
 * with the new input using the exponential window function
 *
 * @param newValue the n-th value of the sequence
 * @param previousSmoothedValue the exponential average of the first n-1 values
 * @param halfLife value of `dt` to move the smoothed value halfway between `previousFilteredValue` and `newValue`
 * @param dt time elapsed between adding the (n-1)th and the n-th values
 * @returns the exponential average of the first n values
 */ function $4e5b770b58150a1e$export$2e2bcd8739ae039(newValue, previousSmoothedValue, halfLife, dt) {
    if (halfLife === 0 || newValue === previousSmoothedValue) return newValue;
    if (dt === 0) return previousSmoothedValue;
    return newValue + (previousSmoothedValue - newValue) * 2 ** (-dt / halfLife);
}



var $5278b2bb79ab63f5$export$2e2bcd8739ae039 = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete"
};



var $02c2aab7657be691$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $02c2aab7657be691$exports) {
        classNames.default = classNames;
        $02c2aab7657be691$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



function $3d16a6a6f033a885$export$2e2bcd8739ae039(files) {
    const values = [];
    let mode = "indeterminate";
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress;
        // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if ((preprocess == null ? void 0 : preprocess.mode) === "determinate") values.push(preprocess.value);
        if ((postprocess == null ? void 0 : postprocess.mode) === "determinate") values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}





function $1bd6564471caa0d9$export$2e2bcd8739ae039(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}


function $cf4f21df8a3b103f$export$2e2bcd8739ae039(seconds) {
    const time = (0, $1bd6564471caa0d9$export$2e2bcd8739ae039)(seconds);
    // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
    const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}



const $c0c4f933fc4ac9a2$var$DOT = `\u00B7`;
const $c0c4f933fc4ac9a2$var$renderDot = ()=>` ${$c0c4f933fc4ac9a2$var$DOT} `;
function $c0c4f933fc4ac9a2$export$8fd979504d9f59d1(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
        "uppy-c-btn-primary": uploadState === (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING
    }, {
        "uppy-StatusBar-actionBtn--disabled": isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
        smart_count: newFiles
    }) : i18n("uploadXFiles", {
        smart_count: newFiles
    });
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true
    }, uploadBtnText);
}
function $c0c4f933fc4ac9a2$export$d0263dca13d9e524(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n("retryUpload"),
        onClick: ()=>uppy.retryAll().catch(()=>{
            /* Error reported and handled via an event */ }),
        "data-uppy-super-focusable": true,
        "data-cy": "retry"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "8",
        height: "10",
        viewBox: "0 0 8 10"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
    })), i18n("retry"));
}
function $c0c4f933fc4ac9a2$export$bda6e5e4654fa168(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n("cancel"),
        "aria-label": i18n("cancel"),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
    }))));
}
function $c0c4f933fc4ac9a2$export$f8fda1be68e432db(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n("resume") : i18n("pause");
    function togglePauseResume() {
        if (isAllComplete) return;
        if (!resumableUploads) {
            uppy.cancelAll();
            return;
        }
        if (isAllPaused) {
            uppy.resumeAll();
            return;
        }
        uppy.pauseAll();
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-cy": "togglePauseResume",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
    }))));
}
function $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true
    }, i18n("done"));
}
function $c0c4f933fc4ac9a2$export$b08b517936747730() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
        fillRule: "evenodd"
    }));
}
function $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const dot = `\u00B7`;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null), mode === "determinate" ? `${Math.round(value * 100)}% ${dot} ` : "", message);
}
function $c0c4f933fc4ac9a2$export$511da99642518663(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-StatusBar-additionalInfo"
    }, ifShowFilesUploadedOfTotal && $c0c4f933fc4ac9a2$var$renderDot(), i18n("dataUploadedOfTotal", {
        complete: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalUploadedSize),
        total: (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(totalSize)
    }), $c0c4f933fc4ac9a2$var$renderDot(), i18n("xTimeLeft", {
        time: (0, $cf4f21df8a3b103f$export$2e2bcd8739ae039)(totalETA)
    })));
}
function $c0c4f933fc4ac9a2$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }));
}
function $c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusSecondaryHint"
    }, i18n("xMoreFilesAdded", {
        smart_count: newFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload
    }, i18n("upload")));
}
function $c0c4f933fc4ac9a2$export$2d75d7371a967988(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n("paused") : i18n("uploading");
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$511da99642518663, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        "aria-label": title,
        title: title
    }, !isAllPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$export$b08b517936747730, null) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, supportsUploadProgress ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$UploadNewlyAddedFiles, {
        i18n: i18n,
        newFiles: newFiles,
        startUpload: startUpload
    }) : null));
}
function $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e(props) {
    const { i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        role: "status",
        title: i18n("complete")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
    })), i18n("complete"))));
}
function $c0c4f933fc4ac9a2$export$7331502eb9534bdb(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n("uploadFailed")} \n\n ${error}`;
        // eslint-disable-next-line no-alert
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-content",
        title: i18n("uploadFailed")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, i18n("uploadFailed"), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-StatusBar-details",
        "aria-label": i18n("showErrorDetails"),
        "data-microtip-position": "top-right",
        "data-microtip-size": "medium",
        onClick: displayErrorAlert,
        type: "button"
    }, "?")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($c0c4f933fc4ac9a2$var$FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
    })));
}


const { STATE_ERROR: $4af84b49d740c94f$var$STATE_ERROR, STATE_WAITING: $4af84b49d740c94f$var$STATE_WAITING, STATE_PREPROCESSING: $4af84b49d740c94f$var$STATE_PREPROCESSING, STATE_UPLOADING: $4af84b49d740c94f$var$STATE_UPLOADING, STATE_POSTPROCESSING: $4af84b49d740c94f$var$STATE_POSTPROCESSING, STATE_COMPLETE: $4af84b49d740c94f$var$STATE_COMPLETE } = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039);
function $4af84b49d740c94f$export$2e2bcd8739ae039(_ref) {
    let { newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton = false, hideCancelButton: hideCancelButton = false, hideRetryButton: hideRetryButton = false, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish = false, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize } = _ref;
    function getProgressValue() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const progress = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    if (progress.mode === "determinate") return progress.value * 100;
                    return totalProgress;
                }
            case $4af84b49d740c94f$var$STATE_ERROR:
                return null;
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files);
                    return mode === "indeterminate";
                }
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const width = progressValue != null ? progressValue : 100;
    const showUploadBtn = !error && newFiles && (!isUploadInProgress && !isAllPaused || recoveredState) && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $4af84b49d740c94f$var$STATE_WAITING && uploadState !== $4af84b49d740c94f$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $4af84b49d740c94f$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $4af84b49d740c94f$var$STATE_COMPLETE;
    const progressClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar-progress", {
        "is-indeterminate": getIsIndeterminate()
    });
    const statusBarClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-StatusBar", `is-${uploadState}`, {
        "has-ghosts": isSomeGhost
    });
    const progressBarStateEl = (()=>{
        switch(uploadState){
            case $4af84b49d740c94f$var$STATE_PREPROCESSING:
            case $4af84b49d740c94f$var$STATE_POSTPROCESSING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f10e066f2fffa2e8), {
                    progress: (0, $3d16a6a6f033a885$export$2e2bcd8739ae039)(files)
                });
            case $4af84b49d740c94f$var$STATE_COMPLETE:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8dc84f0e764ad25e), {
                    i18n: i18n
                });
            case $4af84b49d740c94f$var$STATE_ERROR:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$7331502eb9534bdb), {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $4af84b49d740c94f$var$STATE_UPLOADING:
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$2d75d7371a967988), {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })();
    const atLeastOneAction = showUploadBtn || showRetryBtn || showPauseResumeBtn || showCancelBtn || showDoneBtn;
    const thereIsNothingInside = !atLeastOneAction && !progressBarStateEl;
    const isHidden = thereIsNothingInside || uploadState === $4af84b49d740c94f$var$STATE_COMPLETE && hideAfterFinish;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: statusBarClassNames,
        "aria-hidden": isHidden
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: progressClassNames,
        style: {
            width: `${width}%`
        },
        role: "progressbar",
        "aria-label": `${width}%`,
        "aria-valuetext": `${width}%`,
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": progressValue
    }), progressBarStateEl, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-StatusBar-actions"
    }, showUploadBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$8fd979504d9f59d1), {
        newFiles: newFiles,
        isUploadStarted: isUploadStarted,
        recoveredState: recoveredState,
        i18n: i18n,
        isSomeGhost: isSomeGhost,
        startUpload: startUpload,
        uploadState: uploadState
    }) : null, showRetryBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$d0263dca13d9e524), {
        i18n: i18n,
        uppy: uppy
    }) : null, showPauseResumeBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$f8fda1be68e432db), {
        isAllPaused: isAllPaused,
        i18n: i18n,
        isAllComplete: isAllComplete,
        resumableUploads: resumableUploads,
        uppy: uppy
    }) : null, showCancelBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$bda6e5e4654fa168), {
        i18n: i18n,
        uppy: uppy
    }) : null, showDoneBtn ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $c0c4f933fc4ac9a2$export$c5b3ad0eb3665a4a), {
        i18n: i18n,
        doneButtonHandler: doneButtonHandler
    }) : null));
}


var $f9ab456b3e2aaacb$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: "Uploading",
        // Shown in the status bar once all files have been uploaded.
        complete: "Complete",
        // Shown in the status bar if an upload failed.
        uploadFailed: "Upload failed",
        // Shown in the status bar while the upload is paused.
        paused: "Paused",
        // Used as the label for the button that retries an upload.
        retry: "Retry",
        // Used as the label for the button that cancels an upload.
        cancel: "Cancel",
        // Used as the label for the button that pauses an upload.
        pause: "Pause",
        // Used as the label for the button that resumes an upload.
        resume: "Resume",
        // Used as the label for the button that resets the upload state after an upload
        done: "Done",
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: "%{complete} of %{smart_count} file uploaded",
            1: "%{complete} of %{smart_count} files uploaded"
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: "%{complete} of %{total}",
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: "%{time} left",
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: "Upload %{smart_count} file",
            1: "Upload %{smart_count} files"
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: "Upload +%{smart_count} file",
            1: "Upload +%{smart_count} files"
        },
        upload: "Upload",
        retryUpload: "Retry upload",
        xMoreFilesAdded: {
            0: "%{smart_count} more file added",
            1: "%{smart_count} more files added"
        },
        showErrorDetails: "Show error details"
    }
};


function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $f22a72e7b80fdb1a$var$id = 0;
function $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $f22a72e7b80fdb1a$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f22a72e7b80fdb1a$var$packageJson = {
    "version": "4.0.4"
};
const $f22a72e7b80fdb1a$var$speedFilterHalfLife = 2000;
const $f22a72e7b80fdb1a$var$ETAFilterHalfLife = 2000;
function $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_ERROR;
    if (isAllComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_COMPLETE;
    if (recoveredState) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    let state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_PREPROCESSING) state = (0, $5278b2bb79ab63f5$export$2e2bcd8739ae039).STATE_POSTPROCESSING;
    }
    return state;
}
const $f22a72e7b80fdb1a$var$defaultOptions = {
    hideUploadButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideCancelButton: false,
    showProgressDetails: false,
    hideAfterFinish: true,
    doneButtonHandler: null
};
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */ var $f22a72e7b80fdb1a$var$_lastUpdateTime = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("lastUpdateTime");
var $f22a72e7b80fdb1a$var$_previousUploadedBytes = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousUploadedBytes");
var $f22a72e7b80fdb1a$var$_previousSpeed = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousSpeed");
var $f22a72e7b80fdb1a$var$_previousETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("previousETA");
var $f22a72e7b80fdb1a$var$_computeSmoothETA = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("computeSmoothETA");
var $f22a72e7b80fdb1a$var$_onUploadStart = /*#__PURE__*/ $f22a72e7b80fdb1a$var$_classPrivateFieldLooseKey("onUploadStart");
class $f22a72e7b80fdb1a$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f22a72e7b80fdb1a$var$defaultOptions,
            ...opts
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_computeSmoothETA, {
            value: $f22a72e7b80fdb1a$var$_computeSmoothETA2
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_lastUpdateTime, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousSpeed, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_previousETA, {
            writable: true,
            value: void 0
        });
        this.startUpload = ()=>{
            return this.uppy.upload().catch(()=>{
            // Error logged in Core
            });
        };
        Object.defineProperty(this, $f22a72e7b80fdb1a$var$_onUploadStart, {
            writable: true,
            value: ()=>{
                const { recoveredState: recoveredState } = this.uppy.getState();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = null;
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = null;
                if (recoveredState) {
                    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = Object.values(recoveredState.files).reduce((pv, _ref)=>{
                        let { progress: progress } = _ref;
                        return pv + progress.bytesUploaded;
                    }, 0);
                    // We don't set `#lastUpdateTime` at this point because the upload won't
                    // actually resume until the user asks for it.
                    this.uppy.emit("restore-confirmed");
                    return;
                }
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
                $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = 0;
            }
        });
        this.id = this.opts.id || "StatusBar";
        this.title = "StatusBar";
        this.type = "progressindicator";
        this.defaultLocale = (0, $f9ab456b3e2aaacb$export$2e2bcd8739ae039);
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState();
        // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = 0;
        let totalUploadedSize = 0;
        startedFiles.forEach((file)=>{
            totalSize += file.progress.bytesTotal || 0;
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        const totalETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_computeSmoothETA)[$f22a72e7b80fdb1a$var$_computeSmoothETA]({
            uploaded: totalUploadedSize,
            total: totalSize,
            remaining: totalSize - totalUploadedSize
        });
        return (0, $4af84b49d740c94f$export$2e2bcd8739ae039)({
            error: error,
            uploadState: $f22a72e7b80fdb1a$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = (0, $82cce0c04a5d7a26$export$2e2bcd8739ae039)(element);
        if (!direction) element.dir = "ltr";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
        this.uppy.on("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
        // To cover the use case where the status bar is installed while the upload
        // has started, we set `lastUpdateTime` right away.
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
        $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = this.uppy.getFiles().reduce((pv, file)=>pv + file.progress.bytesUploaded, 0);
    }
    uninstall() {
        this.unmount();
        this.uppy.off("upload", $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_onUploadStart)[$f22a72e7b80fdb1a$var$_onUploadStart]);
    }
}
function $f22a72e7b80fdb1a$var$_computeSmoothETA2(totalBytes) {
    var _classPrivateFieldLoo, _classPrivateFieldLoo2;
    if (totalBytes.total === 0 || totalBytes.remaining === 0) return 0;
    // When state is restored, lastUpdateTime is still nullish at this point.
    (_classPrivateFieldLoo2 = (_classPrivateFieldLoo = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime))[$f22a72e7b80fdb1a$var$_lastUpdateTime]) != null ? _classPrivateFieldLoo2 : _classPrivateFieldLoo[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    const dt = performance.now() - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime];
    if (dt === 0) {
        var _classPrivateFieldLoo3;
        return Math.round(((_classPrivateFieldLoo3 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo3 : 0) / 100) / 10;
    }
    const uploadedBytesSinceLastTick = totalBytes.uploaded - $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes];
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousUploadedBytes)[$f22a72e7b80fdb1a$var$_previousUploadedBytes] = totalBytes.uploaded;
    // uploadedBytesSinceLastTick can be negative in some cases (packet loss?)
    // in which case, we wait for next tick to update ETA.
    if (uploadedBytesSinceLastTick <= 0) {
        var _classPrivateFieldLoo4;
        return Math.round(((_classPrivateFieldLoo4 = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA]) != null ? _classPrivateFieldLoo4 : 0) / 100) / 10;
    }
    const currentSpeed = uploadedBytesSinceLastTick / dt;
    const filteredSpeed = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] == null ? currentSpeed : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(currentSpeed, $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed], $f22a72e7b80fdb1a$var$speedFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousSpeed)[$f22a72e7b80fdb1a$var$_previousSpeed] = filteredSpeed;
    const instantETA = totalBytes.remaining / filteredSpeed;
    const updatedPreviousETA = Math.max($f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] - dt, 0);
    const filteredETA = $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] == null ? instantETA : (0, $4e5b770b58150a1e$export$2e2bcd8739ae039)(instantETA, updatedPreviousETA, $f22a72e7b80fdb1a$var$ETAFilterHalfLife, dt);
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_previousETA)[$f22a72e7b80fdb1a$var$_previousETA] = filteredETA;
    $f22a72e7b80fdb1a$var$_classPrivateFieldLooseBase(this, $f22a72e7b80fdb1a$var$_lastUpdateTime)[$f22a72e7b80fdb1a$var$_lastUpdateTime] = performance.now();
    return Math.round(filteredETA / 100) / 10;
}
$f22a72e7b80fdb1a$export$2e2bcd8739ae039.VERSION = $f22a72e7b80fdb1a$var$packageJson.version;




/* eslint-disable jsx-a11y/no-noninteractive-element-interactions  */ /* eslint-disable jsx-a11y/click-events-have-key-events */ 


const $aaa56faedf37f661$var$TRANSITION_MS = 300;
class $aaa56faedf37f661$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.ref = (0, $4d2e93495e50cc85$export$7d1e3a5e95ceca43)();
    }
    componentWillEnter(callback) {
        this.ref.current.style.opacity = "1";
        this.ref.current.style.transform = "none";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = "0";
        this.ref.current.style.transform = "translateY(350%)";
        setTimeout(callback, $aaa56faedf37f661$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref
        }, children);
    }
}


// INFO: not typing copy pasted libarary code
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable */ /**
 * @source https://github.com/developit/preact-transition-group
 */ 
function $39136bc8da03ed4c$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $39136bc8da03ed4c$var$getKey(vnode, fallback) {
    var _vnode$key;
    return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function $39136bc8da03ed4c$var$linkRef(component, name) {
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $39136bc8da03ed4c$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $39136bc8da03ed4c$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $39136bc8da03ed4c$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>next.hasOwnProperty(key) ? next[key] : prev[key];
    // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    }
    // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $39136bc8da03ed4c$var$identity = (i)=>i;
class $39136bc8da03ed4c$var$TransitionGroup extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $39136bc8da03ed4c$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (nextChildMapping.hasOwnProperty(key)) {
            const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
            // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (prevChildMapping.hasOwnProperty(key)) {
            const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component != null && component.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component != null && component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component != null && component.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $39136bc8da03ed4c$var$getChildMapping((0, $4d2e93495e50cc85$export$47e4c5b300681277)(this.props.children) || []);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $39136bc8da03ed4c$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render(_ref, _ref2) {
        let { childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props } = _ref;
        let { children: children } = _ref2;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = Object.entries(children).map((_ref3)=>{
            let [key, child] = _ref3;
            if (!child) return undefined;
            const ref = $39136bc8da03ed4c$var$linkRef(this, key);
            return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(childFactory(child), {
                ref: ref,
                key: key
            });
        }).filter(Boolean);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(component, props, childrenToRender);
    }
}
$39136bc8da03ed4c$var$TransitionGroup.defaultProps = {
    component: "span",
    childFactory: $39136bc8da03ed4c$var$identity
};
var $39136bc8da03ed4c$export$2e2bcd8739ae039 = $39136bc8da03ed4c$var$TransitionGroup;


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $2d1e3e0d76faae78$var$packageJson = {
    "version": "4.1.1"
};
class $2d1e3e0d76faae78$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, opts);
        this.render = (state)=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy uppy-Informer"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $39136bc8da03ed4c$export$2e2bcd8739ae039), null, state.info.map((info)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aaa56faedf37f661$export$2e2bcd8739ae039), {
                    key: info.message
                }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("p", {
                    role: "alert"
                }, info.message, " ", info.details && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                    "aria-label": info.details,
                    "data-microtip-position": "top-left",
                    "data-microtip-size": "medium",
                    role: "tooltip",
                    onClick: ()=>// eslint-disable-next-line no-alert
                        alert(`${info.message} \n\n ${info.details}`)
                }, "?"))))));
        };
        this.type = "progressindicator";
        this.id = this.opts.id || "Informer";
        this.title = "Informer";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}
$2d1e3e0d76faae78$export$2e2bcd8739ae039.VERSION = $2d1e3e0d76faae78$var$packageJson.version;





const $8f6efe9c4afa65c2$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $8f6efe9c4afa65c2$var$dataURItoBlob(dataURI, opts, toFile) {
    var _ref, _opts$mimeType;
    // get the base64 data
    const dataURIData = $8f6efe9c4afa65c2$var$DATA_URL_PATTERN.exec(dataURI);
    // user may provide mime type, if not get it from data URI
    const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
    let data; // We add `!` to tell TS we're OK with `data` being not defined when the dataURI is invalid.
    if ((dataURIData == null ? void 0 : dataURIData[2]) != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else if ((dataURIData == null ? void 0 : dataURIData[3]) != null) data = [
        decodeURIComponent(dataURIData[3])
    ];
    // Convert to a File?
    if (toFile) return new File(data, opts.name || "", {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}
var $8f6efe9c4afa65c2$export$2e2bcd8739ae039 = $8f6efe9c4afa65c2$var$dataURItoBlob;


/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 */ function $3b72dc28c9f79a38$export$2e2bcd8739ae039(url) {
    return url.startsWith("blob:");
}


function $2e3a76623b3bbcc9$export$2e2bcd8739ae039(fileType) {
    if (!fileType) return false;
    // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}



var $gnS5A = parcelRequire("gnS5A");
var $7785655e028eb2bd$export$2e2bcd8739ae039 = {
    strings: {
        generatingThumbnails: "Generating thumbnails..."
    }
};


// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $f92c4ad36d89e394$var$packageJson = {
    "version": "4.0.1"
};
/**
 * Save a <canvas> element's content to a Blob object.
 *
 */ function $f92c4ad36d89e394$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext("2d").getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error("cannot read image, probably an svg with external resources");
        return blob;
    });
    return Promise.resolve().then(()=>{
        return (0, $8f6efe9c4afa65c2$export$2e2bcd8739ae039)(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error("could not extract blob, probably an old browser");
        return blob;
    });
}
function $f92c4ad36d89e394$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $f92c4ad36d89e394$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement("canvas");
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
const $f92c4ad36d89e394$var$defaultOptions = {
    thumbnailWidth: null,
    thumbnailHeight: null,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    lazy: false
};
class $f92c4ad36d89e394$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    constructor(uppy, opts){
        super(uppy, {
            ...$f92c4ad36d89e394$var$defaultOptions,
            ...opts
        });
        this.onFileAdded = (file)=>{
            if (!file.preview && file.data && (0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) this.addToQueue(file.id);
        };
        /**
     * Cancel a lazy request for a thumbnail if the thumbnail has not yet been generated.
     */ this.onCancelRequest = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
        };
        /**
     * Clean up the thumbnail for a file. Cancel lazy requests and free the thumbnail URL.
     */ this.onFileRemoved = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
            // Clean up object URLs.
            if (file.preview && (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) URL.revokeObjectURL(file.preview);
        };
        this.onRestored = ()=>{
            const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
            restoredFiles.forEach((file)=>{
                // Only add blob URLs; they are likely invalid after being restored.
                if (!file.preview || (0, $3b72dc28c9f79a38$export$2e2bcd8739ae039)(file.preview)) this.addToQueue(file.id);
            });
        };
        this.onAllFilesRemoved = ()=>{
            this.queue = [];
        };
        this.waitUntilAllProcessed = (fileIDs)=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("preprocess-progress", file, {
                    mode: "indeterminate",
                    message: this.i18n("generatingThumbnails")
                });
            });
            const emitPreprocessCompleteForAll = ()=>{
                fileIDs.forEach((fileID)=>{
                    const file = this.uppy.getFile(fileID);
                    this.uppy.emit("preprocess-complete", file);
                });
            };
            return new Promise((resolve)=>{
                if (this.queueProcessing) this.uppy.once("thumbnail:all-generated", ()=>{
                    emitPreprocessCompleteForAll();
                    resolve();
                });
                else {
                    emitPreprocessCompleteForAll();
                    resolve();
                }
            });
        };
        this.type = "modifier";
        this.id = this.opts.id || "ThumbnailGenerator";
        this.title = "Thumbnail Generator";
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType;
        this.defaultLocale = (0, $7785655e028eb2bd$export$2e2bcd8739ae039);
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
    createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener("load", ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener("error", (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error("Could not create thumbnail"));
            });
        });
        const orientationPromise = (0, $gnS5A.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then((_ref)=>{
            let [image, orientation] = _ref;
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = $f92c4ad36d89e394$var$rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return $f92c4ad36d89e394$var$canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */ getProportionalDimensions(img, width, height, deg) {
        // eslint-disable-line no-shadow
        let aspect = img.width / img.height;
        if (deg === 90 || deg === 270) aspect = img.height / img.width;
        if (width != null) return {
            width: width,
            height: Math.round(width / aspect)
        };
        if (height != null) return {
            width: Math.round(height * aspect),
            height: height
        };
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */ // eslint-disable-next-line class-methods-use-this
    resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = $f92c4ad36d89e394$var$protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement("canvas");
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
   * Set the preview URL for a file.
   */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(fileID) {
        this.queue.push(fileID);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}) // eslint-disable-line node/handle-callback-err
            .then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
        this.uppy.emit("thumbnail:all-generated");
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ((0, $2e3a76623b3bbcc9$export$2e2bcd8739ae039)(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
            this.uppy.log(err, "warning");
            this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    install() {
        this.uppy.on("file-removed", this.onFileRemoved);
        this.uppy.on("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("file-added", this.onFileAdded);
            this.uppy.on("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off("file-removed", this.onFileRemoved);
        this.uppy.off("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("file-added", this.onFileAdded);
            this.uppy.off("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}
$f92c4ad36d89e394$export$2e2bcd8739ae039.VERSION = $f92c4ad36d89e394$var$packageJson.version;



/**
 * Find one or more DOM elements.
 */ function $3da4efa7f88c23a6$var$findAllDOMElements(element) {
    if (typeof element === "string") {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === "object" && (0, $dcdea5a9bf8353ff$export$2e2bcd8739ae039)(element)) return [
        element
    ];
    return null;
}
var $3da4efa7f88c23a6$export$2e2bcd8739ae039 = $3da4efa7f88c23a6$var$findAllDOMElements;


/**
 * Converts list into array
 */ var $d737086ca91a9c7d$export$2e2bcd8739ae039 = Array.from;


/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 */ function $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ];
        // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $b08bd893356e01b1$export$2e2bcd8739ae039(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        });
        else onSuccess(newEntries);
    }, // Make sure we resolve on error anyway, it's fine if only one directory couldn't be parsed!
    (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}


/**
 * Polyfill for the new (experimental) getAsFileSystemHandle API (using the popular webkitGetAsEntry behind the scenes)
 * so that we can switch to the getAsFileSystemHandle API once it (hopefully) becomes standard
 */ function $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        kind: // eslint-disable-next-line no-nested-ternary
        entry.isFile ? "file" : entry.isDirectory ? "directory" : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                (0, $b08bd893356e01b1$export$2e2bcd8739ae039)(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        },
        isSameEntry: undefined
    };
}
function $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(entry, relativePath, lastResortFile) {
    try {
        if (lastResortFile === void 0) lastResortFile = undefined;
        return async function*() {
            const getNextRelativePath = ()=>`${relativePath}/${entry.name}`;
            // For each dropped item, - make sure it's a file/directory, and start deepening in!
            if (entry.kind === "file") {
                const file = await entry.getFile();
                if (file != null) {
                    file.relativePath = relativePath ? getNextRelativePath() : null;
                    yield file;
                } else if (lastResortFile != null) yield lastResortFile;
            } else if (entry.kind === "directory") for await (const handle of entry.values())// Recurse on the directory, appending the dir name to the relative path
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(handle, relativePath ? getNextRelativePath() : entry.name);
            else if (lastResortFile != null) yield lastResortFile;
        }();
    } catch (e) {
        return Promise.reject(e);
    }
}
async function* $e30d9f0f4292db6d$export$2e2bcd8739ae039(dataTransfer, logDropError) {
    // Retrieving the dropped items must happen synchronously
    // otherwise only the first item gets treated and the other ones are garbage collected.
    // https://github.com/transloadit/uppy/pull/3998
    const fileSystemHandles = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        let fileSystemHandle;
        // TODO enable getAsFileSystemHandle API once we can get it working with subdirectories
        // IMPORTANT: Need to check isSecureContext *before* calling getAsFileSystemHandle
        // or else Chrome will crash when running in HTTP: https://github.com/transloadit/uppy/issues/4133
        // if (window.isSecureContext && item.getAsFileSystemHandle != null)
        // fileSystemHandle = await item.getAsFileSystemHandle()
        // `webkitGetAsEntry` exists in all popular browsers (including non-WebKit browsers),
        // however it may be renamed to getAsEntry() in the future, so you should code defensively, looking for both.
        // from https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem/webkitGetAsEntry
        const getAsEntry = ()=>typeof item.getAsEntry === "function" ? item.getAsEntry() : item.webkitGetAsEntry();
        // eslint-disable-next-line prefer-const
        fileSystemHandle != null ? fileSystemHandle : fileSystemHandle = $e30d9f0f4292db6d$var$getAsFileSystemHandleFromEntry(getAsEntry(), logDropError);
        return {
            fileSystemHandle: fileSystemHandle,
            lastResortFile: item.getAsFile() // can be used as a fallback in case other methods fail
        };
    }));
    for (const { lastResortFile: lastResortFile, fileSystemHandle: fileSystemHandle } of fileSystemHandles){
        // fileSystemHandle and lastResortFile can be null when we drop an url.
        if (fileSystemHandle != null) try {
            yield* $e30d9f0f4292db6d$var$createPromiseToAddFileOrParseDirectory(fileSystemHandle, "", lastResortFile);
        } catch (err) {
            // Example: If dropping a symbolic link, Chromium will throw:
            // "DOMException: A requested file or directory could not be found at the time an operation was processed.",
            // So we will use lastResortFile instead. See https://github.com/transloadit/uppy/issues/3505.
            if (lastResortFile != null) yield lastResortFile;
            else logDropError(err);
        }
        else if (lastResortFile != null) yield lastResortFile;
    }
}



function $d5d92a586549e3b5$export$2e2bcd8739ae039(dataTransfer) {
    const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(dataTransfer.files);
    return Promise.resolve(files);
}


async function $954bacbcaff60289$export$2e2bcd8739ae039(dataTransfer, options) {
    var _options$logDropError;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    const logDropError = (_options$logDropError = options == null ? void 0 : options.logDropError) != null ? _options$logDropError : Function.prototype;
    try {
        const accumulator = [];
        for await (const file of (0, $e30d9f0f4292db6d$export$2e2bcd8739ae039)(dataTransfer, logDropError))accumulator.push(file);
        return accumulator;
    // Otherwise just return all first-order files
    } catch  {
        return (0, $d5d92a586549e3b5$export$2e2bcd8739ae039)(dataTransfer);
    }
}





function $d0cca3c9705b0857$export$2e2bcd8739ae039(file) {
    return {
        ...file,
        type: file.mimeType,
        extension: file.name ? (0, $09afbe8d004816d5$export$2e2bcd8739ae039)(file.name).extension : null
    };
}




function $616f0acd28bd0dc4$var$GoogleIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        width: "26",
        height: "26",
        viewBox: "0 0 26 26",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "none",
        "fill-rule": "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#FFF",
        cx: "13",
        cy: "13",
        r: "13"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M21.64 13.205c0-.639-.057-1.252-.164-1.841H13v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z",
        fill: "#4285F4",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 22c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H4.957v2.332A8.997 8.997 0 0013 22z",
        fill: "#34A853",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.964 14.71A5.41 5.41 0 017.682 13c0-.593.102-1.17.282-1.71V8.958H4.957A8.996 8.996 0 004 13c0 1.452.348 2.827.957 4.042l3.007-2.332z",
        fill: "#FBBC05",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M13 7.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C17.463 4.891 15.426 4 13 4a8.997 8.997 0 00-8.043 4.958l3.007 2.332C8.672 9.163 10.656 7.58 13 7.58z",
        fill: "#EA4335",
        "fill-rule": "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4 4h18v18H4z"
    })));
}
function $616f0acd28bd0dc4$var$DefaultForm(_ref) {
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref;
    // In order to comply with Google's brand we need to create a different button
    // for the Google Drive plugin
    const isGoogleDrive = pluginName === "Google Drive";
    const onSubmit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((e)=>{
        e.preventDefault();
        onAuth();
    }, [
        onAuth
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("form", {
        onSubmit: onSubmit
    }, isGoogleDrive ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn uppy-Provider-btn-google",
        "data-uppy-super-focusable": true
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$GoogleIcon, null), i18n("signInWithGoogle")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "submit",
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Provider-authBtn",
        "data-uppy-super-focusable": true
    }, i18n("authenticateWith", {
        pluginName: pluginName
    })));
}
const $616f0acd28bd0dc4$var$defaultRenderForm = (_ref2)=>{
    let { pluginName: pluginName, i18n: i18n, onAuth: onAuth } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($616f0acd28bd0dc4$var$DefaultForm, {
        pluginName: pluginName,
        i18n: i18n,
        onAuth: onAuth
    });
};
function $616f0acd28bd0dc4$export$2e2bcd8739ae039(_ref3) {
    let { loading: loading, pluginName: pluginName, pluginIcon: pluginIcon, i18n: i18n, handleAuth: handleAuth, renderForm: renderForm = $616f0acd28bd0dc4$var$defaultRenderForm } = _ref3;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-auth"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authIcon"
    }, pluginIcon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authTitle"
    }, i18n("authenticateWithTitle", {
        pluginName: pluginName
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-authForm"
    }, renderForm({
        pluginName: pluginName,
        i18n: i18n,
        loading: loading,
        onAuth: handleAuth
    })));
}


/* eslint-disable react/destructuring-assignment */ 


function $4ee9dcacd7f26785$export$2e2bcd8739ae039(_ref) {
    let { i18n: i18n, logout: logout, username: username } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, username && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-ProviderBrowser-user",
        key: "username"
    }, username), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        onClick: logout,
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowser-userLogout",
        key: "logout"
    }, i18n("logOut")));
}



function $48839592a474f204$export$2e2bcd8739ae039(props) {
    const { openFolder: openFolder, title: title, breadcrumbsIcon: breadcrumbsIcon, breadcrumbs: breadcrumbs, i18n: i18n } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbs"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-breadcrumbsIcon"
    }, breadcrumbsIcon), breadcrumbs.map((folder, index)=>{
        var _folder$data$name;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
            key: folder.id,
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            onClick: ()=>openFolder(folder.id)
        }, folder.type === "root" ? title : (_folder$data$name = folder.data.name) != null ? _folder$data$name : i18n("unnamed")), breadcrumbs.length === index + 1 ? "" : " / ");
    }));
}


function $6b1b801e011f359f$export$2e2bcd8739ae039(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-header"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser-headerBar", !props.showBreadcrumbs && "uppy-ProviderBrowser-headerBar--simple")
    }, props.showBreadcrumbs && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $48839592a474f204$export$2e2bcd8739ae039), {
        openFolder: props.openFolder,
        breadcrumbs: props.breadcrumbs,
        breadcrumbsIcon: props.pluginIcon && props.pluginIcon(),
        title: props.title,
        i18n: props.i18n
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ee9dcacd7f26785$export$2e2bcd8739ae039), {
        logout: props.logout,
        username: props.username,
        i18n: props.i18n
    })));
}




function $aba06cd85441b3f8$var$_extends() {
    return $aba06cd85441b3f8$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $aba06cd85441b3f8$var$_extends.apply(null, arguments);
}
const $aba06cd85441b3f8$var$STYLE_INNER = {
    position: "relative",
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: "100%",
    minHeight: "100%"
};
const $aba06cd85441b3f8$var$STYLE_CONTENT = {
    position: "absolute",
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: "100%",
    overflow: "visible"
};
class $aba06cd85441b3f8$var$VirtualList extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(props){
        super(props);
        // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.handleScroll = ()=>{
            this.setState({
                offset: this.base.scrollTop
            });
        };
        this.handleResize = ()=>{
            this.resize();
        };
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener("resize", this.handleResize);
    }
    // TODO: refactor to stable lifecycle method
    // eslint-disable-next-line
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render(_ref) {
        let { data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props } = _ref;
        const { offset: offset, height: height } = this.state;
        // first visible row index
        let start = Math.floor(offset / rowHeight);
        // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight);
        // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        }
        // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4;
        // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$aba06cd85441b3f8$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$aba06cd85441b3f8$var$STYLE_CONTENT,
            top: start * rowHeight
        };
        // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return(// eslint-disable-next-line react/jsx-props-no-spreading
        (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", $aba06cd85441b3f8$var$_extends({
            onScroll: this.handleScroll
        }, props), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleInner
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            role: "presentation",
            style: styleContent
        }, selection.map(renderRow)))));
    }
}
var $aba06cd85441b3f8$export$2e2bcd8739ae039 = $aba06cd85441b3f8$var$VirtualList;



/* eslint-disable react/jsx-props-no-spreading */ 



function $eeb730e0d52603b2$var$FileIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: 11,
        height: 14.5,
        viewBox: "0 0 44 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M27.437.517a1 1 0 0 0-.094.03H4.25C2.037.548.217 2.368.217 4.58v48.405c0 2.212 1.82 4.03 4.03 4.03H39.03c2.21 0 4.03-1.818 4.03-4.03V15.61a1 1 0 0 0-.03-.28 1 1 0 0 0 0-.093 1 1 0 0 0-.03-.032 1 1 0 0 0 0-.03 1 1 0 0 0-.032-.063 1 1 0 0 0-.03-.063 1 1 0 0 0-.032 0 1 1 0 0 0-.03-.063 1 1 0 0 0-.032-.03 1 1 0 0 0-.03-.063 1 1 0 0 0-.063-.062l-14.593-14a1 1 0 0 0-.062-.062A1 1 0 0 0 28 .708a1 1 0 0 0-.374-.157 1 1 0 0 0-.156 0 1 1 0 0 0-.03-.03l-.003-.003zM4.25 2.547h22.218v9.97c0 2.21 1.82 4.03 4.03 4.03h10.564v36.438a2.02 2.02 0 0 1-2.032 2.032H4.25c-1.13 0-2.032-.9-2.032-2.032V4.58c0-1.13.902-2.032 2.03-2.032zm24.218 1.345l10.375 9.937.75.718H30.5c-1.13 0-2.032-.9-2.032-2.03V3.89z"
    }));
}
function $eeb730e0d52603b2$var$FolderIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        style: {
            minWidth: 16,
            marginRight: 3
        },
        viewBox: "0 0 276.157 276.157"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M273.08 101.378c-3.3-4.65-8.86-7.32-15.254-7.32h-24.34V67.59c0-10.2-8.3-18.5-18.5-18.5h-85.322c-3.63 0-9.295-2.875-11.436-5.805l-6.386-8.735c-4.982-6.814-15.104-11.954-23.546-11.954H58.73c-9.292 0-18.638 6.608-21.737 15.372l-2.033 5.752c-.958 2.71-4.72 5.37-7.596 5.37H18.5C8.3 49.09 0 57.39 0 67.59v167.07c0 .886.16 1.73.443 2.52.152 3.306 1.18 6.424 3.053 9.064 3.3 4.652 8.86 7.32 15.255 7.32h188.487c11.395 0 23.27-8.425 27.035-19.18l40.677-116.188c2.11-6.035 1.43-12.164-1.87-16.816zM18.5 64.088h8.864c9.295 0 18.64-6.607 21.738-15.37l2.032-5.75c.96-2.712 4.722-5.373 7.597-5.373h29.565c3.63 0 9.295 2.876 11.437 5.806l6.386 8.735c4.982 6.815 15.104 11.954 23.546 11.954h85.322c1.898 0 3.5 1.602 3.5 3.5v26.47H69.34c-11.395 0-23.27 8.423-27.035 19.178L15 191.23V67.59c0-1.898 1.603-3.5 3.5-3.5zm242.29 49.15l-40.676 116.188c-1.674 4.78-7.812 9.135-12.877 9.135H18.75c-1.447 0-2.576-.372-3.02-.997-.442-.625-.422-1.814.057-3.18l40.677-116.19c1.674-4.78 7.812-9.134 12.877-9.134h188.487c1.448 0 2.577.372 3.02.997.443.625.423 1.814-.056 3.18z"
    }));
}
function $eeb730e0d52603b2$var$VideoIcon() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        style: {
            width: 16,
            marginRight: 4
        },
        viewBox: "0 0 58 58"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M36.537 28.156l-11-7a1.005 1.005 0 0 0-1.02-.033C24.2 21.3 24 21.635 24 22v14a1 1 0 0 0 1.537.844l11-7a1.002 1.002 0 0 0 0-1.688zM26 34.18V23.82L34.137 29 26 34.18z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M57 6H1a1 1 0 0 0-1 1v44a1 1 0 0 0 1 1h56a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM10 28H2v-9h8v9zm-8 2h8v9H2v-9zm10 10V8h34v42H12V40zm44-12h-8v-9h8v9zm-8 2h8v9h-8v-9zm8-22v9h-8V8h8zM2 8h8v9H2V8zm0 42v-9h8v9H2zm54 0h-8v-9h8v9z"
    }));
}
function $eeb730e0d52603b2$export$2e2bcd8739ae039(_ref) {
    let { itemIconString: itemIconString, alt: alt } = _ref;
    if (itemIconString === null) return null;
    switch(itemIconString){
        case "file":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FileIcon, null);
        case "folder":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$FolderIcon, null);
        case "video":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($eeb730e0d52603b2$var$VideoIcon, null);
        default:
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
                src: itemIconString,
                alt: alt,
                referrerPolicy: "no-referrer",
                loading: "lazy",
                width: 16,
                height: 16
            });
    }
}


function $79441ec2d5893efa$var$GridItem(_ref) {
    var _file$data$name, _file$data$name2;
    let { file: file, toggleCheckbox: toggleCheckbox, className: className, isDisabled: isDisabled, restrictionError: restrictionError, showTitles: showTitles, children: children = null, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: isDisabled && restrictionError ? restrictionError : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox uppy-ProviderBrowserItem-checkbox--grid",
        onChange: toggleCheckbox,
        name: "listitem",
        id: file.id,
        checked: file.status === "checked",
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: file.id,
        "aria-label": (_file$data$name = file.data.name) != null ? _file$data$name : i18n("unnamed"),
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.thumbnail || file.data.icon
    }), showTitles && ((_file$data$name2 = file.data.name) != null ? _file$data$name2 : i18n("unnamed")), children));
}
var $79441ec2d5893efa$export$2e2bcd8739ae039 = $79441ec2d5893efa$var$GridItem;




function $9b946df2ba2b33d0$export$2e2bcd8739ae039(_ref) {
    var _file$data$name, _file$data$name2, _file$data$name3;
    let { file: file, openFolder: openFolder, className: className, isDisabled: isDisabled, restrictionError: restrictionError, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("li", {
        className: className,
        title: file.status !== "checked" && restrictionError ? restrictionError : undefined
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        type: "checkbox",
        className: "uppy-u-reset uppy-ProviderBrowserItem-checkbox",
        onChange: toggleCheckbox,
        name: "listitem",
        id: file.id,
        checked: file.status === "checked",
        "aria-label": file.data.isFolder ? i18n("allFilesFromFolderNamed", {
            name: (_file$data$name = file.data.name) != null ? _file$data$name : i18n("unnamed")
        }) : null,
        disabled: isDisabled,
        "data-uppy-super-focusable": true
    }), file.data.isFolder ? // button to open a folder
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-ProviderBrowserItem-inner",
        onClick: ()=>openFolder(file.id),
        "aria-label": i18n("openFolderNamed", {
            name: (_file$data$name2 = file.data.name) != null ? _file$data$name2 : i18n("unnamed")
        })
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.icon
    })), showTitles && file.data.name ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, file.data.name) : i18n("unnamed")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
        htmlFor: file.id,
        className: "uppy-u-reset uppy-ProviderBrowserItem-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowserItem-iconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $eeb730e0d52603b2$export$2e2bcd8739ae039), {
        itemIconString: file.data.icon
    })), showTitles && ((_file$data$name3 = file.data.name) != null ? _file$data$name3 : i18n("unnamed"))));
}


function $7f388d6d579fe299$export$2e2bcd8739ae039(props) {
    const { viewType: viewType, toggleCheckbox: toggleCheckbox, showTitles: showTitles, i18n: i18n, openFolder: openFolder, file: file } = props;
    const restrictionError = file.type === "folder" ? null : file.restrictionError;
    const isDisabled = !!restrictionError && file.status !== "checked";
    const ourProps = {
        file: file,
        openFolder: openFolder,
        toggleCheckbox: toggleCheckbox,
        i18n: i18n,
        viewType: viewType,
        showTitles: showTitles,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowserItem", {
            "uppy-ProviderBrowserItem--disabled": isDisabled
        }, {
            "uppy-ProviderBrowserItem--noPreview": file.data.icon === "video"
        }, {
            "uppy-ProviderBrowserItem--is-checked": file.status === "checked"
        }, {
            "uppy-ProviderBrowserItem--is-partial": file.status === "partial"
        }),
        isDisabled: isDisabled,
        restrictionError: restrictionError
    };
    switch(viewType){
        case "grid":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), ourProps);
        case "list":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9b946df2ba2b33d0$export$2e2bcd8739ae039), ourProps);
        case "unsplash":
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $79441ec2d5893efa$export$2e2bcd8739ae039), ourProps, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
                href: `${file.data.author.url}?utm_source=Companion&utm_medium=referral`,
                target: "_blank",
                rel: "noopener noreferrer",
                className: "uppy-ProviderBrowserItem-author",
                tabIndex: -1
            }, file.data.author.name));
        default:
            throw new Error(`There is no such type ${viewType}`);
    }
}


function $ffc120143b595bcb$var$Browser(props) {
    const { displayedPartialTree: displayedPartialTree, viewType: viewType, toggleCheckbox: toggleCheckbox, handleScroll: handleScroll, showTitles: showTitles, i18n: i18n, isLoading: isLoading, openFolder: openFolder, noResultsLabel: noResultsLabel, virtualList: virtualList } = props;
    const [isShiftKeyPressed, setIsShiftKeyPressed] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(false);
    // This records whether the user is holding the SHIFT key this very moment.
    // Typically, this is implemented using `onClick((e) => e.shiftKey)` -
    // however we can't use that, because for accessibility reasons
    // we're using html tags that don't support `e.shiftKey` property (see #3768).
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const handleKeyUp = (e)=>{
            if (e.key === "Shift") setIsShiftKeyPressed(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === "Shift") setIsShiftKeyPressed(true);
        };
        document.addEventListener("keyup", handleKeyUp);
        document.addEventListener("keydown", handleKeyDown);
        return ()=>{
            document.removeEventListener("keyup", handleKeyUp);
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, []);
    if (isLoading) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-loading"
    }, typeof isLoading === "string" ? isLoading : i18n("loading"));
    if (displayedPartialTree.length === 0) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Provider-empty"
    }, noResultsLabel);
    const renderItem = (item)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7f388d6d579fe299$export$2e2bcd8739ae039), {
            viewType: viewType,
            toggleCheckbox: (event)=>{
                var _document$getSelectio;
                event.stopPropagation();
                event.preventDefault();
                // Prevent shift-clicking from highlighting file names
                // (https://stackoverflow.com/a/1527797/3192470)
                (_document$getSelectio = document.getSelection()) == null || _document$getSelectio.removeAllRanges();
                toggleCheckbox(item, isShiftKeyPressed);
            },
            showTitles: showTitles,
            i18n: i18n,
            openFolder: openFolder,
            file: item
        });
    if (virtualList) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-body"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
        className: "uppy-ProviderBrowser-list"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        data: displayedPartialTree,
        renderRow: renderItem,
        rowHeight: 31
    })));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-body"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("ul", {
        className: "uppy-ProviderBrowser-list",
        onScroll: handleScroll,
        role: "listbox",
        tabIndex: -1
    }, displayedPartialTree.map(renderItem)));
}
var $ffc120143b595bcb$export$2e2bcd8739ae039 = $ffc120143b595bcb$var$Browser;


const $75b69938e29d602a$var$afterOpenFolder = (oldPartialTree, discoveredItems, clickedFolder, currentPagePath, validateSingleFile)=>{
    const discoveredFolders = discoveredItems.filter((i)=>i.isFolder === true);
    const discoveredFiles = discoveredItems.filter((i)=>i.isFolder === false);
    const isParentFolderChecked = clickedFolder.type === "folder" && clickedFolder.status === "checked";
    const folders = discoveredFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? "checked" : "unchecked",
            parentId: clickedFolder.id,
            data: folder
        }));
    const files = discoveredFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? "checked" : "unchecked",
            parentId: clickedFolder.id,
            data: file
        };
    });
    // just doing `clickedFolder.cached = true` in a non-mutating way
    const updatedClickedFolder = {
        ...clickedFolder,
        cached: true,
        nextPagePath: currentPagePath
    };
    const partialTreeWithUpdatedClickedFolder = oldPartialTree.map((folder)=>folder.id === updatedClickedFolder.id ? updatedClickedFolder : folder);
    const newPartialTree = [
        ...partialTreeWithUpdatedClickedFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $75b69938e29d602a$export$2e2bcd8739ae039 = $75b69938e29d602a$var$afterOpenFolder;


const $6157a596a45fd763$var$afterScrollFolder = (oldPartialTree, currentFolderId, items, nextPagePath, validateSingleFile)=>{
    const currentFolder = oldPartialTree.find((i)=>i.id === currentFolderId);
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    // just doing `scrolledFolder.nextPagePath = ...` in a non-mutating way
    const scrolledFolder = {
        ...currentFolder,
        nextPagePath: nextPagePath
    };
    const partialTreeWithUpdatedScrolledFolder = oldPartialTree.map((folder)=>folder.id === scrolledFolder.id ? scrolledFolder : folder);
    const isParentFolderChecked = scrolledFolder.type === "folder" && scrolledFolder.status === "checked";
    const folders = newFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: isParentFolderChecked ? "checked" : "unchecked",
            parentId: scrolledFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: isParentFolderChecked && !restrictionError ? "checked" : "unchecked",
            parentId: scrolledFolder.id,
            data: file
        };
    });
    const newPartialTree = [
        ...partialTreeWithUpdatedScrolledFolder,
        ...folders,
        ...files
    ];
    return newPartialTree;
};
var $6157a596a45fd763$export$2e2bcd8739ae039 = $6157a596a45fd763$var$afterScrollFolder;


/* eslint-disable no-param-reassign */ /**
 * One-level copying is sufficient as mutations within our `partialTree` are limited to properties
 * such as `.status`, `.cached`, `.nextPagePath`, and not `.data = { THIS }`.
 */ const $ca2a09feaf67815d$var$shallowClone = (partialTree)=>{
    return partialTree.map((item)=>({
            ...item
        }));
};
var $ca2a09feaf67815d$export$2e2bcd8739ae039 = $ca2a09feaf67815d$var$shallowClone;


/*
  FROM        | TO

  root        |  root
    folder    |    folder
    folder ✅︎  |    folder ✅︎
      file    |      file ✅︎
      file    |      file ✅︎
      folder  |      folder ✅︎
        file  |        file ✅︎
    file      |    file
    file      |    file
*/ const $28868daa484a498f$var$percolateDown = (tree, id, shouldMarkAsChecked)=>{
    const children = tree.filter((item)=>item.type !== "root" && item.parentId === id);
    children.forEach((item)=>{
        item.status = shouldMarkAsChecked && !(item.type === "file" && item.restrictionError) ? "checked" : "unchecked";
        $28868daa484a498f$var$percolateDown(tree, item.id, shouldMarkAsChecked);
    });
};
/*
  FROM         | TO

  root         |  root
    folder     |    folder
    folder     |    folder [▬] ('partial' status)
      file     |      file
      folder   |      folder ✅︎
        file ✅︎ |       file ✅︎
    file       |    file
    file       |    file
*/ const $28868daa484a498f$var$percolateUp = (tree, id)=>{
    const folder = tree.find((item)=>item.id === id);
    if (folder.type === "root") return;
    const validChildren = tree.filter((item)=>// is a child
        item.type !== "root" && item.parentId === folder.id && // does pass validations
        !(item.type === "file" && item.restrictionError));
    const areAllChildrenChecked = validChildren.every((item)=>item.status === "checked");
    const areAllChildrenUnchecked = validChildren.every((item)=>item.status === "unchecked");
    if (areAllChildrenChecked) folder.status = "checked";
    else if (areAllChildrenUnchecked) folder.status = "unchecked";
    else folder.status = "partial";
    $28868daa484a498f$var$percolateUp(tree, folder.parentId);
};
const $28868daa484a498f$var$afterToggleCheckbox = (oldTree, clickedRange)=>{
    const tree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(oldTree);
    if (clickedRange.length >= 2) {
        // We checked two or more items
        const newlyCheckedItems = tree.filter((item)=>item.type !== "root" && clickedRange.includes(item.id));
        newlyCheckedItems.forEach((item)=>{
            if (item.type === "file") item.status = item.restrictionError ? "unchecked" : "checked";
            else item.status = "checked";
        });
        newlyCheckedItems.forEach((item)=>{
            $28868daa484a498f$var$percolateDown(tree, item.id, true);
        });
        $28868daa484a498f$var$percolateUp(tree, newlyCheckedItems[0].parentId);
    } else {
        // We checked exactly one item
        const clickedItem = tree.find((item)=>item.id === clickedRange[0]);
        clickedItem.status = clickedItem.status === "checked" ? "unchecked" : "checked";
        $28868daa484a498f$var$percolateDown(tree, clickedItem.id, clickedItem.status === "checked");
        $28868daa484a498f$var$percolateUp(tree, clickedItem.parentId);
    }
    return tree;
};
var $28868daa484a498f$export$2e2bcd8739ae039 = $28868daa484a498f$var$afterToggleCheckbox;


/* eslint-disable no-param-reassign */ // p-queue does not have a `"main"` field in its `package.json`, and that makes `import/no-unresolved` freak out.
// We can safely ignore it because bundlers will happily use the `"exports"` field instead.
// eslint-disable-next-line import/no-unresolved
var $d71e659823218cf6$exports = {};
"use strict";
var $d71e659823218cf6$var$has = Object.prototype.hasOwnProperty, $d71e659823218cf6$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $d71e659823218cf6$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $d71e659823218cf6$var$Events().__proto__) $d71e659823218cf6$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $d71e659823218cf6$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $d71e659823218cf6$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $d71e659823218cf6$var$EE(fn, context || emitter, once), evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $d71e659823218cf6$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $d71e659823218cf6$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $d71e659823218cf6$var$EventEmitter() {
    this._events = new $d71e659823218cf6$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($d71e659823218cf6$var$has.call(events, name)) names.push($d71e659823218cf6$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $d71e659823218cf6$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $d71e659823218cf6$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $d71e659823218cf6$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $d71e659823218cf6$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $d71e659823218cf6$var$prefix ? $d71e659823218cf6$var$prefix + event : event;
        if (this._events[evt]) $d71e659823218cf6$var$clearEvent(this, evt);
    } else {
        this._events = new $d71e659823218cf6$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$d71e659823218cf6$var$EventEmitter.prototype.off = $d71e659823218cf6$var$EventEmitter.prototype.removeListener;
$d71e659823218cf6$var$EventEmitter.prototype.addListener = $d71e659823218cf6$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$d71e659823218cf6$var$EventEmitter.prefixed = $d71e659823218cf6$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$d71e659823218cf6$var$EventEmitter.EventEmitter = $d71e659823218cf6$var$EventEmitter;
$d71e659823218cf6$exports = $d71e659823218cf6$var$EventEmitter;


var $d2ed3f8017184c07$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($d71e659823218cf6$exports)));


class $46025477665dcc7c$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
    }
}
class $46025477665dcc7c$export$18b052ffd8c84d7 extends Error {
    constructor(message){
        super();
        this.name = "AbortError";
        this.message = message;
    }
}
/**
TODO: Remove AbortError and just throw DOMException when targeting Node 18.
*/ const $46025477665dcc7c$var$getDOMException = (errorMessage)=>globalThis.DOMException === undefined ? new $46025477665dcc7c$export$18b052ffd8c84d7(errorMessage) : new DOMException(errorMessage);
/**
TODO: Remove below function and just 'reject(signal.reason)' when targeting Node 18.
*/ const $46025477665dcc7c$var$getAbortedReason = (signal)=>{
    const reason = signal.reason === undefined ? $46025477665dcc7c$var$getDOMException("This operation was aborted.") : signal.reason;
    return reason instanceof Error ? reason : $46025477665dcc7c$var$getDOMException(reason);
};
function $46025477665dcc7c$export$2e2bcd8739ae039(promise, options) {
    const { milliseconds: milliseconds, fallback: fallback, message: message, customTimers: customTimers = {
        setTimeout: setTimeout,
        clearTimeout: clearTimeout
    } } = options;
    let timer;
    const wrappedPromise = new Promise((resolve, reject)=>{
        if (typeof milliseconds !== "number" || Math.sign(milliseconds) !== 1) throw new TypeError(`Expected \`milliseconds\` to be a positive number, got \`${milliseconds}\``);
        if (options.signal) {
            const { signal: signal } = options;
            if (signal.aborted) reject($46025477665dcc7c$var$getAbortedReason(signal));
            const abortHandler = ()=>{
                reject($46025477665dcc7c$var$getAbortedReason(signal));
            };
            signal.addEventListener("abort", abortHandler, {
                once: true
            });
            promise.finally(()=>{
                signal.removeEventListener("abort", abortHandler);
            });
        }
        if (milliseconds === Number.POSITIVE_INFINITY) {
            promise.then(resolve, reject);
            return;
        }
        // We create the error outside of `setTimeout` to preserve the stack trace.
        const timeoutError = new $46025477665dcc7c$export$66d311bf29d5c89c();
        timer = customTimers.setTimeout.call(undefined, ()=>{
            if (fallback) {
                try {
                    resolve(fallback());
                } catch (error) {
                    reject(error);
                }
                return;
            }
            if (typeof promise.cancel === "function") promise.cancel();
            if (message === false) resolve();
            else if (message instanceof Error) reject(message);
            else {
                timeoutError.message = message ?? `Promise timed out after ${milliseconds} milliseconds`;
                reject(timeoutError);
            }
        }, milliseconds);
        (async ()=>{
            try {
                resolve(await promise);
            } catch (error) {
                reject(error);
            }
        })();
    });
    const cancelablePromise = wrappedPromise.finally(()=>{
        cancelablePromise.clear();
    });
    cancelablePromise.clear = ()=>{
        customTimers.clearTimeout.call(undefined, timer);
        timer = undefined;
    };
    return cancelablePromise;
}


// Port of lower_bound from https://en.cppreference.com/w/cpp/algorithm/lower_bound
// Used to compute insertion index to keep queue sorted after insertion
function $6829868fc187eefd$export$2e2bcd8739ae039(array, value, comparator) {
    let first = 0;
    let count = array.length;
    while(count > 0){
        const step = Math.trunc(count / 2);
        let it = first + step;
        if (comparator(array[it], value) <= 0) {
            first = ++it;
            count -= step + 1;
        } else count = step;
    }
    return first;
}


class $17cf7ddbaf767759$export$2e2bcd8739ae039 {
    #queue = [];
    enqueue(run, options) {
        options = {
            priority: 0,
            ...options
        };
        const element = {
            priority: options.priority,
            run: run
        };
        if (this.size && this.#queue[this.size - 1].priority >= options.priority) {
            this.#queue.push(element);
            return;
        }
        const index = (0, $6829868fc187eefd$export$2e2bcd8739ae039)(this.#queue, element, (a, b)=>b.priority - a.priority);
        this.#queue.splice(index, 0, element);
    }
    dequeue() {
        const item = this.#queue.shift();
        return item?.run;
    }
    filter(options) {
        return this.#queue.filter((element)=>element.priority === options.priority).map((element)=>element.run);
    }
    get size() {
        return this.#queue.length;
    }
}


class $d92c5526fb6f64bf$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($d71e659823218cf6$exports))) {
    #carryoverConcurrencyCount;
    #isIntervalIgnored;
    #intervalCount = 0;
    #intervalCap;
    #interval;
    #intervalEnd = 0;
    #intervalId;
    #timeoutId;
    #queue;
    #queueClass;
    #pending = 0;
    // The `!` is needed because of https://github.com/microsoft/TypeScript/issues/32194
    #concurrency;
    #isPaused;
    #throwOnTimeout;
    /**
    Per-operation timeout in milliseconds. Operations fulfill once `timeout` elapses if they haven't already.

    Applies to each future operation.
    */ timeout;
    // TODO: The `throwOnTimeout` option should affect the return types of `add()` and `addAll()`
    constructor(options){
        super();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        options = {
            carryoverConcurrencyCount: false,
            intervalCap: Number.POSITIVE_INFINITY,
            interval: 0,
            concurrency: Number.POSITIVE_INFINITY,
            autoStart: true,
            queueClass: (0, $17cf7ddbaf767759$export$2e2bcd8739ae039),
            ...options
        };
        if (!(typeof options.intervalCap === "number" && options.intervalCap >= 1)) throw new TypeError(`Expected \`intervalCap\` to be a number from 1 and up, got \`${options.intervalCap?.toString() ?? ""}\` (${typeof options.intervalCap})`);
        if (options.interval === undefined || !(Number.isFinite(options.interval) && options.interval >= 0)) throw new TypeError(`Expected \`interval\` to be a finite number >= 0, got \`${options.interval?.toString() ?? ""}\` (${typeof options.interval})`);
        this.#carryoverConcurrencyCount = options.carryoverConcurrencyCount;
        this.#isIntervalIgnored = options.intervalCap === Number.POSITIVE_INFINITY || options.interval === 0;
        this.#intervalCap = options.intervalCap;
        this.#interval = options.interval;
        this.#queue = new options.queueClass();
        this.#queueClass = options.queueClass;
        this.concurrency = options.concurrency;
        this.timeout = options.timeout;
        this.#throwOnTimeout = options.throwOnTimeout === true;
        this.#isPaused = options.autoStart === false;
    }
    get #doesIntervalAllowAnother() {
        return this.#isIntervalIgnored || this.#intervalCount < this.#intervalCap;
    }
    get #doesConcurrentAllowAnother() {
        return this.#pending < this.#concurrency;
    }
    #next() {
        this.#pending--;
        this.#tryToStartAnother();
        this.emit("next");
    }
    #onResumeInterval() {
        this.#onInterval();
        this.#initializeIntervalIfNeeded();
        this.#timeoutId = undefined;
    }
    get #isIntervalPaused() {
        const now = Date.now();
        if (this.#intervalId === undefined) {
            const delay = this.#intervalEnd - now;
            if (delay < 0) // Act as the interval was done
            // We don't need to resume it here because it will be resumed on line 160
            this.#intervalCount = this.#carryoverConcurrencyCount ? this.#pending : 0;
            else {
                // Act as the interval is pending
                if (this.#timeoutId === undefined) this.#timeoutId = setTimeout(()=>{
                    this.#onResumeInterval();
                }, delay);
                return true;
            }
        }
        return false;
    }
    #tryToStartAnother() {
        if (this.#queue.size === 0) {
            // We can clear the interval ("pause")
            // Because we can redo it later ("resume")
            if (this.#intervalId) clearInterval(this.#intervalId);
            this.#intervalId = undefined;
            this.emit("empty");
            if (this.#pending === 0) this.emit("idle");
            return false;
        }
        if (!this.#isPaused) {
            const canInitializeInterval = !this.#isIntervalPaused;
            if (this.#doesIntervalAllowAnother && this.#doesConcurrentAllowAnother) {
                const job = this.#queue.dequeue();
                if (!job) return false;
                this.emit("active");
                job();
                if (canInitializeInterval) this.#initializeIntervalIfNeeded();
                return true;
            }
        }
        return false;
    }
    #initializeIntervalIfNeeded() {
        if (this.#isIntervalIgnored || this.#intervalId !== undefined) return;
        this.#intervalId = setInterval(()=>{
            this.#onInterval();
        }, this.#interval);
        this.#intervalEnd = Date.now() + this.#interval;
    }
    #onInterval() {
        if (this.#intervalCount === 0 && this.#pending === 0 && this.#intervalId) {
            clearInterval(this.#intervalId);
            this.#intervalId = undefined;
        }
        this.#intervalCount = this.#carryoverConcurrencyCount ? this.#pending : 0;
        this.#processQueue();
    }
    /**
    Executes all queued functions until it reaches the limit.
    */ #processQueue() {
        // eslint-disable-next-line no-empty
        while(this.#tryToStartAnother());
    }
    get concurrency() {
        return this.#concurrency;
    }
    set concurrency(newConcurrency) {
        if (!(typeof newConcurrency === "number" && newConcurrency >= 1)) throw new TypeError(`Expected \`concurrency\` to be a number from 1 and up, got \`${newConcurrency}\` (${typeof newConcurrency})`);
        this.#concurrency = newConcurrency;
        this.#processQueue();
    }
    async #throwOnAbort(signal) {
        return new Promise((_resolve, reject)=>{
            signal.addEventListener("abort", ()=>{
                reject(signal.reason);
            }, {
                once: true
            });
        });
    }
    async add(function_, options = {}) {
        options = {
            timeout: this.timeout,
            throwOnTimeout: this.#throwOnTimeout,
            ...options
        };
        return new Promise((resolve, reject)=>{
            this.#queue.enqueue(async ()=>{
                this.#pending++;
                this.#intervalCount++;
                try {
                    options.signal?.throwIfAborted();
                    let operation = function_({
                        signal: options.signal
                    });
                    if (options.timeout) operation = (0, $46025477665dcc7c$export$2e2bcd8739ae039)(Promise.resolve(operation), {
                        milliseconds: options.timeout
                    });
                    if (options.signal) operation = Promise.race([
                        operation,
                        this.#throwOnAbort(options.signal)
                    ]);
                    const result = await operation;
                    resolve(result);
                    this.emit("completed", result);
                } catch (error) {
                    if (error instanceof (0, $46025477665dcc7c$export$66d311bf29d5c89c) && !options.throwOnTimeout) {
                        resolve();
                        return;
                    }
                    reject(error);
                    this.emit("error", error);
                } finally{
                    this.#next();
                }
            }, options);
            this.emit("add");
            this.#tryToStartAnother();
        });
    }
    async addAll(functions, options) {
        return Promise.all(functions.map(async (function_)=>this.add(function_, options)));
    }
    /**
    Start (or resume) executing enqueued tasks within concurrency limit. No need to call this if queue is not paused (via `options.autoStart = false` or by `.pause()` method.)
    */ start() {
        if (!this.#isPaused) return this;
        this.#isPaused = false;
        this.#processQueue();
        return this;
    }
    /**
    Put queue execution on hold.
    */ pause() {
        this.#isPaused = true;
    }
    /**
    Clear the queue.
    */ clear() {
        this.#queue = new this.#queueClass();
    }
    /**
    Can be called multiple times. Useful if you for example add additional items at a later time.

    @returns A promise that settles when the queue becomes empty.
    */ async onEmpty() {
        // Instantly resolve if the queue is empty
        if (this.#queue.size === 0) return;
        await this.#onEvent("empty");
    }
    /**
    @returns A promise that settles when the queue size is less than the given limit: `queue.size < limit`.

    If you want to avoid having the queue grow beyond a certain size you can `await queue.onSizeLessThan()` before adding a new item.

    Note that this only limits the number of items waiting to start. There could still be up to `concurrency` jobs already running that this call does not include in its calculation.
    */ async onSizeLessThan(limit) {
        // Instantly resolve if the queue is empty.
        if (this.#queue.size < limit) return;
        await this.#onEvent("next", ()=>this.#queue.size < limit);
    }
    /**
    The difference with `.onEmpty` is that `.onIdle` guarantees that all work from the queue has finished. `.onEmpty` merely signals that the queue is empty, but it could mean that some promises haven't completed yet.

    @returns A promise that settles when the queue becomes empty, and all promises have completed; `queue.size === 0 && queue.pending === 0`.
    */ async onIdle() {
        // Instantly resolve if none pending and if nothing else is queued
        if (this.#pending === 0 && this.#queue.size === 0) return;
        await this.#onEvent("idle");
    }
    async #onEvent(event, filter) {
        return new Promise((resolve)=>{
            const listener = ()=>{
                if (filter && !filter()) return;
                this.off(event, listener);
                resolve();
            };
            this.on(event, listener);
        });
    }
    /**
    Size of the queue, the number of queued items waiting to run.
    */ get size() {
        return this.#queue.size;
    }
    /**
    Size of the queue, filtered by the given options.

    For example, this can be used to find the number of items remaining in the queue with a specific priority level.
    */ sizeBy(options) {
        // eslint-disable-next-line unicorn/no-array-callback-reference
        return this.#queue.filter(options).length;
    }
    /**
    Number of running items (no longer in the queue).
    */ get pending() {
        return this.#pending;
    }
    /**
    Whether the queue is currently paused.
    */ get isPaused() {
        return this.#isPaused;
    }
}



const $742a2dde4df138bd$var$recursivelyFetch = async (queue, poorTree, poorFolder, apiList, validateSingleFile)=>{
    let items = [];
    let currentPath = poorFolder.cached ? poorFolder.nextPagePath : poorFolder.id;
    while(currentPath){
        const response = await apiList(currentPath);
        items = items.concat(response.items);
        currentPath = response.nextPagePath;
    }
    const newFolders = items.filter((i)=>i.isFolder === true);
    const newFiles = items.filter((i)=>i.isFolder === false);
    const folders = newFolders.map((folder)=>({
            type: "folder",
            id: folder.requestPath,
            cached: false,
            nextPagePath: null,
            status: "checked",
            parentId: poorFolder.id,
            data: folder
        }));
    const files = newFiles.map((file)=>{
        const restrictionError = validateSingleFile(file);
        return {
            type: "file",
            id: file.requestPath,
            restrictionError: restrictionError,
            status: restrictionError ? "unchecked" : "checked",
            parentId: poorFolder.id,
            data: file
        };
    });
    poorFolder.cached = true;
    poorFolder.nextPagePath = null;
    poorTree.push(...files, ...folders);
    folders.forEach(async (folder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, folder, apiList, validateSingleFile));
    });
};
const $742a2dde4df138bd$var$afterFill = async (partialTree, apiList, validateSingleFile, reportProgress)=>{
    const queue = new (0, $d92c5526fb6f64bf$export$2e2bcd8739ae039)({
        concurrency: 6
    });
    // fill up the missing parts of a partialTree!
    const poorTree = (0, $ca2a09feaf67815d$export$2e2bcd8739ae039)(partialTree);
    const poorFolders = poorTree.filter((item)=>item.type === "folder" && item.status === "checked" && // either "not yet cached at all" or "some pages are left to fetch"
        (item.cached === false || item.nextPagePath));
    // per each poor folder, recursively fetch all files and make them .checked!
    poorFolders.forEach((poorFolder)=>{
        queue.add(()=>$742a2dde4df138bd$var$recursivelyFetch(queue, poorTree, poorFolder, apiList, validateSingleFile));
    });
    queue.on("completed", ()=>{
        const nOfFilesChecked = poorTree.filter((i)=>i.type === "file" && i.status === "checked").length;
        reportProgress(nOfFilesChecked);
    });
    await queue.onIdle();
    return poorTree;
};
var $742a2dde4df138bd$export$2e2bcd8739ae039 = $742a2dde4df138bd$var$afterFill;


var $561f5272d8ac5b76$export$2e2bcd8739ae039 = {
    afterOpenFolder: $75b69938e29d602a$export$2e2bcd8739ae039,
    afterScrollFolder: $6157a596a45fd763$export$2e2bcd8739ae039,
    afterToggleCheckbox: $28868daa484a498f$export$2e2bcd8739ae039,
    afterFill: $742a2dde4df138bd$export$2e2bcd8739ae039
};


const $b5a8e6b281aacb12$var$shouldHandleScroll = (event)=>{
    const { scrollHeight: scrollHeight, scrollTop: scrollTop, offsetHeight: offsetHeight } = event.target;
    const scrollPosition = scrollHeight - (scrollTop + offsetHeight);
    return scrollPosition < 50;
};
var $b5a8e6b281aacb12$export$2e2bcd8739ae039 = $b5a8e6b281aacb12$var$shouldHandleScroll;


const $4ac650d5250ead28$var$handleError = (uppy)=>(error)=>{
        // authError just means we're not authenticated, don't report it
        if (error.isAuthError) return;
        // AbortError means the user has clicked "cancel" on an operation
        if (error.name === "AbortError") {
            uppy.log("Aborting request", "warning");
            return;
        }
        uppy.log(error, "error");
        if (error.name === "UserFacingApiError") uppy.info({
            message: uppy.i18n("companionError"),
            details: uppy.i18n(error.message)
        }, "warning", 5000);
    };
var $4ac650d5250ead28$export$2e2bcd8739ae039 = $4ac650d5250ead28$var$handleError;


// Shift-clicking selects a single consecutive list of items
// starting at the previous click.
const $3af8f69ec184395c$var$getClickedRange = (clickedId, displayedPartialTree, isShiftKeyPressed, lastCheckbox)=>{
    const lastCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === lastCheckbox);
    if (lastCheckboxIndex !== -1 && isShiftKeyPressed) {
        const newCheckboxIndex = displayedPartialTree.findIndex((item)=>item.id === clickedId);
        const clickedRange = displayedPartialTree.slice(Math.min(lastCheckboxIndex, newCheckboxIndex), Math.max(lastCheckboxIndex, newCheckboxIndex) + 1);
        return clickedRange.map((item)=>item.id);
    }
    return [
        clickedId
    ];
};
var $3af8f69ec184395c$export$2e2bcd8739ae039 = $3af8f69ec184395c$var$getClickedRange;




let $a0ee3b646e338d67$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $a0ee3b646e338d67$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $a0ee3b646e338d67$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $a0ee3b646e338d67$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


function $f173600a8ed11ef3$var$SearchInput(_ref) {
    let { searchString: searchString, setSearchString: setSearchString, submitSearchString: submitSearchString, wrapperClassName: wrapperClassName, inputClassName: inputClassName, inputLabel: inputLabel, clearSearchLabel: clearSearchLabel = "", showButton: showButton = false, buttonLabel: buttonLabel = "", buttonCSSClassName: buttonCSSClassName = "" } = _ref;
    const onInput = (e)=>{
        setSearchString(e.target.value);
    };
    const submit = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        submitSearchString();
    }, [
        submitSearchString
    ]);
    // We do this to avoid nested <form>s
    // (See https://github.com/transloadit/uppy/pull/5050#discussion_r1640392516)
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $a0ee3b646e338d67$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", submit);
        return ()=>{
            form.removeEventListener("submit", submit);
            document.body.removeChild(form);
        };
    }, [
        form,
        submit
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("section", {
        className: wrapperClassName
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
        className: `uppy-u-reset ${inputClassName}`,
        type: "search",
        "aria-label": inputLabel,
        placeholder: inputLabel,
        value: searchString,
        onInput: onInput,
        form: form.id,
        "data-uppy-super-focusable": true
    }), !showButton && // 🔍
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-ProviderBrowser-searchFilterIcon",
        width: "12",
        height: "12",
        viewBox: "0 0 12 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.638 7.99l3.172 3.172a.492.492 0 1 1-.697.697L7.91 8.656a4.977 4.977 0 0 1-2.983.983C2.206 9.639 0 7.481 0 4.819 0 2.158 2.206 0 4.927 0c2.721 0 4.927 2.158 4.927 4.82a4.74 4.74 0 0 1-1.216 3.17zm-3.71.685c2.176 0 3.94-1.726 3.94-3.856 0-2.129-1.764-3.855-3.94-3.855C2.75.964.984 2.69.984 4.819c0 2.13 1.765 3.856 3.942 3.856z"
    })), !showButton && searchString && // ❌
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-ProviderBrowser-searchFilterReset",
        type: "button",
        "aria-label": clearSearchLabel,
        title: clearSearchLabel,
        onClick: ()=>setSearchString("")
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        viewBox: "0 0 19 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M17.318 17.232L9.94 9.854 9.586 9.5l-.354.354-7.378 7.378h.707l-.62-.62v.706L9.318 9.94l.354-.354-.354-.354L1.94 1.854v.707l.62-.62h-.706l7.378 7.378.354.354.354-.354 7.378-7.378h-.707l.622.62v-.706L9.854 9.232l-.354.354.354.354 7.378 7.378.708-.707-7.38-7.378v.708l7.38-7.38.353-.353-.353-.353-.622-.622-.353-.353-.354.352-7.378 7.38h.708L2.56 1.23 2.208.88l-.353.353-.622.62-.353.355.352.353 7.38 7.38v-.708l-7.38 7.38-.353.353.352.353.622.622.353.353.354-.353 7.38-7.38h-.708l7.38 7.38z"
    }))), showButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: `uppy-u-reset uppy-c-btn uppy-c-btn-primary ${buttonCSSClassName}`,
        type: "submit",
        form: form.id
    }, buttonLabel));
}
var $f173600a8ed11ef3$export$2e2bcd8739ae039 = $f173600a8ed11ef3$var$SearchInput;





/**
 * We're interested in all 'checked' leaves of this tree,
 * but we don't yet know how many files there are inside of each checked folder.
 * `getNumberOfSelectedFiles()` returns the most intuitive number we can show to the user
 * in this situation.
 */ const $3599f082ce07508f$var$getNumberOfSelectedFiles = (partialTree)=>{
    const checkedLeaves = partialTree.filter((item)=>{
        if (item.type === "file" && item.status === "checked") return true;
        if (item.type === "folder" && item.status === "checked") {
            const doesItHaveChildren = partialTree.some((i)=>i.type !== "root" && i.parentId === item.id);
            return !doesItHaveChildren;
        }
        return false;
    });
    return checkedLeaves.length;
};
var $3599f082ce07508f$export$2e2bcd8739ae039 = $3599f082ce07508f$var$getNumberOfSelectedFiles;


function $4ab2a94a3ee5ad67$export$2e2bcd8739ae039(_ref) {
    let { cancelSelection: cancelSelection, donePicking: donePicking, i18n: i18n, partialTree: partialTree, validateAggregateRestrictions: validateAggregateRestrictions } = _ref;
    const aggregateRestrictionError = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return validateAggregateRestrictions(partialTree);
    }, [
        partialTree,
        validateAggregateRestrictions
    ]);
    const nOfSelectedFiles = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        return (0, $3599f082ce07508f$export$2e2bcd8739ae039)(partialTree);
    }, [
        partialTree
    ]);
    if (nOfSelectedFiles === 0) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer-buttons"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-u-reset uppy-c-btn uppy-c-btn-primary", {
            "uppy-c-btn--disabled": aggregateRestrictionError
        }),
        disabled: !!aggregateRestrictionError,
        onClick: donePicking,
        type: "button"
    }, i18n("selectX", {
        smart_count: nOfSelectedFiles
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link",
        onClick: cancelSelection,
        type: "button"
    }, i18n("cancel"))), aggregateRestrictionError && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-ProviderBrowser-footer-error"
    }, aggregateRestrictionError));
}



// TODO: document what is a "tagFile" or get rid of this concept
const $67e1a0ee3f34a25a$var$getTagFile = (file, plugin, provider)=>{
    var _file$author, _file$author2;
    const tagFile = {
        id: file.id,
        source: plugin.id,
        name: file.name || file.id,
        type: file.mimeType,
        isRemote: true,
        data: file,
        preview: file.thumbnail || undefined,
        meta: {
            authorName: (_file$author = file.author) == null ? void 0 : _file$author.name,
            authorUrl: (_file$author2 = file.author) == null ? void 0 : _file$author2.url,
            // We need to do this `|| null` check, because null value
            // for .relDirPath is `undefined` and for .relativePath is `null`.
            // I do think we should just use `null` everywhere.
            relativePath: file.relDirPath || null,
            absolutePath: file.absDirPath
        },
        body: {
            fileId: file.id
        },
        remote: {
            companionUrl: plugin.opts.companionUrl,
            // @ts-expect-error untyped for now
            url: `${provider.fileUrl(file.requestPath)}`,
            body: {
                fileId: file.id
            },
            providerName: provider.name,
            provider: provider.provider,
            requestClientId: provider.provider
        }
    };
    return tagFile;
};
var $67e1a0ee3f34a25a$export$2e2bcd8739ae039 = $67e1a0ee3f34a25a$var$getTagFile;


const $8e91ea798ebec2b3$var$addFiles = (companionFiles, plugin, provider)=>{
    const tagFiles = companionFiles.map((f)=>(0, $67e1a0ee3f34a25a$export$2e2bcd8739ae039)(f, plugin, provider));
    const filesToAdd = [];
    const filesAlreadyAdded = [];
    tagFiles.forEach((tagFile)=>{
        if (plugin.uppy.checkIfFileAlreadyExists((0, $d67267bb9859462b$export$2ff5b23440673856)(tagFile, plugin.uppy.getID()))) filesAlreadyAdded.push(tagFile);
        else filesToAdd.push(tagFile);
    });
    if (filesToAdd.length > 0) plugin.uppy.info(plugin.uppy.i18n("addedNumFiles", {
        numFiles: filesToAdd.length
    }));
    if (filesAlreadyAdded.length > 0) plugin.uppy.info(`Not adding ${filesAlreadyAdded.length} files because they already exist`);
    plugin.uppy.addFiles(filesToAdd);
};
var $8e91ea798ebec2b3$export$2e2bcd8739ae039 = $8e91ea798ebec2b3$var$addFiles;


/* eslint-disable no-param-reassign */ const $9b79bc726c3450f4$var$getPath = (partialTree, id, cache)=>{
    const sId = id === null ? "null" : id;
    if (cache[sId]) return cache[sId];
    const file = partialTree.find((f)=>f.id === id);
    if (file.type === "root") return [];
    const meAndParentPath = [
        ...$9b79bc726c3450f4$var$getPath(partialTree, file.parentId, cache),
        file
    ];
    cache[sId] = meAndParentPath;
    return meAndParentPath;
};
// See "Uppy file properties" documentation for `.absolutePath` and `.relativePath`
// (https://uppy.io/docs/uppy/#working-with-uppy-files)
const $9b79bc726c3450f4$var$getCheckedFilesWithPaths = (partialTree)=>{
    // Equivalent to `const cache = {}`, but makes keys such as 'hasOwnProperty' safe too
    const cache = Object.create(null);
    // We're only interested in injecting paths into 'checked' files
    const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
    const companionFilesWithInjectedPaths = checkedFiles.map((file)=>{
        const absFolders = $9b79bc726c3450f4$var$getPath(partialTree, file.id, cache);
        const firstCheckedFolderIndex = absFolders.findIndex((i)=>i.type === "folder" && i.status === "checked");
        const relFolders = absFolders.slice(firstCheckedFolderIndex);
        const absDirPath = `/${absFolders.map((i)=>i.data.name).join("/")}`;
        const relDirPath = relFolders.length === 1 ? // Must return `undefined` (which later turns into `null` in `.getTagFile()`)
        // (https://github.com/transloadit/uppy/pull/4537#issuecomment-1629136652)
        undefined : relFolders.map((i)=>i.data.name).join("/");
        return {
            ...file.data,
            absDirPath: absDirPath,
            relDirPath: relDirPath
        };
    });
    return companionFilesWithInjectedPaths;
};
var $9b79bc726c3450f4$export$2e2bcd8739ae039 = $9b79bc726c3450f4$var$getCheckedFilesWithPaths;


const $15f8d756dc46e018$var$getBreadcrumbs = (partialTree, currentFolderId)=>{
    let folder = partialTree.find((f)=>f.id === currentFolderId);
    let breadcrumbs = [];
    // eslint-disable-next-line no-constant-condition
    while(true){
        breadcrumbs = [
            folder,
            ...breadcrumbs
        ];
        if (folder.type === "root") break;
        const currentParentId = folder.parentId;
        folder = partialTree.find((f)=>f.id === currentParentId);
    }
    return breadcrumbs;
};
var $15f8d756dc46e018$export$2e2bcd8739ae039 = $15f8d756dc46e018$var$getBreadcrumbs;


function $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $671181bcc8a0cf10$var$id = 0;
function $671181bcc8a0cf10$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $671181bcc8a0cf10$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $671181bcc8a0cf10$var$packageJson = {
    "version": "4.0.2"
};
function $671181bcc8a0cf10$export$b9ab270927e310e4() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
    }));
}
const $671181bcc8a0cf10$var$getDefaultState = (rootFolderId)=>({
        authenticated: undefined,
        // we don't know yet
        partialTree: [
            {
                type: "root",
                id: rootFolderId,
                cached: false,
                nextPagePath: null
            }
        ],
        currentFolderId: rootFolderId,
        searchString: "",
        didFirstRender: false,
        username: null,
        loading: false
    });
var $671181bcc8a0cf10$var$_abortController = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("abortController");
var $671181bcc8a0cf10$var$_withAbort = /*#__PURE__*/ $671181bcc8a0cf10$var$_classPrivateFieldLooseKey("withAbort");
class $671181bcc8a0cf10$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        Object.defineProperty(this, $671181bcc8a0cf10$var$_withAbort, {
            value: $671181bcc8a0cf10$var$_withAbort2
        });
        this.isHandlingScroll = false;
        this.lastCheckbox = null;
        Object.defineProperty(this, $671181bcc8a0cf10$var$_abortController, {
            writable: true,
            value: void 0
        });
        this.validateSingleFile = (file)=>{
            const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
            const result = this.plugin.uppy.validateSingleFile(companionFile);
            return result;
        };
        this.getDisplayedPartialTree = ()=>{
            const { partialTree: partialTree, currentFolderId: currentFolderId, searchString: searchString } = this.plugin.getPluginState();
            const inThisFolder = partialTree.filter((item)=>item.type !== "root" && item.parentId === currentFolderId);
            const filtered = searchString === "" ? inThisFolder : inThisFolder.filter((item)=>{
                var _item$data$name;
                return ((_item$data$name = item.data.name) != null ? _item$data$name : this.plugin.uppy.i18n("unnamed")).toLowerCase().indexOf(searchString.toLowerCase()) !== -1;
            });
            return filtered;
        };
        this.validateAggregateRestrictions = (partialTree)=>{
            const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
            const uppyFiles = checkedFiles.map((file)=>file.data);
            return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        const defaultOptions = {
            viewType: "list",
            showTitles: true,
            showFilter: true,
            showBreadcrumbs: true,
            loadAllFiles: false,
            virtualList: false
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.openFolder = this.openFolder.bind(this);
        this.logout = this.logout.bind(this);
        this.handleAuth = this.handleAuth.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.render = this.render.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // todo
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on("dashboard:close-panel", this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    resetPluginState() {
        this.plugin.setPluginState($671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId));
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === "root" ? item : {
                ...item,
                status: "unchecked"
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    async openFolder(folderId) {
        this.lastCheckbox = null;
        // Returning cached folder
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedFolder = partialTree.find((folder)=>folder.id === folderId);
        if (clickedFolder.cached) {
            this.plugin.setPluginState({
                currentFolderId: folderId,
                searchString: ""
            });
            return;
        }
        this.setLoading(true);
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            let currentPagePath = folderId;
            let currentItems = [];
            do {
                const { username: username, nextPagePath: nextPagePath, items: items } = await this.provider.list(currentPagePath, {
                    signal: signal
                });
                // It's important to set the username during one of our first fetches
                this.plugin.setPluginState({
                    username: username
                });
                currentPagePath = nextPagePath;
                currentItems = currentItems.concat(items);
                this.setLoading(this.plugin.uppy.i18n("loadedXFiles", {
                    numFiles: currentItems.length
                }));
            }while (this.opts.loadAllFiles && currentPagePath);
            const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterOpenFolder(partialTree, currentItems, clickedFolder, currentPagePath, this.validateSingleFile);
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                currentFolderId: folderId,
                searchString: ""
            });
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    /**
   * Removes session token on client side.
   */ async logout() {
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            const res = await this.provider.logout({
                signal: signal
            });
            // res.ok is from the JSON body, not to be confused with Response.ok
            if (res.ok) {
                if (!res.revoked) {
                    const message = this.plugin.uppy.i18n("companionUnauthorizeHint", {
                        provider: this.plugin.title,
                        url: res.manual_revoke_url
                    });
                    this.plugin.uppy.info(message, "info", 7000);
                }
                this.plugin.setPluginState({
                    ...$671181bcc8a0cf10$var$getDefaultState(this.plugin.rootFolderId),
                    authenticated: false
                });
            }
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
    }
    async handleAuth(authFormData) {
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            this.setLoading(true);
            await this.provider.login({
                authFormData: authFormData,
                signal: signal
            });
            this.plugin.setPluginState({
                authenticated: true
            });
            await Promise.all([
                this.provider.fetchPreAuthToken(),
                this.openFolder(this.plugin.rootFolderId)
            ]);
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, currentFolderId: currentFolderId } = this.plugin.getPluginState();
        const currentFolder = partialTree.find((i)=>i.id === currentFolderId);
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && currentFolder.nextPagePath) {
            this.isHandlingScroll = true;
            await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
                const { nextPagePath: nextPagePath, items: items } = await this.provider.list(currentFolder.nextPagePath, {
                    signal: signal
                });
                const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterScrollFolder(partialTree, currentFolderId, items, nextPagePath, this.validateSingleFile);
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
            this.isHandlingScroll = false;
        }
    }
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        this.setLoading(true);
        await $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_withAbort)[$671181bcc8a0cf10$var$_withAbort](async (signal)=>{
            // 1. Enrich our partialTree by fetching all 'checked' but not-yet-fetched folders
            const enrichedTree = await (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterFill(partialTree, (path)=>this.provider.list(path, {
                    signal: signal
                }), this.validateSingleFile, (n)=>{
                this.setLoading(this.plugin.uppy.i18n("addedNumFiles", {
                    numFiles: n
                }));
            });
            // 2. Now that we know how many files there are - recheck aggregateRestrictions!
            const aggregateRestrictionError = this.validateAggregateRestrictions(enrichedTree);
            if (aggregateRestrictionError) {
                this.plugin.setPluginState({
                    partialTree: enrichedTree
                });
                return;
            }
            // 3. Add files
            const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(enrichedTree);
            (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
            // 4. Reset state
            this.resetPluginState();
        }).catch((0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy));
        this.setLoading(false);
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    render(state, viewOptions) {
        if (viewOptions === void 0) viewOptions = {};
        const { didFirstRender: didFirstRender } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        if (!didFirstRender) {
            this.plugin.setPluginState({
                didFirstRender: true
            });
            this.provider.fetchPreAuthToken();
            this.openFolder(this.plugin.rootFolderId);
        }
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        const { authenticated: authenticated, loading: loading } = this.plugin.getPluginState();
        const pluginIcon = this.plugin.icon || $671181bcc8a0cf10$export$b9ab270927e310e4;
        if (authenticated === false) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $616f0acd28bd0dc4$export$2e2bcd8739ae039), {
            pluginName: this.plugin.title,
            pluginIcon: pluginIcon,
            handleAuth: this.handleAuth,
            i18n: this.plugin.uppy.i18nArray,
            renderForm: opts.renderAuthForm,
            loading: loading
        });
        const { partialTree: partialTree, currentFolderId: currentFolderId, username: username, searchString: searchString } = this.plugin.getPluginState();
        const breadcrumbs = (0, $15f8d756dc46e018$export$2e2bcd8739ae039)(partialTree, currentFolderId);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${opts.viewType}`)
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $6b1b801e011f359f$export$2e2bcd8739ae039), {
            showBreadcrumbs: opts.showBreadcrumbs,
            openFolder: this.openFolder,
            breadcrumbs: breadcrumbs,
            pluginIcon: pluginIcon,
            title: this.plugin.title,
            logout: this.logout,
            username: username,
            i18n: i18n
        }), opts.showFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: (s)=>{
                this.plugin.setPluginState({
                    searchString: s
                });
            },
            submitSearchString: ()=>{},
            inputLabel: i18n("filter"),
            clearSearchLabel: i18n("resetFilter"),
            wrapperClassName: "uppy-ProviderBrowser-searchFilter",
            inputClassName: "uppy-ProviderBrowser-searchFilterInput"
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
            toggleCheckbox: this.toggleCheckbox,
            displayedPartialTree: this.getDisplayedPartialTree(),
            openFolder: this.openFolder,
            virtualList: opts.virtualList,
            noResultsLabel: i18n("noFilesFound"),
            handleScroll: this.handleScroll,
            viewType: opts.viewType,
            showTitles: opts.showTitles,
            i18n: this.plugin.uppy.i18n,
            isLoading: loading
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
            partialTree: partialTree,
            donePicking: this.donePicking,
            cancelSelection: this.cancelSelection,
            i18n: i18n,
            validateAggregateRestrictions: this.validateAggregateRestrictions
        }));
    }
}
async function $671181bcc8a0cf10$var$_withAbort2(op) {
    var _classPrivateFieldLoo;
    // prevent multiple requests in parallel from causing race conditions
    (_classPrivateFieldLoo = $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController]) == null || _classPrivateFieldLoo.abort();
    const abortController = new AbortController();
    $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = abortController;
    const cancelRequest = ()=>{
        abortController.abort();
    };
    try {
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.on("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.on("cancel-all", cancelRequest);
        await op(abortController.signal);
    } finally{
        // @ts-expect-error this should be typed in @uppy/dashboard.
        // Even then I don't think we can make this work without adding dashboard
        // as a dependency to provider-views.
        this.plugin.uppy.off("dashboard:close-panel", cancelRequest);
        this.plugin.uppy.off("cancel-all", cancelRequest);
        $671181bcc8a0cf10$var$_classPrivateFieldLooseBase(this, $671181bcc8a0cf10$var$_abortController)[$671181bcc8a0cf10$var$_abortController] = undefined;
    }
}
$671181bcc8a0cf10$export$2e2bcd8739ae039.VERSION = $671181bcc8a0cf10$var$packageJson.version;
















// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $3174b53b600a62c5$var$packageJson = {
    "version": "4.0.2"
};
const $3174b53b600a62c5$var$defaultState = {
    loading: false,
    searchString: "",
    partialTree: [
        {
            type: "root",
            id: null,
            cached: false,
            nextPagePath: null
        }
    ],
    currentFolderId: null,
    isInputMode: true
};
class $3174b53b600a62c5$export$2e2bcd8739ae039 {
    constructor(plugin, opts){
        this.isHandlingScroll = false;
        this.lastCheckbox = null;
        this.validateSingleFile = (file)=>{
            const companionFile = (0, $d0cca3c9705b0857$export$2e2bcd8739ae039)(file);
            const result = this.plugin.uppy.validateSingleFile(companionFile);
            return result;
        };
        this.getDisplayedPartialTree = ()=>{
            const { partialTree: partialTree } = this.plugin.getPluginState();
            return partialTree.filter((item)=>item.type !== "root");
        };
        this.setSearchString = (searchString)=>{
            this.plugin.setPluginState({
                searchString: searchString
            });
            if (searchString === "") this.plugin.setPluginState({
                partialTree: []
            });
        };
        this.validateAggregateRestrictions = (partialTree)=>{
            const checkedFiles = partialTree.filter((item)=>item.type === "file" && item.status === "checked");
            const uppyFiles = checkedFiles.map((file)=>file.data);
            return this.plugin.uppy.validateAggregateRestrictions(uppyFiles);
        };
        this.plugin = plugin;
        this.provider = opts.provider;
        const defaultOptions = {
            viewType: "grid",
            showTitles: true,
            showFilter: true
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.setSearchString = this.setSearchString.bind(this);
        this.search = this.search.bind(this);
        this.resetPluginState = this.resetPluginState.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
        this.donePicking = this.donePicking.bind(this);
        this.cancelSelection = this.cancelSelection.bind(this);
        this.toggleCheckbox = this.toggleCheckbox.bind(this);
        this.render = this.render.bind(this);
        // Set default state for the plugin
        this.resetPluginState();
        // @ts-expect-error this should be typed in @uppy/dashboard.
        this.plugin.uppy.on("dashboard:close-panel", this.resetPluginState);
        this.plugin.uppy.registerRequestClient(this.provider.provider, this.provider);
    }
    // eslint-disable-next-line class-methods-use-this
    tearDown() {
    // Nothing.
    }
    setLoading(loading) {
        this.plugin.setPluginState({
            loading: loading
        });
    }
    resetPluginState() {
        this.plugin.setPluginState($3174b53b600a62c5$var$defaultState);
    }
    cancelSelection() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const newPartialTree = partialTree.map((item)=>item.type === "root" ? item : {
                ...item,
                status: "unchecked"
            });
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
    }
    async search() {
        const { searchString: searchString } = this.plugin.getPluginState();
        if (searchString === "") return;
        this.setLoading(true);
        try {
            const response = await this.provider.search(searchString);
            const newPartialTree = [
                {
                    type: "root",
                    id: null,
                    cached: false,
                    nextPagePath: response.nextPageQuery
                },
                ...response.items.map((item)=>({
                        type: "file",
                        id: item.requestPath,
                        status: "unchecked",
                        parentId: null,
                        data: item
                    }))
            ];
            this.plugin.setPluginState({
                partialTree: newPartialTree,
                isInputMode: false
            });
        } catch (error) {
            (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
        }
        this.setLoading(false);
    }
    async handleScroll(event) {
        const { partialTree: partialTree, searchString: searchString } = this.plugin.getPluginState();
        const root = partialTree.find((i)=>i.type === "root");
        if ((0, $b5a8e6b281aacb12$export$2e2bcd8739ae039)(event) && !this.isHandlingScroll && root.nextPagePath) {
            this.isHandlingScroll = true;
            try {
                const response = await this.provider.search(searchString, root.nextPagePath);
                const newRoot = {
                    ...root,
                    nextPagePath: response.nextPageQuery
                };
                const oldItems = partialTree.filter((i)=>i.type !== "root");
                const newPartialTree = [
                    newRoot,
                    ...oldItems,
                    ...response.items.map((item)=>({
                            type: "file",
                            id: item.requestPath,
                            status: "unchecked",
                            parentId: null,
                            data: item
                        }))
                ];
                this.plugin.setPluginState({
                    partialTree: newPartialTree
                });
            } catch (error) {
                (0, $4ac650d5250ead28$export$2e2bcd8739ae039)(this.plugin.uppy)(error);
            }
            this.isHandlingScroll = false;
        }
    }
    async donePicking() {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        // 1. Add files
        const companionFiles = (0, $9b79bc726c3450f4$export$2e2bcd8739ae039)(partialTree);
        (0, $8e91ea798ebec2b3$export$2e2bcd8739ae039)(companionFiles, this.plugin, this.provider);
        // 2. Reset state
        this.resetPluginState();
    }
    toggleCheckbox(ourItem, isShiftKeyPressed) {
        const { partialTree: partialTree } = this.plugin.getPluginState();
        const clickedRange = (0, $3af8f69ec184395c$export$2e2bcd8739ae039)(ourItem.id, this.getDisplayedPartialTree(), isShiftKeyPressed, this.lastCheckbox);
        const newPartialTree = (0, $561f5272d8ac5b76$export$2e2bcd8739ae039).afterToggleCheckbox(partialTree, clickedRange);
        this.plugin.setPluginState({
            partialTree: newPartialTree
        });
        this.lastCheckbox = ourItem.id;
    }
    render(state, viewOptions) {
        if (viewOptions === void 0) viewOptions = {};
        const { isInputMode: isInputMode, searchString: searchString, loading: loading, partialTree: partialTree } = this.plugin.getPluginState();
        const { i18n: i18n } = this.plugin.uppy;
        const opts = {
            ...this.opts,
            ...viewOptions
        };
        if (isInputMode) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: this.setSearchString,
            submitSearchString: this.search,
            inputLabel: i18n("enterTextToSearch"),
            buttonLabel: i18n("searchImages"),
            wrapperClassName: "uppy-SearchProvider",
            inputClassName: "uppy-c-textInput uppy-SearchProvider-input",
            showButton: true,
            buttonCSSClassName: "uppy-SearchProvider-searchButton"
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-ProviderBrowser", `uppy-ProviderBrowser-viewType--${opts.viewType}`)
        }, opts.showFilter && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $f173600a8ed11ef3$export$2e2bcd8739ae039), {
            searchString: searchString,
            setSearchString: this.setSearchString,
            submitSearchString: this.search,
            inputLabel: i18n("search"),
            clearSearchLabel: i18n("resetSearch"),
            wrapperClassName: "uppy-ProviderBrowser-searchFilter",
            inputClassName: "uppy-ProviderBrowser-searchFilterInput"
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ffc120143b595bcb$export$2e2bcd8739ae039), {
            toggleCheckbox: this.toggleCheckbox,
            displayedPartialTree: this.getDisplayedPartialTree(),
            handleScroll: this.handleScroll,
            openFolder: async ()=>{},
            noResultsLabel: i18n("noSearchResults"),
            viewType: opts.viewType,
            showTitles: opts.showTitles,
            isLoading: loading,
            i18n: i18n,
            virtualList: false
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4ab2a94a3ee5ad67$export$2e2bcd8739ae039), {
            partialTree: partialTree,
            donePicking: this.donePicking,
            cancelSelection: this.cancelSelection,
            i18n: i18n,
            validateAggregateRestrictions: this.validateAggregateRestrictions
        }));
    }
}
$3174b53b600a62c5$export$2e2bcd8739ae039.VERSION = $3174b53b600a62c5$var$packageJson.version;






let $ee6f2436cceea22a$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $ee6f2436cceea22a$export$62e99e5c9f473d7f = (alphabet, defaultSize = 21)=>{
    return (size = defaultSize)=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $ee6f2436cceea22a$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $ee6f2436cceea22a$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};


var $e66b69e563b626e6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e66b69e563b626e6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e66b69e563b626e6$var$safeIsNaN(first) && $e66b69e563b626e6$var$safeIsNaN(second)) return true;
    return false;
}
function $e66b69e563b626e6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e66b69e563b626e6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e66b69e563b626e6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e66b69e563b626e6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $a6c8757fba02bc34$export$2e2bcd8739ae039 = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    "input:not([disabled]):not([inert]):not([aria-hidden])",
    "select:not([disabled]):not([inert]):not([aria-hidden])",
    "textarea:not([disabled]):not([inert]):not([aria-hidden])",
    "button:not([disabled]):not([inert]):not([aria-hidden])",
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];


/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ function $0a4934e80baa1792$export$2e2bcd8739ae039(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`);
        // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}


function $f5d602e6112dba3d$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $f5d602e6112dba3d$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
// ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
    const focusableNodes = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(activeOverlayEl.querySelectorAll((0, $a6c8757fba02bc34$export$2e2bcd8739ae039)));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement);
    // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$f5d602e6112dba3d$var$isFocusInOverlay(activeOverlayEl)) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
    else if (event.shiftKey && focusedItemIndex === 0) $f5d602e6112dba3d$var$focusOnLastNode(event, focusableNodes);
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $f5d602e6112dba3d$var$focusOnFirstNode(event, focusableNodes);
}
function $f5d602e6112dba3d$export$66fd63158b65050a(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $f5d602e6112dba3d$export$f41e0874aee57111(event, activeOverlayType, dashboardEl);
}





function $33dc1dd867a7b8b6$export$2e2bcd8739ae039() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = (0, $0a4934e80baa1792$export$2e2bcd8739ae039)(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement);
        // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]");
        // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector((0, $a6c8757fba02bc34$export$2e2bcd8739ae039));
            firstEl == null || firstEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    };
    // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8284bc2b60dc4bc4$exports)))(superFocus, 260);
}




/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 */ function $5e3c26e19f70d299$export$2e2bcd8739ae039() {
    const div = document.body;
    if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) return false;
    if (!("FormData" in window)) return false;
    if (!("FileReader" in window)) return false;
    return true;
}





/* eslint-disable react/destructuring-assignment */ 

function $4d35db026571eaa3$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $4d35db026571eaa3$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $4d35db026571eaa3$export$967a6b9924a689f7(a, b);
    return $4d35db026571eaa3$export$3e67810a3f0e9f1c(a, b);
}





function $7fe1d951359cc6e1$var$iconImage() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#686DE0",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        cx: "7.5",
        cy: "9.5",
        r: "1.5"
    })));
}
function $7fe1d951359cc6e1$var$iconAudio() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
        fill: "#049BCF",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconVideo() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
        fill: "#19AF67",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconPDF() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
        fill: "#E2514A",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconArchive() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
        fill: "#00C469",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$var$iconFile() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fill: "#A7AFB7",
        fillRule: "nonzero"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
    })));
}
function $7fe1d951359cc6e1$var$iconText() {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
        fill: "#5A5E69",
        fillRule: "nonzero"
    }));
}
function $7fe1d951359cc6e1$export$2e2bcd8739ae039(fileType) {
    const defaultChoice = {
        color: "#838999",
        icon: $7fe1d951359cc6e1$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split("/")[0];
    const fileTypeSpecific = fileType.split("/")[1];
    // Text
    if (fileTypeGeneral === "text") return {
        color: "#5a5e69",
        icon: $7fe1d951359cc6e1$var$iconText()
    };
    // Image
    if (fileTypeGeneral === "image") return {
        color: "#686de0",
        icon: $7fe1d951359cc6e1$var$iconImage()
    };
    // Audio
    if (fileTypeGeneral === "audio") return {
        color: "#068dbb",
        icon: $7fe1d951359cc6e1$var$iconAudio()
    };
    // Video
    if (fileTypeGeneral === "video") return {
        color: "#19af67",
        icon: $7fe1d951359cc6e1$var$iconVideo()
    };
    // PDF
    if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") return {
        color: "#e25149",
        icon: $7fe1d951359cc6e1$var$iconPDF()
    };
    // Archive
    const archiveTypes = [
        "zip",
        "x-7z-compressed",
        "x-zip-compressed",
        "x-rar-compressed",
        "x-tar",
        "x-gzip",
        "x-apple-diskimage"
    ];
    if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: "#00C469",
        icon: $7fe1d951359cc6e1$var$iconArchive()
    };
    return defaultChoice;
}


function $9e2af7705a2c15c5$export$2e2bcd8739ae039(props) {
    const { file: file } = props;
    if (file.preview) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("img", {
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-Dashboard-Item-previewIcon",
        style: {
            color: color
        }
    }, icon), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-Dashboard-Item-previewIconBg",
        width: "58",
        height: "76",
        viewBox: "0 0 58 76"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        fill: "#FFF",
        width: "58",
        height: "76",
        rx: "3",
        fillRule: "evenodd"
    })));
}



const $e8c1f4ca43ed49b9$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const fields = typeof metaFields === "function" ? metaFields() : metaFields;
    const field = fields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $e8c1f4ca43ed49b9$export$2e2bcd8739ae039(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$e8c1f4ca43ed49b9$var$metaFieldIdToName(missingMetaField, metaFields)).join(", ");
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-errorMessage"
    }, i18n("missingRequiredMetaFields", {
        smart_count: missingRequiredMetaFields.length,
        fields: metaFieldsString
    }), " ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
        onClick: ()=>toggleFileCard(true, file.id)
    }, i18n("editFile")));
}



function $bfd13c8521ef3809$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult } = props;
    const white = "rgba(255, 255, 255, 0.5)";
    const previewBackgroundColor = file.preview ? white : (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: previewBackgroundColor
        }
    }, showLinkToFileUploadResult && file.uploadURL && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        className: "uppy-Dashboard-Item-previewLink",
        href: file.uploadURL,
        rel: "noreferrer noopener",
        target: "_blank",
        "aria-label": file.meta.name
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        hidden: true
    }, file.meta.name)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}


/* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/destructuring-assignment */ 
function $130a6df4f019eb5d$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $130a6df4f019eb5d$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n("uploadComplete");
    if (props.error) return props.i18n("retryUpload");
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n("resumeUpload");
        return props.i18n("pauseUpload");
    }
    if (props.individualCancellation) return props.i18n("cancelUpload");
    return "";
}
function $130a6df4f019eb5d$var$ProgressIndicatorButton(props) {
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-progressIndicator",
        type: "button",
        "aria-label": $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        title: $130a6df4f019eb5d$var$progressIndicatorTitle(props),
        onClick: ()=>$130a6df4f019eb5d$var$onPauseResumeCancelRetry(props)
    }, props.children));
}
function $130a6df4f019eb5d$var$ProgressCircleContainer(_ref) {
    let { children: children } = _ref;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
    }, children);
}
function $130a6df4f019eb5d$var$ProgressCircle(_ref2) {
    let { progress: progress } = _ref2;
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--bg",
        r: "15",
        cx: "18",
        cy: "18",
        "stroke-width": "2",
        fill: "none"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--progress",
        r: "15",
        cx: "18",
        cy: "18",
        transform: "rotate(-90, 18, 18)",
        fill: "none",
        "stroke-width": "2",
        "stroke-dasharray": circleLength,
        "stroke-dashoffset": circleLength - circleLength / 100 * progress
    }));
}
function $130a6df4f019eb5d$export$2e2bcd8739ae039(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
    if (props.file.progress.percentage === undefined) return null;
    // Green checkmark when complete
    if (props.isUploaded) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        r: "15",
        cx: "18",
        cy: "18",
        fill: "#1bb240"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--check",
        transform: "translate(2, 3)",
        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
    if (props.recoveredState) return null;
    // Retry button for error
    if (props.error && !props.hideRetryButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.9 3H10v2H7.9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
    }))));
    // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), props.file.isPaused ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    })))));
    // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return(// eslint-disable-next-line react/jsx-props-no-spreading
    (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressIndicatorButton, props, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
    }))));
    // Just progress when buttons are disabled
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircleContainer, null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($130a6df4f019eb5d$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }))));
}


/* eslint-disable react/destructuring-assignment */ 

/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 */ const $1e7f833197af6f70$var$separator = "...";
function $1e7f833197af6f70$export$2e2bcd8739ae039(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return "";
    // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string;
    // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $1e7f833197af6f70$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $1e7f833197af6f70$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $1e7f833197af6f70$var$separator + string.slice(-backChars);
}



const $35b148ba1db29747$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.isSingleFile && props.containerHeight >= 350) return 90;
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
        // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(name, getMaxNameLength()));
};
const $35b148ba1db29747$var$renderAuthor = (props)=>{
    var _props$file$remote;
    const { author: author } = props.file.meta;
    const providerName = (_props$file$remote = props.file.remote) == null ? void 0 : _props$file$remote.providerName;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-author"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, (0, $1e7f833197af6f70$export$2e2bcd8739ae039)(author.name, 13)), providerName ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)(Fragment, null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
const $35b148ba1db29747$var$renderFileSize = (props)=>props.file.size && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-statusSize"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($06e80194017bcce5$exports)))(props.file.size));
const $35b148ba1db29747$var$ReSelectButton = (props)=>props.file.isGhost && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, " \u2022 ", (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(true)
    }, props.i18n("reSelect")));
const $35b148ba1db29747$var$ErrorButton = (_ref)=>{
    let { file: file, onClick: onClick } = _ref;
    if (file.error) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button"
    }, "?");
    return null;
};
function $35b148ba1db29747$export$2e2bcd8739ae039(props) {
    const { file: file, i18n: i18n, toggleFileCard: toggleFileCard, metaFields: metaFields, toggleAddFilesPanel: toggleAddFilesPanel, isSingleFile: isSingleFile, containerHeight: containerHeight, containerWidth: containerWidth } = props;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-fileName"
    }, $35b148ba1db29747$var$renderFileName({
        file: file,
        isSingleFile: isSingleFile,
        containerHeight: containerHeight,
        containerWidth: containerWidth
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($35b148ba1db29747$var$ErrorButton, {
        file: file,
        onClick: ()=>alert(file.error)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-status"
    }, $35b148ba1db29747$var$renderAuthor({
        file: file
    }), $35b148ba1db29747$var$renderFileSize({
        file: file
    }), $35b148ba1db29747$var$ReSelectButton({
        file: file,
        toggleAddFilesPanel: toggleAddFilesPanel,
        i18n: i18n
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e8c1f4ca43ed49b9$export$2e2bcd8739ae039), {
        file: file,
        i18n: i18n,
        toggleFileCard: toggleFileCard,
        metaFields: metaFields
    }));
}



/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ function $1402db5492a36d8b$export$2e2bcd8739ae039(textToCopy, fallbackString) {
    if (fallbackString === void 0) fallbackString = "Copy the URL below";
    return new Promise((resolve)=>{
        const textArea = document.createElement("textarea");
        textArea.setAttribute("style", {
            position: "fixed",
            top: 0,
            left: 0,
            width: "2em",
            height: "2em",
            padding: 0,
            border: "none",
            outline: "none",
            boxShadow: "none",
            background: "transparent"
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = ()=>{
            document.body.removeChild(textArea);
            // eslint-disable-next-line no-alert
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand("copy");
            if (!successful) return magicCopyFailed();
            document.body.removeChild(textArea);
            return resolve();
        } catch (err) {
            document.body.removeChild(textArea);
            return magicCopyFailed();
        }
    });
}


function $d15239db21f41277$var$EditButton(_ref) {
    let { file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick } = _ref;
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        title: i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
        fillRule: "nonzero"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("rect", {
        x: "1",
        y: "12.293",
        width: "11",
        height: "1",
        rx: ".5"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fillRule: "nonzero",
        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
    return null;
}
function $d15239db21f41277$var$RemoveButton(_ref2) {
    let { i18n: i18n, onClick: onClick, file: file } = _ref2;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n("removeFile", {
            file: file.meta.name
        }),
        title: i18n("removeFile", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#FFF",
        d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
    })));
}
function $d15239db21f41277$var$CopyLinkButton(_ref3) {
    let { file: file, uppy: uppy, i18n: i18n } = _ref3;
    const copyLinkToClipboard = (event)=>{
        (0, $1402db5492a36d8b$export$2e2bcd8739ae039)(file.uploadURL, i18n("copyLinkToClipboardFallback")).then(()=>{
            uppy.log("Link copied to clipboard.");
            uppy.info(i18n("copyLinkToClipboardSuccess"), "info", 3000);
        }).catch(uppy.log)// avoid losing focus
        .then(()=>event.target.focus({
                preventScroll: true
            }));
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n("copyLink"),
        title: i18n("copyLink"),
        onClick: (event)=>copyLinkToClipboard(event)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 12"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
    })));
}
function $d15239db21f41277$export$2e2bcd8739ae039(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-Item-actionWrapper"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$EditButton, {
        i18n: i18n,
        file: file,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        canEditFile: canEditFile,
        metaFields: metaFields,
        onClick: editAction
    }), showLinkToFileUploadResult && file.uploadURL ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$CopyLinkButton, {
        file: file,
        uppy: uppy,
        i18n: i18n
    }) : null, showRemoveButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($d15239db21f41277$var$RemoveButton, {
        i18n: i18n,
        file: file,
        onClick: ()=>uppy.removeFile(file.id)
    }) : null);
}


class $ed540296fca56761$export$2e2bcd8739ae039 extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, $4d35db026571eaa3$export$3e67810a3f0e9f1c)(this.props, nextProps);
    }
    // VirtualList mounts FileItems again and they emit `thumbnail:request`
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = !!file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = !!file.progress.uploadStarted || !!isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false;
        // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
            "uppy-Dashboard-Item": true,
            "is-inprogress": uploadInProgress && !this.props.recoveredState,
            "is-processing": isProcessing,
            "is-complete": isUploaded,
            "is-error": !!error,
            "is-resumable": this.props.resumableUploads,
            "is-noIndividualCancellation": !this.props.individualCancellation,
            "is-ghost": isGhost
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-preview"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $bfd13c8521ef3809$export$2e2bcd8739ae039), {
            file: file,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            i18n: this.props.i18n,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $130a6df4f019eb5d$export$2e2bcd8739ae039), {
            uppy: this.props.uppy,
            file: file,
            error: error,
            isUploaded: isUploaded,
            hideRetryButton: this.props.hideRetryButton,
            hideCancelButton: this.props.hideCancelButton,
            hidePauseResumeButton: this.props.hidePauseResumeButton,
            recoveredState: this.props.recoveredState,
            resumableUploads: this.props.resumableUploads,
            individualCancellation: this.props.individualCancellation,
            i18n: this.props.i18n
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-Item-fileInfoAndButtons"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35b148ba1db29747$export$2e2bcd8739ae039), {
            file: file,
            containerWidth: this.props.containerWidth,
            containerHeight: this.props.containerHeight,
            i18n: this.props.i18n,
            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields,
            isSingleFile: this.props.isSingleFile
        }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d15239db21f41277$export$2e2bcd8739ae039), {
            file: file,
            metaFields: this.props.metaFields,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            showRemoveButton: showRemoveButton,
            canEditFile: this.props.canEditFile,
            uploadInProgressOrComplete: uploadInProgressOrComplete,
            toggleFileCard: this.props.toggleFileCard,
            openFileEditor: this.props.openFileEditor,
            uppy: this.props.uppy,
            i18n: this.props.i18n
        })));
    }
}


function $7a578b6cd2206257$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
function $7a578b6cd2206257$export$2e2bcd8739ae039(_ref) {
    let { id: id, i18n: i18n, uppy: uppy, files: files, resumableUploads: resumableUploads, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButtonAfterComplete: showRemoveButtonAfterComplete, metaFields: metaFields, isSingleFile: isSingleFile, toggleFileCard: toggleFileCard, handleRequestThumbnail: handleRequestThumbnail, handleCancelThumbnail: handleCancelThumbnail, recoveredState: recoveredState, individualCancellation: individualCancellation, itemsPerRow: itemsPerRow, openFileEditor: openFileEditor, canEditFile: canEditFile, toggleAddFilesPanel: toggleAddFilesPanel, containerWidth: containerWidth, containerHeight: containerHeight } = _ref;
    // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = itemsPerRow === 1 ? // Mobile
    71 : 200;
    // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const rows = (0, $e28f05d17e052ff9$export$1538c33de8887b59)(()=>{
        const sortByGhostComesFirst = (file1, file2)=>Number(files[file2].isGhost) - Number(files[file1].isGhost);
        const fileIds = Object.keys(files);
        if (recoveredState) fileIds.sort(sortByGhostComesFirst);
        return $7a578b6cd2206257$var$chunks(fileIds, itemsPerRow);
    }, [
        files,
        itemsPerRow,
        recoveredState
    ]);
    const renderRow = (row)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            class: "uppy-Dashboard-filesInner",
            role: "presentation",
            key: row[0]
        }, row.map((fileID)=>(0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $ed540296fca56761$export$2e2bcd8739ae039), {
                key: fileID,
                uppy: uppy,
                id: id,
                i18n: i18n,
                resumableUploads: resumableUploads,
                individualCancellation: individualCancellation,
                hideRetryButton: hideRetryButton,
                hidePauseResumeButton: hidePauseResumeButton,
                hideCancelButton: hideCancelButton,
                showLinkToFileUploadResult: showLinkToFileUploadResult,
                showRemoveButtonAfterComplete: showRemoveButtonAfterComplete,
                metaFields: metaFields,
                recoveredState: recoveredState,
                isSingleFile: isSingleFile,
                containerWidth: containerWidth,
                containerHeight: containerHeight,
                toggleFileCard: toggleFileCard,
                handleRequestThumbnail: handleRequestThumbnail,
                handleCancelThumbnail: handleCancelThumbnail,
                role: "listitem",
                openFileEditor: openFileEditor,
                canEditFile: canEditFile,
                toggleAddFilesPanel: toggleAddFilesPanel,
                file: files[fileID]
            })));
    if (isSingleFile) return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        class: "uppy-Dashboard-files"
    }, renderRow(rows[0]));
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $aba06cd85441b3f8$export$2e2bcd8739ae039), {
        class: "uppy-Dashboard-files",
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
}


/* eslint-disable react/destructuring-assignment */ 
class $3f3c0a16d9cbe8a2$var$AddFiles extends (0, $4d2e93495e50cc85$export$16fa2f45be04daa8) {
    constructor(){
        super(...arguments);
        this.fileInput = null;
        this.folderInput = null;
        this.mobilePhotoFileInput = null;
        this.mobileVideoFileInput = null;
        this.triggerFileInputClick = ()=>{
            var _this$fileInput;
            (_this$fileInput = this.fileInput) == null || _this$fileInput.click();
        };
        this.triggerFolderInputClick = ()=>{
            var _this$folderInput;
            (_this$folderInput = this.folderInput) == null || _this$folderInput.click();
        };
        this.triggerVideoCameraInputClick = ()=>{
            var _this$mobileVideoFile;
            (_this$mobileVideoFile = this.mobileVideoFileInput) == null || _this$mobileVideoFile.click();
        };
        this.triggerPhotoCameraInputClick = ()=>{
            var _this$mobilePhotoFile;
            (_this$mobilePhotoFile = this.mobilePhotoFileInput) == null || _this$mobilePhotoFile.click();
        };
        this.onFileInputChange = (event)=>{
            this.props.handleInputChange(event);
            // Clear the input so that Chrome/Safari/etc. can detect file section when the same file is repeatedly selected
            // (see https://github.com/transloadit/uppy/issues/768#issuecomment-2264902758)
            // eslint-disable-next-line no-param-reassign
            event.currentTarget.value = "";
        };
        this.renderHiddenInput = (isFolder, refCallback)=>{
            var _this$props$allowedFi;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                webkitdirectory: isFolder,
                type: "file",
                name: "files[]",
                multiple: this.props.maxNumberOfFiles !== 1,
                onChange: this.onFileInputChange,
                accept: (_this$props$allowedFi = this.props.allowedFileTypes) == null ? void 0 : _this$props$allowedFi.join(", "),
                ref: refCallback
            });
        };
        this.renderHiddenCameraInput = (type, nativeCameraFacingMode, refCallback)=>{
            const typeToAccept = {
                photo: "image/*",
                video: "video/*"
            };
            const accept = typeToAccept[type];
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                type: "file",
                name: `camera-${type}`,
                onChange: this.onFileInputChange,
                capture: nativeCameraFacingMode,
                accept: accept,
                ref: refCallback
            });
        };
        this.renderMyDeviceAcquirer = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MyDevice"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                className: "uppy-DashboardTab-iconMyDevice",
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M8.45 22.087l-1.305-6.674h17.678l-1.572 6.674H8.45zm4.975-12.412l1.083 1.765a.823.823 0 00.715.386h7.951V13.5H8.587V9.675h4.838zM26.043 13.5h-1.195v-2.598c0-.463-.336-.75-.798-.75h-8.356l-1.082-1.766A.823.823 0 0013.897 8H7.728c-.462 0-.815.256-.815.718V13.5h-.956a.97.97 0 00-.746.37.972.972 0 00-.19.81l1.724 8.565c.095.44.484.755.933.755H24c.44 0 .824-.3.929-.727l2.043-8.568a.972.972 0 00-.176-.825.967.967 0 00-.753-.38z",
                fill: "currentcolor",
                "fill-rule": "evenodd"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("myDevice"))));
        };
        this.renderPhotoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobilePhotoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerPhotoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                d: "M23.5 9.5c1.417 0 2.5 1.083 2.5 2.5v9.167c0 1.416-1.083 2.5-2.5 2.5h-15c-1.417 0-2.5-1.084-2.5-2.5V12c0-1.417 1.083-2.5 2.5-2.5h2.917l1.416-2.167C13 7.167 13.25 7 13.5 7h5c.25 0 .5.167.667.333L20.583 9.5H23.5zM16 11.417a4.706 4.706 0 00-4.75 4.75 4.704 4.704 0 004.75 4.75 4.703 4.703 0 004.75-4.75c0-2.663-2.09-4.75-4.75-4.75zm0 7.825c-1.744 0-3.076-1.332-3.076-3.074 0-1.745 1.333-3.077 3.076-3.077 1.744 0 3.074 1.333 3.074 3.076s-1.33 3.075-3.074 3.075z",
                fill: "#02B383",
                "fill-rule": "nonzero"
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("takePictureBtn"))));
        };
        this.renderVideoCamera = ()=>{
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MobileVideoCamera"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerVideoCameraInputClick
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
                "aria-hidden": "true",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
                fill: "#FF675E",
                fillRule: "nonzero",
                d: "m21.254 14.277 2.941-2.588c.797-.313 1.243.818 1.09 1.554-.01 2.094.02 4.189-.017 6.282-.126.915-1.145 1.08-1.58.34l-2.434-2.142c-.192.287-.504 1.305-.738.468-.104-1.293-.028-2.596-.05-3.894.047-.312.381.823.426 1.069.063-.384.206-.744.362-1.09zm-12.939-3.73c3.858.013 7.717-.025 11.574.02.912.129 1.492 1.237 1.351 2.217-.019 2.412.04 4.83-.03 7.239-.17 1.025-1.166 1.59-2.029 1.429-3.705-.012-7.41.025-11.114-.019-.913-.129-1.492-1.237-1.352-2.217.018-2.404-.036-4.813.029-7.214.136-.82.83-1.473 1.571-1.454z "
            }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("recordVideoBtn"))));
        };
        this.renderBrowseButton = (text, onClickFn)=>{
            const numberOfAcquirers = this.props.acquirers.length;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-Dashboard-browse",
                onClick: onClickFn,
                "data-uppy-super-focusable": numberOfAcquirers === 0
            }, text);
        };
        this.renderDropPasteBrowseTagline = (numberOfAcquirers)=>{
            const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
            const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick);
            // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
            // to Camel
            const lowerFMSelectionType = this.props.fileManagerSelectionType;
            const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                class: "uppy-Dashboard-AddFiles-title"
            }, // eslint-disable-next-line no-nested-ternary
            this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }));
        };
        this.renderAcquirer = (acquirer)=>{
            var _this$props$activePic;
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": acquirer.id
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": ((_this$props$activePic = this.props.activePickerPanel) == null ? void 0 : _this$props$activePic.id) === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id)
            }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-inner"
            }, acquirer.icon()), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-DashboardTab-name"
            }, acquirer.name)));
        };
        this.renderAcquirers = (acquirers)=>{
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const acquirersWithoutLastTwo = [
                ...acquirers
            ];
            const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))));
        };
        this.renderSourcesList = (acquirers, disableLocalFiles)=>{
            const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton } = this.props;
            let list = [];
            const myDeviceKey = "myDevice";
            if (!disableLocalFiles) list.push({
                key: myDeviceKey,
                elements: this.renderMyDeviceAcquirer()
            });
            if (showNativePhotoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderPhotoCamera()
            });
            if (showNativeVideoCameraButton) list.push({
                key: "nativePhotoCameraButton",
                elements: this.renderVideoCamera()
            });
            list.push(...acquirers.map((acquirer)=>({
                    key: acquirer.id,
                    elements: this.renderAcquirer(acquirer)
                })));
            // doesn't make sense to show only a lonely "My Device"
            const hasOnlyMyDevice = list.length === 1 && list[0].key === myDeviceKey;
            if (hasOnlyMyDevice) list = [];
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const listWithoutLastTwo = [
                ...list
            ];
            const lastTwo = listWithoutLastTwo.splice(list.length - 2, list.length);
            return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), null, this.renderDropPasteBrowseTagline(list.length), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
                className: "uppy-Dashboard-AddFiles-list",
                role: "tablist"
            }, listWithoutLastTwo.map((_ref)=>{
                let { key: key, elements: elements } = _ref;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                    key: key
                }, elements);
            }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwo.map((_ref2)=>{
                let { key: key, elements: elements } = _ref2;
                return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $4d2e93495e50cc85$export$ffb0004e005737fa), {
                    key: key
                }, elements);
            }))));
        };
    }
    [Symbol.for("uppy test: disable unused locale key warning")]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray("dropPasteBoth");
        this.props.i18nArray("dropPasteFiles");
        this.props.i18nArray("dropPasteFolders");
        this.props.i18nArray("dropPasteImportBoth");
        this.props.i18nArray("dropPasteImportFiles");
        this.props.i18nArray("dropPasteImportFolders");
    }
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
            width: "11",
            height: "11",
            viewBox: "0 0 11 11"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
            d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
            fillRule: "evenodd"
        })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-Dashboard-poweredByUppy"
        }, "Uppy"));
        const linkText = i18nArray("poweredBy", {
            uppy: uppyBranding
        });
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("a", {
            tabIndex: -1,
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy"
        }, linkText);
    }
    render() {
        const { showNativePhotoCameraButton: showNativePhotoCameraButton, showNativeVideoCameraButton: showNativeVideoCameraButton, nativeCameraFacingMode: nativeCameraFacingMode } = this.props;
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles"
        }, this.renderHiddenInput(false, (ref)=>{
            this.fileInput = ref;
        }), this.renderHiddenInput(true, (ref)=>{
            this.folderInput = ref;
        }), showNativePhotoCameraButton && this.renderHiddenCameraInput("photo", nativeCameraFacingMode, (ref)=>{
            this.mobilePhotoFileInput = ref;
        }), showNativeVideoCameraButton && this.renderHiddenCameraInput("video", nativeCameraFacingMode, (ref)=>{
            this.mobileVideoFileInput = ref;
        }), this.renderSourcesList(this.props.acquirers, this.props.disableLocalFiles), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-AddFiles-info"
        }, this.props.note && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
            className: "uppy-Dashboard-note"
        }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy()));
    }
}
var $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039 = $3f3c0a16d9cbe8a2$var$AddFiles;


/* eslint-disable react/destructuring-assignment */ 


const $175934b4bbc4fb46$var$AddFilesPanel = (props)=>{
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-AddFilesPanel", props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": !props.showAddFilesPanel
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18n("addingMoreFiles")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(false)
    }, props.i18n("back"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), props));
};
var $175934b4bbc4fb46$export$2e2bcd8739ae039 = $175934b4bbc4fb46$var$AddFilesPanel;





// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $cb1052d4a6aa569a$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
var $cb1052d4a6aa569a$export$2e2bcd8739ae039 = $cb1052d4a6aa569a$var$ignoreEvent;


function $e3578ca53f5728a8$var$PickerPanelContent(_ref) {
    let { activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy } = _ref;
    const ref = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)(null);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18n("importFrom", {
        name: activePickerPanel.name
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: hideAllPanels
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        ref: ref,
        className: "uppy-DashboardContent-panelBody"
    }, uppy.getPlugin(activePickerPanel.id).render(state, ref.current)));
}
var $e3578ca53f5728a8$export$2e2bcd8739ae039 = $e3578ca53f5728a8$var$PickerPanelContent;


/* eslint-disable react/destructuring-assignment */ 

function $d8360bbc75e6a373$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    const handleCancel = ()=>{
        props.uppy.emit("file-editor:cancel", file);
        props.closeFileEditor();
    };
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-DashboardContent-panel", props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: handleCancel
    }, props.i18n("cancel")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-save",
        type: "button",
        onClick: props.saveFileEditor
    }, props.i18n("save"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, props.editors.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })));
}
var $d8360bbc75e6a373$export$2e2bcd8739ae039 = $d8360bbc75e6a373$var$EditorPanel;



const $915070fc553cba86$var$uploadStates = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete",
    STATE_PAUSED: "paused"
};
function $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
    if (files === void 0) files = {};
    if (isAllErrored) return $915070fc553cba86$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $915070fc553cba86$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $915070fc553cba86$var$uploadStates.STATE_PAUSED;
    let state = $915070fc553cba86$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]];
        // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $915070fc553cba86$var$uploadStates.STATE_UPLOADING;
        // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING) state = $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING;
        // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $915070fc553cba86$var$uploadStates.STATE_UPLOADING && state !== $915070fc553cba86$var$uploadStates.STATE_PREPROCESSING) state = $915070fc553cba86$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $915070fc553cba86$var$UploadStatus(_ref) {
    let { files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles } = _ref;
    const uploadingState = $915070fc553cba86$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case "uploading":
            return i18n("uploadingXFiles", {
                smart_count: inProgressNotPausedFiles.length
            });
        case "preprocessing":
        case "postprocessing":
            return i18n("processingXFiles", {
                smart_count: processingFiles.length
            });
        case "paused":
            return i18n("uploadPaused");
        case "waiting":
            return i18n("xFilesSelected", {
                smart_count: newFiles.length
            });
        case "complete":
            return i18n("uploadComplete");
        case "error":
            return i18n("error");
        default:
    }
}
function $915070fc553cba86$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props;
    // TODO maybe this should be done in ../Dashboard.jsx, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) // eslint-disable-next-line react/destructuring-assignment
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, !isAllComplete && !hideCancelButton ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>uppy.cancelAll()
    }, i18n("cancel")) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)($915070fc553cba86$var$UploadStatus, props)), allowNewUpload ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-addMore",
        type: "button",
        "aria-label": i18n("addMoreFiles"),
        title: i18n("addMoreFiles"),
        onClick: ()=>toggleAddFilesPanel(true)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        className: "uppy-DashboardContent-addMoreCaption"
    }, i18n("addMore"))) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", null));
}
var $915070fc553cba86$export$2e2bcd8739ae039 = $915070fc553cba86$var$PanelTopBar;










function $fca34f2366194ceb$export$2e2bcd8739ae039(props) {
    const { computedMetaFields: computedMetaFields, requiredMetaFields: requiredMetaFields, updateMeta: updateMeta, form: form, formState: formState } = props;
    const fieldCSSClasses = {
        text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
    };
    return computedMetaFields.map((field)=>{
        const id = `uppy-Dashboard-FileCard-input-${field.id}`;
        const required = requiredMetaFields.includes(field.id);
        return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("fieldset", {
            key: field.id,
            className: "uppy-Dashboard-FileCard-fieldset"
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("label", {
            className: "uppy-Dashboard-FileCard-label",
            htmlFor: id
        }, field.name), field.render !== undefined ? field.render({
            value: formState[field.id],
            onChange: (newVal)=>updateMeta(newVal, field.id),
            fieldCSSClasses: fieldCSSClasses,
            required: required,
            form: form.id
        }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("input", {
            className: fieldCSSClasses.text,
            id: id,
            form: form.id,
            type: field.type || "text",
            required: required,
            value: formState[field.id],
            placeholder: field.placeholder,
            onInput: (ev)=>updateMeta(ev.target.value, field.id),
            "data-uppy-super-focusable": true
        }));
    });
}


function $af43f3a66035ecee$export$2e2bcd8739ae039(props) {
    var _getMetaFields;
    const { files: files, fileCardFor: fileCardFor, toggleFileCard: toggleFileCard, saveFileCard: saveFileCard, metaFields: metaFields, requiredMetaFields: requiredMetaFields, openFileEditor: openFileEditor, i18n: i18n, i18nArray: i18nArray, className: className, canEditFile: canEditFile } = props;
    const getMetaFields = ()=>{
        return typeof metaFields === "function" ? metaFields(files[fileCardFor]) : metaFields;
    };
    const file = files[fileCardFor];
    const computedMetaFields = (_getMetaFields = getMetaFields()) != null ? _getMetaFields : [];
    const showEditButton = canEditFile(file);
    const storedMetaData = {};
    computedMetaFields.forEach((field)=>{
        var _file$meta$field$id;
        storedMetaData[field.id] = (_file$meta$field$id = file.meta[field.id]) != null ? _file$meta$field$id : "";
    });
    const [formState, setFormState] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(storedMetaData);
    const handleSave = (0, $e28f05d17e052ff9$export$35808ee640e87ca7)((ev)=>{
        ev.preventDefault();
        saveFileCard(formState, fileCardFor);
    }, [
        saveFileCard,
        formState,
        fileCardFor
    ]);
    const updateMeta = (newVal, name)=>{
        setFormState({
            ...formState,
            [name]: newVal
        });
    };
    const handleCancel = ()=>{
        toggleFileCard(false);
    };
    const [form] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(()=>{
        const formEl = document.createElement("form");
        formEl.setAttribute("tabindex", "-1");
        formEl.id = (0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)();
        return formEl;
    });
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        document.body.appendChild(form);
        form.addEventListener("submit", handleSave);
        return ()=>{
            form.removeEventListener("submit", handleSave);
            document.body.removeChild(form);
        };
    }, [
        form,
        handleSave
    ]);
    return (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))("uppy-Dashboard-FileCard", className),
        "data-uppy-panelType": "FileCard",
        onDragOver: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDragLeave: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onDrop: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039),
        onPaste: (0, $cb1052d4a6aa569a$export$2e2bcd8739ae039)
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18nArray("editing", {
        file: (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        form: form.id,
        title: i18n("finishEditingFile"),
        onClick: handleCancel
    }, i18n("cancel"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-inner"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-preview",
        style: {
            backgroundColor: (0, $7fe1d951359cc6e1$export$2e2bcd8739ae039)(file.type).color
        }
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $9e2af7705a2c15c5$export$2e2bcd8739ae039), {
        file: file
    }), showEditButton && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
        onClick: (event)=>{
            // When opening the image editor we want to save any meta fields changes.
            // Otherwise it's confusing for the user to click save in the editor,
            // but the changes here are discarded. This bypasses validation,
            // but we are okay with that.
            handleSave(event);
            openFileEditor(file);
        }
    }, i18n("editImage"))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-info"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $fca34f2366194ceb$export$2e2bcd8739ae039), {
        computedMetaFields: computedMetaFields,
        requiredMetaFields: requiredMetaFields,
        updateMeta: updateMeta,
        form: form,
        formState: formState
    })), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-FileCard-actions"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn",
        type: "submit",
        form: form.id
    }, i18n("saveChanges")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
        type: "button",
        onClick: handleCancel,
        form: form.id
    }, i18n("cancel")))));
}





const $35cf1967ab48fc35$var$transitionName = "uppy-transition-slideDownUp";
const $35cf1967ab48fc35$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ function $35cf1967ab48fc35$var$Slide(_ref) {
    let { children: children } = _ref;
    const [cachedChildren, setCachedChildren] = (0, $e28f05d17e052ff9$export$60241385465d0a34)(null);
    const [className, setClassName] = (0, $e28f05d17e052ff9$export$60241385465d0a34)("");
    const enterTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const leaveTimeoutRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const animationFrameRef = (0, $e28f05d17e052ff9$export$b8f5890fc79d6aca)();
    const handleEnterTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(leaveTimeoutRef.current);
        leaveTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-enter ${$35cf1967ab48fc35$var$transitionName}-enter-active`);
            enterTimeoutRef.current = setTimeout(()=>{
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    const handleLeaveTransition = ()=>{
        setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave`);
        cancelAnimationFrame(animationFrameRef.current);
        clearTimeout(enterTimeoutRef.current);
        enterTimeoutRef.current = undefined;
        animationFrameRef.current = requestAnimationFrame(()=>{
            setClassName(`${$35cf1967ab48fc35$var$transitionName}-leave ${$35cf1967ab48fc35$var$transitionName}-leave-active`);
            leaveTimeoutRef.current = setTimeout(()=>{
                setCachedChildren(null);
                setClassName("");
            }, $35cf1967ab48fc35$var$duration);
        });
    };
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        const child = (0, $4d2e93495e50cc85$export$47e4c5b300681277)(children)[0];
        if (cachedChildren === child) return;
        if (child && !cachedChildren) handleEnterTransition();
        else if (cachedChildren && !child && !leaveTimeoutRef.current) handleLeaveTransition();
        setCachedChildren(child);
    }, [
        children,
        cachedChildren
    ]); // Dependency array to trigger effect on children change
    (0, $e28f05d17e052ff9$export$6d9c69b0de29b591)(()=>{
        return ()=>{
            clearTimeout(enterTimeoutRef.current);
            clearTimeout(leaveTimeoutRef.current);
            cancelAnimationFrame(animationFrameRef.current);
        };
    }, []); // Cleanup useEffect
    if (!cachedChildren) return null;
    return (0, $4d2e93495e50cc85$export$e530037191fcd5d7)(cachedChildren, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))(className, cachedChildren.props.className)
    });
}
var $35cf1967ab48fc35$export$2e2bcd8739ae039 = $35cf1967ab48fc35$var$Slide;


function $8dc96b7f61bbef1d$var$_extends() {
    return $8dc96b7f61bbef1d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $8dc96b7f61bbef1d$var$_extends.apply(null, arguments);
}
// http://dev.edenspiekermann.com/2016/02/11/introducing-accessible-modal-dialog
// https://github.com/ghosh/micromodal
const $8dc96b7f61bbef1d$var$WIDTH_XL = 900;
const $8dc96b7f61bbef1d$var$WIDTH_LG = 700;
const $8dc96b7f61bbef1d$var$WIDTH_MD = 576;
const $8dc96b7f61bbef1d$var$HEIGHT_MD = 330;
function $8dc96b7f61bbef1d$export$2e2bcd8739ae039(props) {
    const isNoFiles = props.totalFileCount === 0;
    const isSingleFile = props.totalFileCount === 1;
    const isSizeMD = props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD;
    const isSizeHeightMD = props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD;
    const dashboardClassName = (0, (/*@__PURE__*/$parcel$interopDefault($02c2aab7657be691$exports)))({
        "uppy-Dashboard": true,
        "uppy-Dashboard--isDisabled": props.disabled,
        "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
        "uppy-Dashboard--isClosing": props.isClosing,
        "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
        "uppy-Dashboard--modal": !props.inline,
        "uppy-size--md": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD,
        "uppy-size--lg": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG,
        "uppy-size--xl": props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL,
        "uppy-size--height-md": props.containerHeight > $8dc96b7f61bbef1d$var$HEIGHT_MD,
        // We might want to enable this in the future
        // 'uppy-size--height-lg': props.containerHeight > HEIGHT_LG,
        // 'uppy-size--height-xl': props.containerHeight > HEIGHT_XL,
        "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
        "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible,
        // Only enable “centered single file” mode when Dashboard is tall enough
        "uppy-Dashboard--singleFile": props.singleFileFullScreen && isSingleFile && isSizeHeightMD
    });
    // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $8dc96b7f61bbef1d$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !isNoFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : 0;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n("recoveredXFiles", {
            smart_count: numberOfGhosts
        });
        return props.i18n("recoveredAllFiles");
    };
    const dashboard = (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && (0, $5e3c26e19f70d299$export$2e2bcd8739ae039)(),
        "aria-hidden": props.inline ? "false" : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        "aria-hidden": "true",
        className: "uppy-Dashboard-overlay",
        tabIndex: -1,
        onClick: props.handleClickOutside
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-inner",
        "aria-modal": !props.inline && "true",
        role: props.inline ? undefined : "dialog",
        style: {
            width: props.inline && props.width ? props.width : "",
            height: props.inline && props.height ? props.height : ""
        }
    }, !props.inline ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("button", {
        className: "uppy-u-reset uppy-Dashboard-close",
        type: "button",
        "aria-label": props.i18n("closeModal"),
        title: props.i18n("closeModal"),
        onClick: props.closeModal
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("span", {
        "aria-hidden": "true"
    }, "\xd7")) : null, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-innerWrap"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-dropFilesHereHint"
    }, props.i18n("dropHint")), showFileList && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $915070fc553cba86$export$2e2bcd8739ae039), props), numberOfFilesForRecovery && (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("svg", {
        className: "uppy-Dashboard-serviceMsg-icon",
        "aria-hidden": "true",
        focusable: "false",
        width: "21",
        height: "16",
        viewBox: "0 0 24 19"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("g", {
        transform: "translate(0 -1)",
        fill: "none",
        fillRule: "evenodd"
    }, (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
        fill: "#FFD300"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("path", {
        fill: "#000",
        d: "M11 6h2l-.3 8h-1.4z"
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("circle", {
        fill: "#000",
        cx: "12",
        cy: "17",
        r: "1"
    }))), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("strong", {
        className: "uppy-Dashboard-serviceMsg-title"
    }, props.i18n("sessionRestored")), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-serviceMsg-text"
    }, renderRestoredText())), showFileList ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $7a578b6cd2206257$export$2e2bcd8739ae039), {
        id: props.id,
        i18n: props.i18n,
        uppy: props.uppy,
        files: props.files,
        resumableUploads: props.resumableUploads,
        hideRetryButton: props.hideRetryButton,
        hidePauseResumeButton: props.hidePauseResumeButton,
        hideCancelButton: props.hideCancelButton,
        showLinkToFileUploadResult: props.showLinkToFileUploadResult,
        showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
        metaFields: props.metaFields,
        toggleFileCard: props.toggleFileCard,
        handleRequestThumbnail: props.handleRequestThumbnail,
        handleCancelThumbnail: props.handleCancelThumbnail,
        recoveredState: props.recoveredState,
        individualCancellation: props.individualCancellation,
        openFileEditor: props.openFileEditor,
        canEditFile: props.canEditFile,
        toggleAddFilesPanel: props.toggleAddFilesPanel,
        isSingleFile: isSingleFile,
        itemsPerRow: itemsPerRow,
        containerWidth: props.containerWidth,
        containerHeight: props.containerHeight
    }) : (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $3f3c0a16d9cbe8a2$export$2e2bcd8739ae039), {
        i18n: props.i18n,
        i18nArray: props.i18nArray,
        acquirers: props.acquirers,
        handleInputChange: props.handleInputChange,
        maxNumberOfFiles: props.maxNumberOfFiles,
        allowedFileTypes: props.allowedFileTypes,
        showNativePhotoCameraButton: props.showNativePhotoCameraButton,
        showNativeVideoCameraButton: props.showNativeVideoCameraButton,
        nativeCameraFacingMode: props.nativeCameraFacingMode,
        showPanel: props.showPanel,
        activePickerPanel: props.activePickerPanel,
        disableLocalFiles: props.disableLocalFiles,
        fileManagerSelectionType: props.fileManagerSelectionType,
        note: props.note,
        proudlyDisplayPoweredByUppy: props.proudlyDisplayPoweredByUppy
    }), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showAddFilesPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $175934b4bbc4fb46$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "AddFiles"
    }, props, {
        isSizeMD: isSizeMD
    })) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.fileCardFor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $af43f3a66035ecee$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "FileCard"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.activePickerPanel ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $e3578ca53f5728a8$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Picker"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $35cf1967ab48fc35$export$2e2bcd8739ae039), null, props.showFileEditor ? (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)((0, $d8360bbc75e6a373$export$2e2bcd8739ae039), $8dc96b7f61bbef1d$var$_extends({
        key: "Editor"
    }, props)) : null), (0, $4d2e93495e50cc85$export$c8a8987d4410bf2d)("div", {
        className: "uppy-Dashboard-progressindicators"
    }, props.progressindicators.map((target)=>{
        // TODO
        // Here we're telling typescript all `this.type = 'progressindicator'` plugins inherit from `UIPlugin`
        // This is factually true in Uppy right now, but maybe it doesn't have to be
        return props.uppy.getPlugin(target.id).render(props.state);
    })))));
    return dashboard;
}


var $c4158ae05dd76b13$export$2e2bcd8739ae039 = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: "Close Modal",
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: "Add more files",
        addingMoreFiles: "Adding more files",
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: "Import from %{name}",
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: "Uppy Dashboard",
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: "Link copied to clipboard.",
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: "Copy the URL below",
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: "Copy link",
        back: "Back",
        // Used as the screen reader label for buttons that remove a file.
        removeFile: "Remove file",
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: "Edit file",
        editImage: "Edit image",
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: "Editing %{file}",
        // Shown on the main upload screen when an upload error occurs
        error: "Error",
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: "Finish editing file",
        saveChanges: "Save changes",
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: "My Device",
        dropHint: "Drop your files here",
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: "Upload complete",
        uploadPaused: "Upload paused",
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Resume upload",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: "Pause upload",
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: "Retry upload",
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Cancel upload",
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: "%{smart_count} file selected",
            1: "%{smart_count} files selected"
        },
        uploadingXFiles: {
            0: "Uploading %{smart_count} file",
            1: "Uploading %{smart_count} files"
        },
        processingXFiles: {
            0: "Processing %{smart_count} file",
            1: "Processing %{smart_count} files"
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: "Powered by %{uppy}",
        addMore: "Add more",
        editFileWithFilename: "Edit file %{file}",
        save: "Save",
        cancel: "Cancel",
        dropPasteFiles: "Drop files here or %{browseFiles}",
        dropPasteFolders: "Drop files here or %{browseFolders}",
        dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
        dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
        dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
        dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
        importFiles: "Import files from:",
        browseFiles: "browse files",
        browseFolders: "browse folders",
        recoveredXFiles: {
            0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
            1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
        },
        recoveredAllFiles: "We restored all files. You can now resume the upload.",
        sessionRestored: "Session restored",
        reSelect: "Re-select",
        missingRequiredMetaFields: {
            0: "Missing required meta field: %{fields}.",
            1: "Missing required meta fields: %{fields}."
        },
        // Used for native device camera buttons on mobile
        takePictureBtn: "Take Picture",
        recordVideoBtn: "Record Video"
    }
};


function $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $b868dcf7a47332e3$var$id = 0;
function $b868dcf7a47332e3$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $b868dcf7a47332e3$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $b868dcf7a47332e3$var$packageJson = {
    "version": "4.1.2"
};
const $b868dcf7a47332e3$var$memoize = (0, $e66b69e563b626e6$export$2e2bcd8739ae039).default || (0, $e66b69e563b626e6$export$2e2bcd8739ae039);
const $b868dcf7a47332e3$var$TAB_KEY = 9;
const $b868dcf7a47332e3$var$ESC_KEY = 27;
function $b868dcf7a47332e3$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
const $b868dcf7a47332e3$var$defaultOptions = {
    target: "body",
    metaFields: [],
    thumbnailWidth: 280,
    thumbnailType: "image/jpeg",
    waitForThumbnailsBeforeUpload: false,
    defaultPickerIcon: $671181bcc8a0cf10$export$b9ab270927e310e4,
    showLinkToFileUploadResult: false,
    showProgressDetails: false,
    hideUploadButton: false,
    hideCancelButton: false,
    hideRetryButton: false,
    hidePauseResumeButton: false,
    hideProgressAfterFinish: false,
    note: null,
    singleFileFullScreen: true,
    disableStatusBar: false,
    disableInformer: false,
    disableThumbnailGenerator: false,
    fileManagerSelectionType: "files",
    proudlyDisplayPoweredByUppy: true,
    showSelectedFiles: true,
    showRemoveButtonAfterComplete: false,
    showNativePhotoCameraButton: false,
    showNativeVideoCameraButton: false,
    theme: "light",
    autoOpen: null,
    disabled: false,
    disableLocalFiles: false,
    nativeCameraFacingMode: "",
    onDragLeave: ()=>{},
    onDragOver: ()=>{},
    onDrop: ()=>{},
    plugins: [],
    // Dynamic default options, they have to be defined in the constructor (because
    // they require access to the `this` keyword), but we still want them to
    // appear in the default options so TS knows they'll be defined.
    doneButtonHandler: undefined,
    onRequestCloseModal: null,
    // defaultModalOptions
    inline: false,
    animateOpenClose: true,
    browserBackButtonClose: false,
    closeAfterFinish: false,
    closeModalOnClickOutside: false,
    disablePageScrollWhenModalOpen: true,
    trigger: null,
    // defaultInlineOptions
    width: 750,
    height: 550
};
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */ var $b868dcf7a47332e3$var$_disabledNodes = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("disabledNodes");
var $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("generateLargeThumbnailIfSingleFile");
var $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var $b868dcf7a47332e3$var$_attachRenderFunctionToTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var $b868dcf7a47332e3$var$_isTargetSupported = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("isTargetSupported");
var $b868dcf7a47332e3$var$_getAcquirers = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getAcquirers");
var $b868dcf7a47332e3$var$_getProgressIndicators = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getProgressIndicators");
var $b868dcf7a47332e3$var$_getEditors = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getEditors");
var $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSpecifiedPluginsFromOptions");
var $b868dcf7a47332e3$var$_autoDiscoverPlugins = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("autoDiscoverPlugins");
var $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("addSupportedPluginIfNoTarget");
var $b868dcf7a47332e3$var$_getStatusBarOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getStatusBarOpts");
var $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getThumbnailGeneratorOpts");
var $b868dcf7a47332e3$var$_getInformerOpts = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getInformerOpts");
var $b868dcf7a47332e3$var$_getStatusBarId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getStatusBarId");
var $b868dcf7a47332e3$var$_getThumbnailGeneratorId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getThumbnailGeneratorId");
var $b868dcf7a47332e3$var$_getInformerId = /*#__PURE__*/ $b868dcf7a47332e3$var$_classPrivateFieldLooseKey("getInformerId");
class $b868dcf7a47332e3$export$2e2bcd8739ae039 extends (0, $5d08dd66a9cc6899$export$2e2bcd8739ae039) {
    // Timeouts
    constructor(uppy, _opts){
        var _opts$autoOpen, _this$opts, _this$opts$onRequestC;
        const autoOpen = (_opts$autoOpen = _opts == null ? void 0 : _opts.autoOpen) != null ? _opts$autoOpen : null;
        super(uppy, {
            ...$b868dcf7a47332e3$var$defaultOptions,
            ..._opts,
            autoOpen: autoOpen
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getInformerId, {
            value: $b868dcf7a47332e3$var$_getInformerId2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId, {
            value: $b868dcf7a47332e3$var$_getThumbnailGeneratorId2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getStatusBarId, {
            value: $b868dcf7a47332e3$var$_getStatusBarId2
        });
        // eslint-disable-next-line class-methods-use-this
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getInformerOpts, {
            value: $b868dcf7a47332e3$var$_getInformerOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts, {
            value: $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getStatusBarOpts, {
            value: $b868dcf7a47332e3$var$_getStatusBarOpts2
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_disabledNodes, {
            writable: true,
            value: void 0
        });
        this.modalName = `uppy-Dashboard-${(0, $ee6f2436cceea22a$export$ac4959f4f1338dfc)()}`;
        this.superFocus = (0, $33dc1dd867a7b8b6$export$2e2bcd8739ae039)();
        this.ifFocusedOnUppyRecently = false;
        this.removeTarget = (plugin)=>{
            const pluginState = this.getPluginState();
            // filter out the one we want to remove
            const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
            this.setPluginState({
                targets: newTargets
            });
        };
        this.addTarget = (plugin)=>{
            const callerPluginId = plugin.id || plugin.constructor.name;
            const callerPluginName = plugin.title || callerPluginId;
            const callerPluginType = plugin.type;
            if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
                const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
                this.uppy.log(msg, "error");
                return null;
            }
            const target = {
                id: callerPluginId,
                name: callerPluginName,
                type: callerPluginType
            };
            const state = this.getPluginState();
            const newTargets = state.targets.slice();
            newTargets.push(target);
            this.setPluginState({
                targets: newTargets
            });
            return this.el;
        };
        this.hideAllPanels = ()=>{
            var _state$activePickerPa;
            const state = this.getPluginState();
            const update = {
                activePickerPanel: undefined,
                showAddFilesPanel: false,
                activeOverlayType: null,
                fileCardFor: null,
                showFileEditor: false
            };
            if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
            return;
            this.setPluginState(update);
            this.uppy.emit("dashboard:close-panel", (_state$activePickerPa = state.activePickerPanel) == null ? void 0 : _state$activePickerPa.id);
        };
        this.showPanel = (id)=>{
            const { targets: targets } = this.getPluginState();
            const activePickerPanel = targets.find((target)=>{
                return target.type === "acquirer" && target.id === id;
            });
            this.setPluginState({
                activePickerPanel: activePickerPanel,
                activeOverlayType: "PickerPanel"
            });
            this.uppy.emit("dashboard:show-panel", id);
        };
        this.canEditFile = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
        };
        this.openFileEditor = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            this.setPluginState({
                showFileEditor: true,
                fileCardFor: file.id || null,
                activeOverlayType: "FileEditor"
            });
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).selectFile(file);
            });
        };
        this.closeFileEditor = ()=>{
            const { metaFields: metaFields } = this.getPluginState();
            const isMetaEditorEnabled = metaFields && metaFields.length > 0;
            if (isMetaEditorEnabled) this.setPluginState({
                showFileEditor: false,
                activeOverlayType: "FileCard"
            });
            else this.setPluginState({
                showFileEditor: false,
                fileCardFor: null,
                activeOverlayType: "AddFiles"
            });
        };
        this.saveFileEditor = ()=>{
            const { targets: targets } = this.getPluginState();
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](targets);
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).save();
            });
            this.closeFileEditor();
        };
        this.openModal = ()=>{
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            // save scroll position
            this.savedScrollPosition = window.pageYOffset;
            // save active element, so we can restore focus when modal is closed
            this.savedActiveElement = document.activeElement;
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: false
                    });
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: false
                });
                resolve();
            }
            if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
            // handle ESC and TAB keys in modal dialog
            document.addEventListener("keydown", this.handleKeyDownInModal);
            this.uppy.emit("dashboard:modal-open");
            return promise;
        };
        this.closeModal = (opts)=>{
            var _opts$manualClose;
            // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
            const manualClose = (_opts$manualClose = opts == null ? void 0 : opts.manualClose) != null ? _opts$manualClose : true;
            const { isHidden: isHidden, isClosing: isClosing } = this.getPluginState();
            if (isHidden || isClosing) // short-circuit if animation is ongoing
            return undefined;
            const { promise: promise, resolve: resolve } = $b868dcf7a47332e3$var$createPromise();
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose) {
                this.setPluginState({
                    isClosing: true
                });
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: true,
                        isClosing: false
                    });
                    this.superFocus.cancel();
                    this.savedActiveElement.focus();
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: true
                });
                this.superFocus.cancel();
                this.savedActiveElement.focus();
                resolve();
            }
            // handle ESC and TAB keys in modal dialog
            document.removeEventListener("keydown", this.handleKeyDownInModal);
            if (manualClose) {
                if (this.opts.browserBackButtonClose) {
                    var _history$state;
                    // Make sure that the latest entry in the history state is our modal name
                    // eslint-disable-next-line no-restricted-globals
                    if ((_history$state = history.state) != null && _history$state[this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                    // eslint-disable-next-line no-restricted-globals
                    history.back();
                }
            }
            this.uppy.emit("dashboard:modal-closed");
            return promise;
        };
        this.isModalOpen = ()=>{
            return !this.getPluginState().isHidden || false;
        };
        this.requestCloseModal = ()=>{
            if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
            return this.closeModal();
        };
        this.setDarkModeCapability = (isDarkModeOn)=>{
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    darkMode: isDarkModeOn
                }
            });
        };
        this.handleSystemDarkModeChange = (event)=>{
            const isDarkModeOnNow = event.matches;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnNow);
        };
        this.toggleFileCard = (show, fileID)=>{
            const file = this.uppy.getFile(fileID);
            if (show) this.uppy.emit("dashboard:file-edit-start", file);
            else this.uppy.emit("dashboard:file-edit-complete", file);
            this.setPluginState({
                fileCardFor: show ? fileID : null,
                activeOverlayType: show ? "FileCard" : null
            });
        };
        this.toggleAddFilesPanel = (show)=>{
            this.setPluginState({
                showAddFilesPanel: show,
                activeOverlayType: show ? "AddFiles" : null
            });
        };
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || file.webkitRelativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        // ___Why make insides of Dashboard invisible until first ResizeObserver event is emitted?
        //    ResizeOberserver doesn't emit the first resize event fast enough, users can see the jump from one .uppy-size-- to
        //    another (e.g. in Safari)
        // ___Why not apply visibility property to .uppy-Dashboard-inner?
        //    Because ideally, acc to specs, ResizeObserver should see invisible elements as of width 0. So even though applying
        //    invisibility to .uppy-Dashboard-inner works now, it may not work in the future.
        this.startListeningToResize = ()=>{
            // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
            // and update containerWidth/containerHeight in plugin state accordingly.
            // Emits first event on initialization.
            this.resizeObserver = new ResizeObserver((entries)=>{
                const uppyDashboardInnerEl = entries[0];
                const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
                this.setPluginState({
                    containerWidth: width,
                    containerHeight: height,
                    areInsidesReadyToBeVisible: true
                });
            });
            this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner"));
            // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
            this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
                const pluginState = this.getPluginState();
                const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
                if (// We might want to enable this in the future
                // if ResizeObserver hasn't yet fired,
                !pluginState.areInsidesReadyToBeVisible && // and it's not due to the modal being closed
                !isModalAndClosed) {
                    this.uppy.log("[Dashboard] resize event didn\u2019t fire on time: defaulted to mobile layout", "warning");
                    this.setPluginState({
                        areInsidesReadyToBeVisible: true
                    });
                }
            }, 1000);
        };
        this.stopListeningToResize = ()=>{
            this.resizeObserver.disconnect();
            clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
        };
        // Records whether we have been interacting with uppy right now,
        // which is then used to determine whether state updates should trigger a refocusing.
        this.recordIfFocusedOnUppyRecently = (event)=>{
            if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
            else {
                this.ifFocusedOnUppyRecently = false;
                // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
                //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
                //    previously run superFocus sometimes hits and moves focus back to Uppy.
                this.superFocus.cancel();
            }
        };
        this.disableInteractiveElements = (disable)=>{
            var _classPrivateFieldLoo;
            const NODES_TO_DISABLE = [
                "a[href]",
                "input:not([disabled])",
                "select:not([disabled])",
                "textarea:not([disabled])",
                "button:not([disabled])",
                '[role="button"]:not([disabled])'
            ];
            const nodesToDisable = (_classPrivateFieldLoo = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes]) != null ? _classPrivateFieldLoo : (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(this.el.querySelectorAll(NODES_TO_DISABLE)).filter((node)=>!node.classList.contains("uppy-Dashboard-close"));
            for (const node of nodesToDisable)// Links can’t have `disabled` attr, so we use `aria-disabled` for a11y
            if (node.tagName === "A") node.setAttribute("aria-disabled", disable);
            else node.disabled = disable;
            if (disable) $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = nodesToDisable;
            else $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_disabledNodes)[$b868dcf7a47332e3$var$_disabledNodes] = null;
            this.dashboardIsDisabled = disable;
        };
        this.updateBrowserHistory = ()=>{
            var _history$state2;
            // Ensure history state does not already contain our modal name to avoid double-pushing
            // eslint-disable-next-line no-restricted-globals
            if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) // Push to history so that the page is not lost on browser back button press
            // eslint-disable-next-line no-restricted-globals
            history.pushState({
                // eslint-disable-next-line no-restricted-globals
                ...history.state,
                [this.modalName]: true
            }, "");
            // Listen for back button presses
            window.addEventListener("popstate", this.handlePopState, false);
        };
        this.handlePopState = (event)=>{
            var _event$state;
            // Close the modal if the history state no longer contains our modal name
            if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
                manualClose: false
            });
            // When the browser back button is pressed and uppy is now the latest entry
            // in the history but the modal is closed, fix the history by removing the
            // uppy history entry.
            // This occurs when another entry is added into the history state while the
            // modal is open, and then the modal gets manually closed.
            // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
            if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) // eslint-disable-next-line no-restricted-globals
            history.back();
        };
        this.handleKeyDownInModal = (event)=>{
            // close modal on esc key press
            if (event.keyCode === $b868dcf7a47332e3$var$ESC_KEY) this.requestCloseModal();
            // trap focus on tab key press
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$f41e0874aee57111(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handleClickOutside = ()=>{
            if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
        };
        this.handlePaste = (event)=>{
            // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootPaste == null || plugin.handleRootPaste(event);
            });
            // Add all dropped files
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.clipboardData.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files pasted");
                this.addFiles(files);
            }
        };
        this.handleInputChange = (event)=>{
            event.preventDefault();
            const files = (0, $d737086ca91a9c7d$export$2e2bcd8739ae039)(event.currentTarget.files || []);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files selected through input");
                this.addFiles(files);
            }
        };
        this.handleDragOver = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            // Check if some plugin can handle the datatransfer without files —
            // for instance, the Url plugin can import a url
            const canSomePluginHandleRootDrop = ()=>{
                let somePluginCanHandleRootDrop = true;
                this.uppy.iteratePlugins((plugin)=>{
                    if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) somePluginCanHandleRootDrop = true;
                });
                return somePluginCanHandleRootDrop;
            };
            // Check if the "type" of the datatransfer object includes files
            const doesEventHaveFiles = ()=>{
                const { types: types } = event.dataTransfer;
                return types.some((type)=>type === "Files");
            };
            // Deny drop, if no plugins can handle datatransfer, there are no files,
            // or when opts.disabled is set, or new uploads are not allowed
            const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop();
            const hasFiles = doesEventHaveFiles();
            if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled || // opts.disableLocalFiles should only be taken into account if no plugins
            // can handle the datatransfer
            this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
                event.dataTransfer.dropEffect = "none"; // eslint-disable-line no-param-reassign
                return;
            }
            // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the
            // browser, https://github.com/transloadit/uppy/issues/1978).
            event.dataTransfer.dropEffect = "copy"; // eslint-disable-line no-param-reassign
            this.setPluginState({
                isDraggingOver: true
            });
            this.opts.onDragOver(event);
        };
        this.handleDragLeave = (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.setPluginState({
                isDraggingOver: false
            });
            this.opts.onDragLeave(event);
        };
        this.handleDrop = async (event)=>{
            event.preventDefault();
            event.stopPropagation();
            this.setPluginState({
                isDraggingOver: false
            });
            // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            });
            // Add all dropped files
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, "error");
                // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, "error");
                    executedDropErrorOnce = true;
                }
            };
            this.uppy.log("[Dashboard] Processing dropped files");
            // Add all dropped files
            const files = await (0, $954bacbcaff60289$export$2e2bcd8739ae039)(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files dropped");
                this.addFiles(files);
            }
            this.opts.onDrop(event);
        };
        this.handleRequestThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:request", file);
        };
        /**
     * We cancel thumbnail requests when a file item component unmounts to avoid
     * clogging up the queue when the user scrolls past many elements.
     */ this.handleCancelThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:cancel", file);
        };
        this.handleKeyDownInInline = (event)=>{
            // Trap focus on tab key press.
            if (event.keyCode === $b868dcf7a47332e3$var$TAB_KEY) $f5d602e6112dba3d$export$66fd63158b65050a(event, this.getPluginState().activeOverlayType, this.el);
        };
        // ___Why do we listen to the 'paste' event on a document instead of onPaste={props.handlePaste} prop,
        //    or this.el.addEventListener('paste')?
        //    Because (at least) Chrome doesn't handle paste if focus is on some button, e.g. 'My Device'.
        //    => Therefore, the best option is to listen to all 'paste' events, and only react to them when we are focused on our
        //       particular Uppy instance.
        // ___Why do we still need onPaste={props.handlePaste} for the DashboardUi?
        //    Because if we click on the 'Drop files here' caption e.g., `document.activeElement` will be 'body'. Which means our
        //    standard determination of whether we're pasting into our Uppy instance won't work.
        //    => Therefore, we need a traditional onPaste={props.handlePaste} handler too.
        this.handlePasteOnBody = (event)=>{
            const isFocusInOverlay = this.el.contains(document.activeElement);
            if (isFocusInOverlay) this.handlePaste(event);
        };
        this.handleComplete = (_ref)=>{
            let { failed: failed } = _ref;
            if (this.opts.closeAfterFinish && !(failed != null && failed.length)) // All uploads are done
            this.requestCloseModal();
        };
        this.handleCancelRestore = ()=>{
            this.uppy.emit("restore-canceled");
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile, {
            writable: true,
            value: ()=>{
                if (this.opts.disableThumbnailGenerator) return;
                const LARGE_THUMBNAIL = 600;
                const files = this.uppy.getFiles();
                if (files.length === 1) {
                    const thumbnailGenerator = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                    thumbnailGenerator == null || thumbnailGenerator.setOptions({
                        thumbnailWidth: LARGE_THUMBNAIL
                    });
                    const fileForThumbnail = {
                        ...files[0],
                        preview: undefined
                    };
                    thumbnailGenerator == null || thumbnailGenerator.requestThumbnail(fileForThumbnail).then(()=>{
                        thumbnailGenerator == null || thumbnailGenerator.setOptions({
                            thumbnailWidth: this.opts.thumbnailWidth
                        });
                    });
                }
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded, {
            writable: true,
            value: (files)=>{
                const firstFile = files[0];
                const { metaFields: metaFields } = this.getPluginState();
                const isMetaEditorEnabled = metaFields && metaFields.length > 0;
                const isImageEditorEnabled = this.canEditFile(firstFile);
                if (isMetaEditorEnabled && this.opts.autoOpen === "metaEditor") this.toggleFileCard(true, firstFile.id);
                else if (isImageEditorEnabled && this.opts.autoOpen === "imageEditor") this.openFileEditor(firstFile);
            }
        });
        this.initEvents = ()=>{
            // Modal open button
            if (this.opts.trigger && !this.opts.inline) {
                const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
                if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener("click", this.openModal));
                else this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
            }
            this.startListeningToResize();
            document.addEventListener("paste", this.handlePasteOnBody);
            this.uppy.on("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.on("plugin-remove", this.removeTarget);
            this.uppy.on("file-added", this.hideAllPanels);
            this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.on("complete", this.handleComplete);
            this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.on("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            // ___Why fire on capture?
            //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
            document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
            document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
            if (this.opts.inline) this.el.addEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.on("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.removeEvents = ()=>{
            const showModalTrigger = (0, $3da4efa7f88c23a6$export$2e2bcd8739ae039)(this.opts.trigger);
            if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener("click", this.openModal));
            this.stopListeningToResize();
            document.removeEventListener("paste", this.handlePasteOnBody);
            window.removeEventListener("popstate", this.handlePopState, false);
            this.uppy.off("plugin-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            this.uppy.off("plugin-remove", this.removeTarget);
            this.uppy.off("file-added", this.hideAllPanels);
            this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.off("complete", this.handleComplete);
            this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            this.uppy.off("file-removed", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile)[$b868dcf7a47332e3$var$_generateLargeThumbnailIfSingleFile]);
            document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
            document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
            if (this.opts.inline) this.el.removeEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpen) this.uppy.off("files-added", $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded)[$b868dcf7a47332e3$var$_openFileEditorWhenFilesAdded]);
        };
        this.superFocusOnEachUpdate = ()=>{
            const isFocusInUppy = this.el.contains(document.activeElement);
            // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
            const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
            const isInformerHidden = this.uppy.getState().info.length === 0;
            const isModal = !this.opts.inline;
            if (// If update is connected to showing the Informer - let the screen reader calmly read it.
            isInformerHidden && // If we are in a modal - always superfocus without concern for other elements
            // on the page (user is unlikely to want to interact with the rest of the page)
            (isModal || // If we are already inside of Uppy, or
            isFocusInUppy || // If we are not focused on anything BUT we have already, at least once, focused on uppy
            //   1. We focus when isFocusNowhere, because when the element we were focused
            //      on disappears (e.g. an overlay), - focus gets lost. If user is typing
            //      something somewhere else on the page, - focus won't be 'nowhere'.
            //   2. We only focus when focus is nowhere AND this.ifFocusedOnUppyRecently,
            //      to avoid focus jumps if we do something else on the page.
            //   [Practical check] Without '&& this.ifFocusedOnUppyRecently', in Safari, in inline mode,
            //                     when file is uploading, - navigate via tab to the checkbox,
            //                     try to press space multiple times. Focus will jump to Uppy.
            isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
            else this.superFocus.cancel();
        };
        this.afterUpdate = ()=>{
            if (this.opts.disabled && !this.dashboardIsDisabled) {
                this.disableInteractiveElements(true);
                return;
            }
            if (!this.opts.disabled && this.dashboardIsDisabled) this.disableInteractiveElements(false);
            this.superFocusOnEachUpdate();
        };
        this.saveFileCard = (meta, fileID)=>{
            this.uppy.setFileMeta(fileID, meta);
            this.toggleFileCard(false, fileID);
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                return {
                    ...target,
                    icon: plugin.icon || this.opts.defaultPickerIcon,
                    render: plugin.render
                };
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_isTargetSupported, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
                if (typeof plugin.isSupported !== "function") return true;
                return plugin.isSupported();
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getAcquirers, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "acquirer" && $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_isTargetSupported)[$b868dcf7a47332e3$var$_isTargetSupported](target)).map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getProgressIndicators, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "progressindicator").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_getEditors, {
            writable: true,
            value: $b868dcf7a47332e3$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "editor").map($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_attachRenderFunctionToTarget)[$b868dcf7a47332e3$var$_attachRenderFunctionToTarget]);
            })
        });
        this.render = (state)=>{
            const pluginState = this.getPluginState();
            const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
            const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
            const acquirers = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getAcquirers)[$b868dcf7a47332e3$var$_getAcquirers](pluginState.targets);
            const progressindicators = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getProgressIndicators)[$b868dcf7a47332e3$var$_getProgressIndicators](pluginState.targets);
            const editors = $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getEditors)[$b868dcf7a47332e3$var$_getEditors](pluginState.targets);
            let theme;
            if (this.opts.theme === "auto") theme = capabilities.darkMode ? "dark" : "light";
            else theme = this.opts.theme;
            if ([
                "files",
                "folders",
                "both"
            ].indexOf(this.opts.fileManagerSelectionType) < 0) {
                this.opts.fileManagerSelectionType = "files";
                // eslint-disable-next-line no-console
                console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
            }
            return (0, $8dc96b7f61bbef1d$export$2e2bcd8739ae039)({
                state: state,
                isHidden: pluginState.isHidden,
                files: files,
                newFiles: newFiles,
                uploadStartedFiles: uploadStartedFiles,
                completeFiles: completeFiles,
                erroredFiles: erroredFiles,
                inProgressFiles: inProgressFiles,
                inProgressNotPausedFiles: inProgressNotPausedFiles,
                processingFiles: processingFiles,
                isUploadStarted: isUploadStarted,
                isAllComplete: isAllComplete,
                isAllPaused: isAllPaused,
                totalFileCount: Object.keys(files).length,
                totalProgress: state.totalProgress,
                allowNewUpload: allowNewUpload,
                acquirers: acquirers,
                theme: theme,
                disabled: this.opts.disabled,
                disableLocalFiles: this.opts.disableLocalFiles,
                direction: this.opts.direction,
                activePickerPanel: pluginState.activePickerPanel,
                showFileEditor: pluginState.showFileEditor,
                saveFileEditor: this.saveFileEditor,
                closeFileEditor: this.closeFileEditor,
                disableInteractiveElements: this.disableInteractiveElements,
                animateOpenClose: this.opts.animateOpenClose,
                isClosing: pluginState.isClosing,
                progressindicators: progressindicators,
                editors: editors,
                autoProceed: this.uppy.opts.autoProceed,
                id: this.id,
                closeModal: this.requestCloseModal,
                handleClickOutside: this.handleClickOutside,
                handleInputChange: this.handleInputChange,
                handlePaste: this.handlePaste,
                inline: this.opts.inline,
                showPanel: this.showPanel,
                hideAllPanels: this.hideAllPanels,
                i18n: this.i18n,
                i18nArray: this.i18nArray,
                uppy: this.uppy,
                note: this.opts.note,
                recoveredState: state.recoveredState,
                metaFields: pluginState.metaFields,
                resumableUploads: capabilities.resumableUploads || false,
                individualCancellation: capabilities.individualCancellation,
                isMobileDevice: capabilities.isMobileDevice,
                fileCardFor: pluginState.fileCardFor,
                toggleFileCard: this.toggleFileCard,
                toggleAddFilesPanel: this.toggleAddFilesPanel,
                showAddFilesPanel: pluginState.showAddFilesPanel,
                saveFileCard: this.saveFileCard,
                openFileEditor: this.openFileEditor,
                canEditFile: this.canEditFile,
                width: this.opts.width,
                height: this.opts.height,
                showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
                fileManagerSelectionType: this.opts.fileManagerSelectionType,
                proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
                hideCancelButton: this.opts.hideCancelButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
                containerWidth: pluginState.containerWidth,
                containerHeight: pluginState.containerHeight,
                areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
                parentElement: this.el,
                allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
                maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
                requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
                showSelectedFiles: this.opts.showSelectedFiles,
                showNativePhotoCameraButton: this.opts.showNativePhotoCameraButton,
                showNativeVideoCameraButton: this.opts.showNativeVideoCameraButton,
                nativeCameraFacingMode: this.opts.nativeCameraFacingMode,
                singleFileFullScreen: this.opts.singleFileFullScreen,
                handleCancelRestore: this.handleCancelRestore,
                handleRequestThumbnail: this.handleRequestThumbnail,
                handleCancelThumbnail: this.handleCancelThumbnail,
                // drag props
                isDraggingOver: pluginState.isDraggingOver,
                handleDragOver: this.handleDragOver,
                handleDragLeave: this.handleDragLeave,
                handleDrop: this.handleDrop
            });
        };
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions, {
            writable: true,
            value: ()=>{
                const { plugins: plugins } = this.opts;
                plugins.forEach((pluginID)=>{
                    const plugin = this.uppy.getPlugin(pluginID);
                    if (plugin) plugin.mount(this, plugin);
                    else this.uppy.log(`[Uppy] Dashboard could not find plugin '${pluginID}', make sure to uppy.use() the plugins you are specifying`, "warning");
                });
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins, {
            writable: true,
            value: ()=>{
                this.uppy.iteratePlugins($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget)[$b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget]);
            }
        });
        Object.defineProperty(this, $b868dcf7a47332e3$var$_addSupportedPluginIfNoTarget, {
            writable: true,
            value: (plugin)=>{
                var _plugin$opts;
                // Only these types belong on the Dashboard,
                // we wouldn’t want to try and mount Compressor or Tus, for example.
                const typesAllowed = [
                    "acquirer",
                    "editor"
                ];
                if (plugin && !((_plugin$opts = plugin.opts) != null && _plugin$opts.target) && typesAllowed.includes(plugin.type)) {
                    const pluginAlreadyAdded = this.getPluginState().targets.some((installedPlugin)=>plugin.id === installedPlugin.id);
                    if (!pluginAlreadyAdded) plugin.mount(this, plugin);
                }
            }
        });
        this.install = ()=>{
            // Set default state for Dashboard
            this.setPluginState({
                isHidden: true,
                fileCardFor: null,
                activeOverlayType: null,
                showAddFilesPanel: false,
                activePickerPanel: undefined,
                showFileEditor: false,
                metaFields: this.opts.metaFields,
                targets: [],
                // We'll make them visible once .containerWidth is determined
                areInsidesReadyToBeVisible: false,
                isDraggingOver: false
            });
            const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
            if (inline && closeAfterFinish) throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
            const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
            if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
            const { target: target } = this.opts;
            if (target) this.mount(target, this);
            if (!this.opts.disableStatusBar) this.uppy.use((0, $f22a72e7b80fdb1a$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarId)[$b868dcf7a47332e3$var$_getStatusBarId](),
                target: this,
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarOpts)[$b868dcf7a47332e3$var$_getStatusBarOpts]()
            });
            if (!this.opts.disableInformer) this.uppy.use((0, $2d1e3e0d76faae78$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getInformerId)[$b868dcf7a47332e3$var$_getInformerId](),
                target: this,
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getInformerOpts)[$b868dcf7a47332e3$var$_getInformerOpts]()
            });
            if (!this.opts.disableThumbnailGenerator) this.uppy.use((0, $f92c4ad36d89e394$export$2e2bcd8739ae039), {
                id: $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId)[$b868dcf7a47332e3$var$_getThumbnailGeneratorId](),
                ...$b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts)[$b868dcf7a47332e3$var$_getThumbnailGeneratorOpts]()
            });
            // Dark Mode / theme
            this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
            const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnFromTheStart);
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu;
                (_this$darkModeMediaQu = this.darkModeMediaQuery) == null || _this$darkModeMediaQu.addListener(this.handleSystemDarkModeChange);
            }
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions)[$b868dcf7a47332e3$var$_addSpecifiedPluginsFromOptions]();
            $b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_autoDiscoverPlugins)[$b868dcf7a47332e3$var$_autoDiscoverPlugins]();
            this.initEvents();
        };
        this.uninstall = ()=>{
            if (!this.opts.disableInformer) {
                const informer = this.uppy.getPlugin(`${this.id}:Informer`);
                // Checking if this plugin exists, in case it was removed by uppy-core
                // before the Dashboard was.
                if (informer) this.uppy.removePlugin(informer);
            }
            if (!this.opts.disableStatusBar) {
                const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
                if (statusBar) this.uppy.removePlugin(statusBar);
            }
            if (!this.opts.disableThumbnailGenerator) {
                const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                if (thumbnail) this.uppy.removePlugin(thumbnail);
            }
            const { plugins: plugins } = this.opts;
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.unmount();
            });
            if (this.opts.theme === "auto") {
                var _this$darkModeMediaQu2;
                (_this$darkModeMediaQu2 = this.darkModeMediaQuery) == null || _this$darkModeMediaQu2.removeListener(this.handleSystemDarkModeChange);
            }
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            this.unmount();
            this.removeEvents();
        };
        this.id = this.opts.id || "Dashboard";
        this.title = "Dashboard";
        this.type = "orchestrator";
        this.defaultLocale = (0, $c4158ae05dd76b13$export$2e2bcd8739ae039);
        // Dynamic default options:
        if (this.opts.doneButtonHandler === undefined) // `null` means "do not display a Done button", while `undefined` means
        // "I want the default behavior". For this reason, we need to differentiate `null` and `undefined`.
        this.opts.doneButtonHandler = ()=>{
            this.uppy.clear();
            this.requestCloseModal();
        };
        (_this$opts$onRequestC = (_this$opts = this.opts).onRequestCloseModal) != null ? _this$opts$onRequestC : _this$opts.onRequestCloseModal = ()=>this.closeModal();
        this.i18nInit();
    }
    setOptions(opts) {
        var _this$uppy$getPlugin, _this$uppy$getPlugin2;
        super.setOptions(opts);
        (_this$uppy$getPlugin = this.uppy.getPlugin($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarId)[$b868dcf7a47332e3$var$_getStatusBarId]())) == null || _this$uppy$getPlugin.setOptions($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getStatusBarOpts)[$b868dcf7a47332e3$var$_getStatusBarOpts]());
        (_this$uppy$getPlugin2 = this.uppy.getPlugin($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorId)[$b868dcf7a47332e3$var$_getThumbnailGeneratorId]())) == null || _this$uppy$getPlugin2.setOptions($b868dcf7a47332e3$var$_classPrivateFieldLooseBase(this, $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts)[$b868dcf7a47332e3$var$_getThumbnailGeneratorOpts]());
    }
}
function $b868dcf7a47332e3$var$_getStatusBarOpts2() {
    const { hideUploadButton: hideUploadButton, hideRetryButton: hideRetryButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, showProgressDetails: showProgressDetails, hideProgressAfterFinish: hideProgressAfterFinish, locale: l, doneButtonHandler: doneButtonHandler } = this.opts;
    return {
        hideUploadButton: hideUploadButton,
        hideRetryButton: hideRetryButton,
        hidePauseResumeButton: hidePauseResumeButton,
        hideCancelButton: hideCancelButton,
        showProgressDetails: showProgressDetails,
        hideAfterFinish: hideProgressAfterFinish,
        locale: l,
        doneButtonHandler: doneButtonHandler
    };
}
function $b868dcf7a47332e3$var$_getThumbnailGeneratorOpts2() {
    const { thumbnailWidth: thumbnailWidth, thumbnailHeight: thumbnailHeight, thumbnailType: thumbnailType, waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload } = this.opts;
    return {
        thumbnailWidth: thumbnailWidth,
        thumbnailHeight: thumbnailHeight,
        thumbnailType: thumbnailType,
        waitForThumbnailsBeforeUpload: waitForThumbnailsBeforeUpload,
        // If we don't block on thumbnails, we can lazily generate them
        lazy: !waitForThumbnailsBeforeUpload
    };
}
function $b868dcf7a47332e3$var$_getInformerOpts2() {
    return {
    };
}
function $b868dcf7a47332e3$var$_getStatusBarId2() {
    return `${this.id}:StatusBar`;
}
function $b868dcf7a47332e3$var$_getThumbnailGeneratorId2() {
    return `${this.id}:ThumbnailGenerator`;
}
function $b868dcf7a47332e3$var$_getInformerId2() {
    return `${this.id}:Informer`;
}
$b868dcf7a47332e3$export$2e2bcd8739ae039.VERSION = $b868dcf7a47332e3$var$packageJson.version;





function $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $c89f32c7d05a95a3$var$id = 0;
function $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $c89f32c7d05a95a3$var$id++ + "_" + e;
}
var $c89f32c7d05a95a3$var$_uppy = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("uppy");
var $c89f32c7d05a95a3$var$_events = /*#__PURE__*/ $c89f32c7d05a95a3$var$_classPrivateFieldLooseKey("events");
class $c89f32c7d05a95a3$export$2e2bcd8739ae039 {
    constructor(uppy){
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_uppy, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c89f32c7d05a95a3$var$_events, {
            writable: true,
            value: []
        });
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy] = uppy;
    }
    on(event, fn) {
        $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].push([
            event,
            fn
        ]);
        return $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].on(event, fn);
    }
    remove() {
        for (const [event, fn] of $c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_events)[$c89f32c7d05a95a3$var$_events].splice(0))$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].off(event, fn);
    }
    onFilePause(fileID, cb) {
        this.on("upload-pause", (file, isPaused)=>{
            if (fileID === (file == null ? void 0 : file.id)) cb(isPaused);
        });
    }
    onFileRemove(fileID, cb) {
        this.on("file-removed", (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onPause(fileID, cb) {
        this.on("upload-pause", (file, isPaused)=>{
            if (fileID === (file == null ? void 0 : file.id)) // const isPaused = this.#uppy.pauseResume(fileID)
            cb(isPaused);
        });
    }
    onRetry(fileID, cb) {
        this.on("upload-retry", (file)=>{
            if (fileID === (file == null ? void 0 : file.id)) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.on("retry-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onPauseAll(fileID, cb) {
        this.on("pause-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        var _this = this;
        this.on("cancel-all", function() {
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(_this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            eventHandler(...arguments);
        });
    }
    onResumeAll(fileID, cb) {
        this.on("resume-all", ()=>{
            if (!$c89f32c7d05a95a3$var$_classPrivateFieldLooseBase(this, $c89f32c7d05a95a3$var$_uppy)[$c89f32c7d05a95a3$var$_uppy].getFile(fileID)) return;
            cb();
        });
    }
}


function $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $6cb886e1a5aec334$var$id = 0;
function $6cb886e1a5aec334$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $6cb886e1a5aec334$var$id++ + "_" + e;
}
function $6cb886e1a5aec334$var$createCancelError(cause) {
    return new Error("Cancelled", {
        cause: cause
    });
}
function $6cb886e1a5aec334$var$abortOn(signal) {
    if (signal != null) {
        var _this$then;
        const abortPromise = ()=>this.abort(signal.reason);
        signal.addEventListener("abort", abortPromise, {
            once: true
        });
        const removeAbortListener = ()=>{
            signal.removeEventListener("abort", abortPromise);
        };
        (_this$then = this.then) == null || _this$then.call(this, removeAbortListener, removeAbortListener);
    }
    return this;
}
var $6cb886e1a5aec334$var$_activeRequests = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("activeRequests");
var $6cb886e1a5aec334$var$_queuedHandlers = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queuedHandlers");
var $6cb886e1a5aec334$var$_paused = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("paused");
var $6cb886e1a5aec334$var$_pauseTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("pauseTimer");
var $6cb886e1a5aec334$var$_downLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("downLimit");
var $6cb886e1a5aec334$var$_upperLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("upperLimit");
var $6cb886e1a5aec334$var$_rateLimitingTimer = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("rateLimitingTimer");
var $6cb886e1a5aec334$var$_call = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("call");
var $6cb886e1a5aec334$var$_queueNext = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queueNext");
var $6cb886e1a5aec334$var$_next = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("next");
var $6cb886e1a5aec334$var$_queue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("queue");
var $6cb886e1a5aec334$var$_dequeue = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("dequeue");
var $6cb886e1a5aec334$var$_resume = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("resume");
var $6cb886e1a5aec334$var$_increaseLimit = /*#__PURE__*/ $6cb886e1a5aec334$var$_classPrivateFieldLooseKey("increaseLimit");
class $6cb886e1a5aec334$export$32306e81289653bc {
    constructor(limit){
        Object.defineProperty(this, $6cb886e1a5aec334$var$_dequeue, {
            value: $6cb886e1a5aec334$var$_dequeue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queue, {
            value: $6cb886e1a5aec334$var$_queue2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_next, {
            value: $6cb886e1a5aec334$var$_next2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queueNext, {
            value: $6cb886e1a5aec334$var$_queueNext2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_call, {
            value: $6cb886e1a5aec334$var$_call2
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_activeRequests, {
            writable: true,
            value: 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_queuedHandlers, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_paused, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_pauseTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_downLimit, {
            writable: true,
            value: 1
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_upperLimit, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_rateLimitingTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_resume, {
            writable: true,
            value: ()=>this.resume()
        });
        Object.defineProperty(this, $6cb886e1a5aec334$var$_increaseLimit, {
            writable: true,
            value: ()=>{
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused]) {
                    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 0);
                    return;
                }
                $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = this.limit;
                this.limit = Math.ceil(($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] + $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]) / 2);
                for(let i = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit]; i <= this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
                if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] - $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] > 3) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], 2000);
                else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] = Math.floor($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit] / 2);
            }
        });
        if (typeof limit !== "number" || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    run(fn, queueOptions) {
        if (!$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] && $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] < this.limit) return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](fn);
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queue)[$6cb886e1a5aec334$var$_queue](fn, queueOptions);
    }
    wrapSyncFunction(fn, queueOptions) {
        var _this = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            const queuedRequest = _this.run(()=>{
                fn(...args);
                queueMicrotask(()=>queuedRequest.done());
                return ()=>{};
            }, queueOptions);
            return {
                abortOn: $6cb886e1a5aec334$var$abortOn,
                abort () {
                    queuedRequest.abort();
                }
            };
        };
    }
    wrapPromiseFunction(fn, queueOptions) {
        var _this2 = this;
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = _this2.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return (cause)=>{
                        cancelError = $6cb886e1a5aec334$var$createCancelError(cause);
                    };
                }, queueOptions);
            });
            outerPromise.abort = (cause)=>{
                queuedRequest.abort(cause);
            };
            outerPromise.abortOn = $6cb886e1a5aec334$var$abortOn;
            return outerPromise;
        };
    }
    resume() {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = false;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        for(let i = 0; i < this.limit; i++)$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
    }
    /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */ pause(duration) {
        if (duration === void 0) duration = null;
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] = true;
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer]);
        if (duration != null) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_pauseTimer)[$6cb886e1a5aec334$var$_pauseTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_resume)[$6cb886e1a5aec334$var$_resume], duration);
    }
    /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */ rateLimit(duration) {
        clearTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer]);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_upperLimit)[$6cb886e1a5aec334$var$_upperLimit] = this.limit - 1;
            this.limit = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_downLimit)[$6cb886e1a5aec334$var$_downLimit];
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_rateLimitingTimer)[$6cb886e1a5aec334$var$_rateLimitingTimer] = setTimeout($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_increaseLimit)[$6cb886e1a5aec334$var$_increaseLimit], duration);
        }
    }
    get isPaused() {
        return $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused];
    }
}
function $6cb886e1a5aec334$var$_call2(fn) {
    $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] += 1;
    let done = false;
    let cancelActive;
    try {
        cancelActive = fn();
    } catch (err) {
        $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
        throw err;
    }
    return {
        abort: (cause)=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            cancelActive == null || cancelActive(cause);
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        },
        done: ()=>{
            if (done) return;
            done = true;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] -= 1;
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queueNext)[$6cb886e1a5aec334$var$_queueNext]();
        }
    };
}
function $6cb886e1a5aec334$var$_queueNext2() {
    // Do it soon but not immediately, this allows clearing out the entire queue synchronously
    // one by one without continuously _advancing_ it (and starting new tasks before immediately
    // aborting them)
    queueMicrotask(()=>$6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_next)[$6cb886e1a5aec334$var$_next]());
}
function $6cb886e1a5aec334$var$_next2() {
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_paused)[$6cb886e1a5aec334$var$_paused] || $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_activeRequests)[$6cb886e1a5aec334$var$_activeRequests] >= this.limit) return;
    if ($6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].length === 0) return;
    // Dispatch the next request, and update the abort/done handlers
    // so that cancelling it does the Right Thing (and doesn't just try
    // to dequeue an already-running request).
    const next = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].shift();
    if (next == null) throw new Error("Invariant violation: next is null");
    const handler = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_call)[$6cb886e1a5aec334$var$_call](next.fn);
    next.abort = handler.abort;
    next.done = handler.done;
}
function $6cb886e1a5aec334$var$_queue2(fn, options) {
    const handler = {
        fn: fn,
        priority: (options == null ? void 0 : options.priority) || 0,
        abort: ()=>{
            $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_dequeue)[$6cb886e1a5aec334$var$_dequeue](handler);
        },
        done: ()=>{
            throw new Error("Cannot mark a queued request as done: this indicates a bug");
        }
    };
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].findIndex((other)=>{
        return handler.priority > other.priority;
    });
    if (index === -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].push(handler);
    else $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 0, handler);
    return handler;
}
function $6cb886e1a5aec334$var$_dequeue2(handler) {
    const index = $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].indexOf(handler);
    if (index !== -1) $6cb886e1a5aec334$var$_classPrivateFieldLooseBase(this, $6cb886e1a5aec334$var$_queuedHandlers)[$6cb886e1a5aec334$var$_queuedHandlers].splice(index, 1);
}
const $6cb886e1a5aec334$export$603eb9c93e04437 = Symbol("__queue");


class $0026c55df46f9934$var$NetworkError extends Error {
    constructor(error, xhr){
        if (xhr === void 0) xhr = null;
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
var $0026c55df46f9934$export$2e2bcd8739ae039 = $0026c55df46f9934$var$NetworkError;


function $404d4d8ff4ce3ae1$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
var $404d4d8ff4ce3ae1$export$2e2bcd8739ae039 = $404d4d8ff4ce3ae1$var$isNetworkError;



function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $c8d4b79cf5a3269c$var$id = 0;
function $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $c8d4b79cf5a3269c$var$id++ + "_" + e;
}
var $c8d4b79cf5a3269c$var$_aliveTimer = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("aliveTimer");
var $c8d4b79cf5a3269c$var$_isDone = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("isDone");
var $c8d4b79cf5a3269c$var$_onTimedOut = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("onTimedOut");
var $c8d4b79cf5a3269c$var$_timeout = /*#__PURE__*/ $c8d4b79cf5a3269c$var$_classPrivateFieldLooseKey("timeout");
/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $c8d4b79cf5a3269c$var$ProgressTimeout {
    constructor(timeout, // eslint-disable-next-line no-shadow
    timeoutHandler){
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_aliveTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_isDone, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_onTimedOut, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $c8d4b79cf5a3269c$var$_timeout, {
            writable: true,
            value: void 0
        });
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] = timeout;
        $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut] = ()=>timeoutHandler(timeout);
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) return;
        if ($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout] > 0) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = setTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_onTimedOut)[$c8d4b79cf5a3269c$var$_onTimedOut], $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_timeout)[$c8d4b79cf5a3269c$var$_timeout]);
        }
    }
    done() {
        if (!$c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone]) {
            clearTimeout($c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer]);
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_aliveTimer)[$c8d4b79cf5a3269c$var$_aliveTimer] = undefined;
            $c8d4b79cf5a3269c$var$_classPrivateFieldLooseBase(this, $c8d4b79cf5a3269c$var$_isDone)[$c8d4b79cf5a3269c$var$_isDone] = true;
        }
    }
}
var $c8d4b79cf5a3269c$export$2e2bcd8739ae039 = $c8d4b79cf5a3269c$var$ProgressTimeout;


const $e3981d1185f67d50$var$noop = ()=>{};
function $e3981d1185f67d50$export$47fdd40111eda34c(url, options) {
    if (options === void 0) options = {};
    const { body: body = null, headers: headers = {}, method: method = "GET", onBeforeRequest: onBeforeRequest = $e3981d1185f67d50$var$noop, onUploadProgress: onUploadProgress = $e3981d1185f67d50$var$noop, shouldRetry: shouldRetry = ()=>true, onAfterResponse: onAfterResponse = $e3981d1185f67d50$var$noop, onTimeout: onTimeout = $e3981d1185f67d50$var$noop, responseType: responseType, retries: retries = 3, signal: signal = null, timeout: timeout = 30000, withCredentials: withCredentials = false } = options;
    // 300 ms, 600 ms, 1200 ms, 2400 ms, 4800 ms
    const delay = (attempt)=>0.3 * 2 ** (attempt - 1) * 1000;
    const timer = new (0, $c8d4b79cf5a3269c$export$2e2bcd8739ae039)(timeout, onTimeout);
    function requestWithRetry(retryCount) {
        if (retryCount === void 0) retryCount = 0;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            const onError = (error)=>{
                if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(error);
                }
            };
            xhr.open(method, url, true);
            xhr.withCredentials = withCredentials;
            if (responseType) xhr.responseType = responseType;
            signal == null || signal.addEventListener("abort", ()=>{
                xhr.abort();
                // Using DOMException for abort errors aligns with
                // the convention established by the Fetch API.
                reject(new DOMException("Aborted", "AbortError"));
            });
            xhr.onload = async ()=>{
                try {
                    await onAfterResponse(xhr, retryCount);
                } catch (err) {
                    // This is important as we need to emit the xhr
                    // over the upload-error event.
                    err.request = xhr;
                    onError(err);
                    return;
                }
                if (xhr.status >= 200 && xhr.status < 300) {
                    timer.done();
                    resolve(xhr);
                } else if (shouldRetry(xhr) && retryCount < retries) setTimeout(()=>{
                    requestWithRetry(retryCount + 1).then(resolve, reject);
                }, delay(retryCount));
                else {
                    timer.done();
                    reject(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
                }
            };
            xhr.onerror = ()=>onError(new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(xhr.statusText, xhr));
            xhr.upload.onprogress = (event)=>{
                timer.progress();
                onUploadProgress(event);
            };
            if (headers) Object.keys(headers).forEach((key)=>{
                xhr.setRequestHeader(key, headers[key]);
            });
            await onBeforeRequest(xhr, retryCount);
            xhr.send(body);
        });
    }
    return requestWithRetry();
}


function $169d20dd56f976c7$export$3bd9b1601aad11ac(files) {
    const hasError = (file)=>"error" in file && !!file.error;
    return files.filter((file)=>!hasError(file));
}
function $169d20dd56f976c7$export$9e8ffa0bfbcfeed6(files) {
    return files.filter((file)=>{
        var _file$progress;
        return !((_file$progress = file.progress) != null && _file$progress.uploadStarted) || !file.isRestored;
    });
}


function $8e92129945053521$export$2e2bcd8739ae039(fields, meta) {
    if (fields === true) return Object.keys(meta);
    if (Array.isArray(fields)) return fields;
    return [];
}


var $3b2facc875d4722d$export$2e2bcd8739ae039 = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        uploadStalled: "Upload has not made any progress for %{seconds} seconds. You may want to retry it."
    }
};


function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(e, t) {
    if (!({}).hasOwnProperty.call(e, t)) throw new TypeError("attempted to use private field on non-instance");
    return e;
}
var $cf91058fd9d7f8ee$var$id = 0;
function $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey(e) {
    return "__private_" + $cf91058fd9d7f8ee$var$id++ + "_" + e;
}
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore We don't want TS to generate types for the package.json
const $cf91058fd9d7f8ee$var$packageJson = {
    "version": "4.3.3"
};
function $cf91058fd9d7f8ee$var$buildResponseError(xhr, err) {
    let error = err;
    // No error message
    if (!error) error = new Error("Upload error");
    // Got an error message string
    if (typeof error === "string") error = new Error(error);
    // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error("Upload error"), {
        data: error
    });
    if ((0, $404d4d8ff4ce3ae1$export$2e2bcd8739ae039)(xhr)) {
        error = new (0, $0026c55df46f9934$export$2e2bcd8739ae039)(error, xhr);
        return error;
    }
    // @ts-expect-error request can only be set on NetworkError
    // but we use NetworkError to distinguish between errors.
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 */ function $cf91058fd9d7f8ee$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
const $cf91058fd9d7f8ee$var$defaultOptions = {
    formData: true,
    fieldName: "file",
    method: "post",
    allowedMetaFields: true,
    bundle: false,
    headers: {},
    timeout: 30000,
    limit: 5,
    withCredentials: false,
    responseType: ""
};
var $cf91058fd9d7f8ee$var$_getFetcher = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getFetcher");
var $cf91058fd9d7f8ee$var$_uploadLocalFile = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadLocalFile");
var $cf91058fd9d7f8ee$var$_uploadBundle = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadBundle");
var $cf91058fd9d7f8ee$var$_getCompanionClientArgs = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("getCompanionClientArgs");
var $cf91058fd9d7f8ee$var$_uploadFiles = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("uploadFiles");
var $cf91058fd9d7f8ee$var$_handleUpload = /*#__PURE__*/ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseKey("handleUpload");
class $cf91058fd9d7f8ee$export$2e2bcd8739ae039 extends (0, $336df15d01030489$export$2e2bcd8739ae039) {
    constructor(uppy, _opts){
        super(uppy, {
            ...$cf91058fd9d7f8ee$var$defaultOptions,
            fieldName: _opts.bundle ? "files[]" : "file",
            ..._opts
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadFiles, {
            value: $cf91058fd9d7f8ee$var$_uploadFiles2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs, {
            value: $cf91058fd9d7f8ee$var$_getCompanionClientArgs2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadBundle, {
            value: $cf91058fd9d7f8ee$var$_uploadBundle2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_uploadLocalFile, {
            value: $cf91058fd9d7f8ee$var$_uploadLocalFile2
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_getFetcher, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $cf91058fd9d7f8ee$var$_handleUpload, {
            writable: true,
            value: async (fileIDs)=>{
                if (fileIDs.length === 0) {
                    this.uppy.log("[XHRUpload] No files to upload!");
                    return;
                }
                // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
                // (basically just AwsS3) using the internal symbol
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore untyped internal
                if (this.opts.limit === 0 && !this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437]) this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning");
                this.uppy.log("[XHRUpload] Uploading...");
                const files = this.uppy.getFilesByIds(fileIDs);
                const filesFiltered = (0, $169d20dd56f976c7$export$3bd9b1601aad11ac)(files);
                const filesToEmit = (0, $169d20dd56f976c7$export$9e8ffa0bfbcfeed6)(filesFiltered);
                this.uppy.emit("upload-start", filesToEmit);
                if (this.opts.bundle) {
                    // if bundle: true, we don’t support remote uploads
                    const isSomeFileRemote = filesFiltered.some((file)=>file.isRemote);
                    if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
                    if (typeof this.opts.headers === "function") throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
                    await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadBundle)[$cf91058fd9d7f8ee$var$_uploadBundle](filesFiltered);
                } else await $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadFiles)[$cf91058fd9d7f8ee$var$_uploadFiles](filesFiltered);
            }
        });
        this.type = "uploader";
        this.id = this.opts.id || "XHRUpload";
        this.defaultLocale = (0, $3b2facc875d4722d$export$2e2bcd8739ae039);
        this.i18nInit();
        // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ((0, $6cb886e1a5aec334$export$603eb9c93e04437) in this.opts) // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore untyped internal
        this.requests = this.opts[0, $6cb886e1a5aec334$export$603eb9c93e04437];
        else this.requests = new (0, $6cb886e1a5aec334$export$32306e81289653bc)(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
        if (this.opts.bundle && typeof this.opts.headers === "function") throw new Error("`opts.headers` can not be a function when the `bundle: true` option is set.");
        if ((_opts == null ? void 0 : _opts.allowedMetaFields) === undefined && "metaFields" in this.opts) throw new Error("The `metaFields` option has been renamed to `allowedMetaFields`.");
        this.uploaderEvents = Object.create(null);
        /**
     * xhr-upload wrapper for `fetcher` to handle user options
     * `validateStatus`, `getResponseError`, `getResponseData`
     * and to emit `upload-progress`, `upload-error`, and `upload-success` events.
     */ $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher] = (files)=>{
            return async (url, options)=>{
                try {
                    var _this$opts$getRespons, _this$opts2, _body3;
                    const res = await (0, $e3981d1185f67d50$export$47fdd40111eda34c)(url, {
                        ...options,
                        onBeforeRequest: (xhr, retryCount)=>{
                            var _this$opts$onBeforeRe, _this$opts;
                            return (_this$opts$onBeforeRe = (_this$opts = this.opts).onBeforeRequest) == null ? void 0 : _this$opts$onBeforeRe.call(_this$opts, xhr, retryCount, files);
                        },
                        shouldRetry: this.opts.shouldRetry,
                        onAfterResponse: this.opts.onAfterResponse,
                        onTimeout: (timeout)=>{
                            const seconds = Math.ceil(timeout / 1000);
                            const error = new Error(this.i18n("uploadStalled", {
                                seconds: seconds
                            }));
                            this.uppy.emit("upload-stalled", error, files);
                        },
                        onUploadProgress: (event)=>{
                            if (event.lengthComputable) for (const { id: id } of files){
                                var _file$progress$upload;
                                const file = this.uppy.getFile(id);
                                this.uppy.emit("upload-progress", file, {
                                    uploadStarted: (_file$progress$upload = file.progress.uploadStarted) != null ? _file$progress$upload : 0,
                                    bytesUploaded: event.loaded / event.total * file.size,
                                    bytesTotal: file.size
                                });
                            }
                        }
                    });
                    let body = await ((_this$opts$getRespons = (_this$opts2 = this.opts).getResponseData) == null ? void 0 : _this$opts$getRespons.call(_this$opts2, res));
                    if (res.responseType === "json") {
                        var _body;
                        (_body = body) != null ? _body : body = res.response;
                    } else try {
                        var _body2;
                        (_body2 = body) != null ? _body2 : body = JSON.parse(res.responseText);
                    } catch (cause) {
                        throw new Error("@uppy/xhr-upload expects a JSON response (with a `url` property). To parse non-JSON responses, use `getResponseData` to turn your response into JSON.", {
                            cause: cause
                        });
                    }
                    const uploadURL = typeof ((_body3 = body) == null ? void 0 : _body3.url) === "string" ? body.url : undefined;
                    for (const { id: id } of files)this.uppy.emit("upload-success", this.uppy.getFile(id), {
                        status: res.status,
                        body: body,
                        uploadURL: uploadURL
                    });
                    return res;
                } catch (error) {
                    if (error.name === "AbortError") return undefined;
                    const request = error.request;
                    for (const file of files)this.uppy.emit("upload-error", this.uppy.getFile(file.id), $cf91058fd9d7f8ee$var$buildResponseError(request, error), request);
                    throw error;
                }
            };
        };
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        };
        // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === "function") opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    // eslint-disable-next-line class-methods-use-this
    addMetadata(formData, meta, opts) {
        const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, meta);
        allowedMetaFields.forEach((item)=>{
            const value = meta[item];
            if (Array.isArray(value)) // In this case we don't transform `item` to add brackets, it's up to
            // the user to add the brackets so it won't be overridden.
            value.forEach((subItem)=>formData.append(item, subItem));
            else formData.append(item, value);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $cf91058fd9d7f8ee$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader($cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_handleUpload)[$cf91058fd9d7f8ee$var$_handleUpload]);
    }
}
async function $cf91058fd9d7f8ee$var$_uploadLocalFile2(file) {
    const events = new (0, $c89f32c7d05a95a3$export$2e2bcd8739ae039)(this.uppy);
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        const opts = this.getOptions(file);
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher]([
            file
        ]);
        const body = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
        return fetch(opts.endpoint, {
            ...opts,
            body: body,
            signal: controller.signal
        });
    });
    events.onFileRemove(file.id, ()=>controller.abort());
    events.onCancelAll(file.id, ()=>{
        controller.abort();
    });
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== "Cancelled") throw error;
    } finally{
        events.remove();
    }
}
async function $cf91058fd9d7f8ee$var$_uploadBundle2(files) {
    const controller = new AbortController();
    const uppyFetch = this.requests.wrapPromiseFunction(async ()=>{
        var _this$uppy$getState$x;
        const optsFromState = (_this$uppy$getState$x = this.uppy.getState().xhrUpload) != null ? _this$uppy$getState$x : {};
        const fetch = $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getFetcher)[$cf91058fd9d7f8ee$var$_getFetcher](files);
        const body = this.createBundledUpload(files, {
            ...this.opts,
            ...optsFromState
        });
        return fetch(this.opts.endpoint, {
            // headers can't be a function with bundle: true
            ...this.opts,
            body: body,
            signal: controller.signal
        });
    });
    function abort() {
        controller.abort();
    }
    // We only need to abort on cancel all because
    // individual cancellations are not possible with bundle: true
    this.uppy.once("cancel-all", abort);
    try {
        await uppyFetch().abortOn(controller.signal);
    } catch (error) {
        // TODO: create formal error with name 'AbortError' (this comes from RateLimitedQueue)
        if (error.message !== "Cancelled") throw error;
    } finally{
        this.uppy.off("cancel-all", abort);
    }
}
function $cf91058fd9d7f8ee$var$_getCompanionClientArgs2(file) {
    var _file$remote;
    const opts = this.getOptions(file);
    const allowedMetaFields = (0, $8e92129945053521$export$2e2bcd8739ae039)(opts.allowedMetaFields, file.meta);
    return {
        ...(_file$remote = file.remote) == null ? void 0 : _file$remote.body,
        protocol: "multipart",
        endpoint: opts.endpoint,
        size: file.data.size,
        fieldname: opts.fieldName,
        metadata: Object.fromEntries(allowedMetaFields.map((name)=>[
                name,
                file.meta[name]
            ])),
        httpMethod: opts.method,
        useFormData: opts.formData,
        headers: opts.headers
    };
}
async function $cf91058fd9d7f8ee$var$_uploadFiles2(files) {
    await Promise.allSettled(files.map((file)=>{
        if (file.isRemote) {
            const getQueue = ()=>this.requests;
            const controller = new AbortController();
            const removedHandler = (removedFile)=>{
                if (removedFile.id === file.id) controller.abort();
            };
            this.uppy.on("file-removed", removedHandler);
            const uploadPromise = this.uppy.getRequestClientForFile(file).uploadRemoteFile(file, $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_getCompanionClientArgs)[$cf91058fd9d7f8ee$var$_getCompanionClientArgs](file), {
                signal: controller.signal,
                getQueue: getQueue
            });
            this.requests.wrapSyncFunction(()=>{
                this.uppy.off("file-removed", removedHandler);
            }, {
                priority: -1
            })();
            return uploadPromise;
        }
        return $cf91058fd9d7f8ee$var$_classPrivateFieldLooseBase(this, $cf91058fd9d7f8ee$var$_uploadLocalFile)[$cf91058fd9d7f8ee$var$_uploadLocalFile](file);
    }));
}
// eslint-disable-next-line global-require
$cf91058fd9d7f8ee$export$2e2bcd8739ae039.VERSION = $cf91058fd9d7f8ee$var$packageJson.version;



var $eKpYu = parcelRequire("eKpYu");
var $4b20ab64ea1e0fd8$var$UploaderEvent;
(function(UploaderEvent) {
    UploaderEvent["uploadComplete"] = "uploadComplete";
    UploaderEvent["uploadFailed"] = "uploadFailed";
})($4b20ab64ea1e0fd8$var$UploaderEvent || ($4b20ab64ea1e0fd8$var$UploaderEvent = {}));
class $4b20ab64ea1e0fd8$var$Uploader {
    constructor(options){
        this.allowedTypes = "*/*";
        this.singleFile = false;
        this.eventNames = [
            "uploadComplete",
            "uploadFailed"
        ];
        this.can_upload_multiple_files = false;
        this.options = options;
        this.csrfToken = options.csrfToken;
        this.allowedTypes = options.allowedFileTypes;
        this.uppy = null;
        this.singleFile = options.singleFile;
        const allowedFileTypes1 = this.allowedTypes.split(",");
        const uppyOptions = {
            autoProceed: true,
            allowMultipleUploadBatches: false,
            restrictions: {
                allowedFileTypes: allowedFileTypes1,
                maxFileSize: (0, $eKpYu.default).MAX_UPLOAD_FILE_SIZE,
                maxNumberOfFiles: (0, $eKpYu.default).MAX_NUMBER_OF_BATCH_UPLOADS
            },
            onBeforeUpload: (files)=>{
                if (this.options.can_upload_multiple_files) return true;
                if (Object.keys(files).length > 1) {
                    eventRecorder.captureEvent("limit_hit", {
                        limit: "multiple_files_free_user",
                        files_count: Object.keys(files).length
                    });
                    alert("As a free user, you can only upload one file at a time.");
                    return false;
                }
                return true;
            }
        };
        if (this.singleFile) uppyOptions.restrictions && (uppyOptions.restrictions.maxNumberOfFiles = 1);
        this.uppy = new (0, $b16b91c7840d3bff$export$2e2bcd8739ae039)(uppyOptions)// @ts-ignore
        .use((0, $b868dcf7a47332e3$export$2e2bcd8739ae039), {
            id: "tool",
            inline: true,
            target: "#uppy-tool-dashboard",
            showProgressDetails: true,
            width: 384,
            height: "auto",
            singleFileFullScreen: true,
            disableInformer: true
        })// @ts-ignore
        .use((0, $cf91058fd9d7f8ee$export$2e2bcd8739ae039), {
            endpoint: (0, $eKpYu.default).UPLOAD_URL,
            headers: {
                "X-CSRFToken": this.csrfToken,
                mode: "same-origin"
            }
        }).on("file-added", (file)=>{
            this.uppy?.setFileMeta(file.id, {
                filename: file.name,
                content_type: file.type
            });
        }).on("upload-success", (file, response)=>{
            console.debug("Upload success: ", file, response);
            eventRecorder.captureEvent("upload_success", {
                file: file,
                response: response
            });
            this.uppy?.setFileMeta(file.id, {
                ng_id: response.body.id
            });
            this.uppy?.setFileMeta(file.id, {
                ng_short_id: response.body.short_id
            });
        }).on("complete", async (result)=>{
            console.log("Upload complete: ", result.successful, result.failed);
            // Check for out of space errors and redirect
            for (const f of result.failed){
                eventRecorder.captureEvent("upload_failed", {
                    error: f.response.status
                });
                if (f.response.status === 413) {
                    window.location.href = `/plans?tab=files-tab&upgrade_space=true`;
                    return;
                }
            }
            if (result.failed.length > 0) {
                let msg = "Upload failed: " + result.failed[0].error;
                if (result.successful.length > 0) msg += "\n Still proceeding with the successfully uploaded files.";
                alert(msg);
            }
            const short_ids = result.successful.map((f)=>f.meta.ng_short_id);
            eventRecorder.captureEvent("upload_complete");
            if (short_ids.length > 0) window.location.href = `/tools/${this.options.refname}/params?short_ids=${short_ids.join(",")}`;
        }).on("error", (error)=>{
            eventRecorder.captureEvent("upload_error", {
                error: error.detail.error
            });
            alert("Upload error: " + error.detail.error);
        }).on("restriction-failed", (file, error)=>{
            console.error("Restriction failed: ", file, error);
            const msg = error?.message?.toLowerCase() ?? "";
            const limitType = msg.includes("size") ? "max_file_size" : msg.includes("you can only upload") ? "max_number_of_files" : msg.includes("type") || msg.includes("only upload:") ? "file_type" : "unknown";
            eventRecorder.captureEvent("limit_hit", {
                limit: limitType,
                file_name: file?.name,
                file_size: file?.size,
                error_message: error?.message
            });
            alert(`${file.name}: ${error}`);
        });
    }
    alertOnMultipleFiles(files) {
        if (this.options.can_upload_multiple_files) return true;
        if (Object.keys(files).length > 1) {
            this.uppy?.info("As a free user, you can only upload one file at a time.");
            return false;
        }
        return true;
    }
    _dispatchEvent(eventName, detail) {
        document.dispatchEvent(new CustomEvent(eventName, {
            detail: detail
        }));
    }
    on(eventName, callback) {
        document.addEventListener(eventName, callback);
    }
    off(eventName, callback) {
        document.removeEventListener(eventName, callback);
    }
    off_all_events() {
        this.eventNames.forEach((eventName)=>{
            document.removeEventListener(eventName, ()=>{});
        });
    }
}
// Inputs here are delivered via global vars
// @ts-ignore
const $4b20ab64ea1e0fd8$var$uploader = new $4b20ab64ea1e0fd8$var$Uploader({
    csrfToken: csrf,
    allowedFileTypes: allowedFileTypes,
    singleFile: singleFile,
    refname: refname,
    can_upload_multiple_files: can_upload_multiple_files ? true : false
});
$4b20ab64ea1e0fd8$var$uploader.on($4b20ab64ea1e0fd8$var$UploaderEvent.uploadFailed, (e)=>{
    eventRecorder.captureEvent("upload_failed", {
        error: e.detail.error
    });
    alert("Upload failed: " + e.detail.error);
});

})();
//# sourceMappingURL=uploader.js.map
